// Luckysheet2.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Disclaimer, Checklist, updateData, formCompare, csrPolicyData2_3, baseUrl, staticSummaryReviewChecklistCSRData, Summary } from '../Services/Constants';
import { findTableForIndex, processAndUpdateToken, getText, findTblRowAllIndex, filterSelectedRowIndexForCopyPaste, CsrSaveHistoryApiCall, CsrPendingReport, autoupdate, brokerIdsGetData, qacTblRangeStructureFun } from '../Services/CommonFunctions';
import { DialogComponent, DiscrepancyOptionsDialogComponent, EndorsementDialogComponent, FilterCsrDialogComponent } from '../Services/dialogComponent';
import axios from "axios";
import { Icon } from '@fluentui/react';
import $ from 'jquery';
import { gradiationConverter } from '../Services/GradationDataConverter';
import { SimpleSnackbar } from '../Components/SnackBar';
import { UpdateJobPreviewStatus, UpdateJobSendPolicyInsured } from '../Services/PreviewChecklistDataService';
import { updateGridAuditLog } from '../Services/PreviewChecklistDataService';

export default function Luckysheet2(props) {
    const container = useRef();
    const sheetDataRowIndexRef = useRef({});
    const navigate = useNavigate();
    const [openDialog, setOpenDialog] = useState(false);
    const [msgText, setMsgText] = useState("");
    const luckysheet = window.luckysheet;
    const [yesDialog, setYesDialog] = useState(false);
    const [sheetState, setsheetState] = useState([]);
    const [loBResult, setLobResult] = useState([]);
    const [openFilterDialog, setOpenFilterDialog] = useState(false);
    const [filterSelectionData, setFilterSelectionData] = useState(null);
    const [csrPolicyData, setCsrPolicydata] = useState(props?.data);
    const [autoprogress, setautoprogress] = useState(false);
    const [jobId, setJobId] = useState(props?.selectedJob);
    const [issavessheet, setIssavessheet] = useState(false);
    const [dataForSavePolicy, setDataForSavePolicy] = useState([]); //AGN -- for update(previewchecklist)
    const [dataForSavePolicyPosition, setDataForSavePolicyPosition] = useState([]); //AGN -- for update(previewchecklist)
    const [dataForXRayMapping, setDataForXRayMapping] = useState([]); // for x-Ray Data(previewchecklist)
    const [formdataForXRayMapping, setFormDataForXRayMapping] = useState([]); // for x-Ray Data(formscompare)
    const [exclusiondataForXRayMapping, setExclusionDataForXRayMapping] = useState([]); // for x-Ray Data(exclusion)
    const [proposalexclusiondataForXRayMapping, setProposalExclusionDataForXRayMapping] = useState([]); // for x-Ray Data(proposalexclusion)
    const [dataForSaveFormsCompare, setDataForSaveFormsCompare] = useState([]); //-- for update(formsCompare)
    const [dataForSaveFormsComparePosition, setDataForSaveFormsComparePosition] = useState([]); //-- for update(formsCompare)
    const [dataForSaveExclusion, setDataForSaveExclusion] = useState([]); //-- for update(exclusion)
    const [dataForSaveExclusionPosition, setDataForSaveExclusionPosition] = useState([]); //-- for update(exclusion)
    const [dataForSaveProposalExclusion, setDataForSaveProposalExclusion] = useState([]); //-- for update(proposalexclusion)
    const [dataForSaveProposalExclusionPosition, setDataForSaveProposalExclusionPosition] = useState([]); //-- for update(proposalexclusion)
    const [summaryReviewChecklistData, setSummaryReviewChecklistData] = useState(props?.summaryReviewChecklistData || []);
    const [formsComparedata, setFormsComparedata] = useState(props.formCompareData);
    const [state, setState] = useState(props?.data);
    const [formstate, setFormState] = useState(props.formCompareData);
    const [exclusionstate, setExclusionState] = useState(props.exclusionRenderData);
    const [canRenderChecklist, setCanRenderChecklist] = useState(props?.data && Array.isArray(props?.data) && props?.data?.length > 0);
    const [canRenderFormData, setCanRenderFormData] = useState(props?.formCompareData && Array.isArray(props?.formCompareData) && props?.formCompareData?.length > 0);
    const [canRenderExclusionData, setCanRenderExclusionData] = useState(props?.exclusionRenderData && Array.isArray(props?.exclusionRenderData) && props.exclusionRenderData?.length > 0);
    const [proposalstate, setProposalState] = useState(props?.proposalRenderData);
    const [canRenderProposalData, setCanRenderProposalData] = useState(props?.proposalRenderData && Array.isArray(props?.proposalRenderData) && props?.proposalRenderData?.length > 0);
    useEffect(() => {
    const proposalData = props?.proposalRenderData;

    if (Array.isArray(proposalData) && proposalData.length > 0) {
        setProposalState(proposalData);
        setCanRenderProposalData(true);
    } else {
        setProposalState([]);
        setCanRenderProposalData(false);
    }
}, [props?.proposalRenderData]);
    const [canRenderGradation, setCanRenderGradation] = useState(props?.gradtionDataSet && Array.isArray(props?.gradtionDataSet) && props?.gradtionDataSet?.length > 0);
    const [canRenderQac, setCanRenderQac] = useState(props?.qacData);
    const [canRenderSummaryData, setCanRenderSummary] = useState(props?.summaryReviewChecklistData && Array.isArray(props?.summaryReviewChecklistData) && props?.summaryReviewChecklistData?.length > 0 ? props?.summaryReviewChecklistData : staticSummaryReviewChecklistCSRData);
    const [sheetDataRowIndex, setSheetDataRowIndex] = useState({});
    const [gradtionData, setGradtionData] = useState(props?.gradtionDataSet);
    const [dropDialog, setDropDialog] = useState(false);
    const [dropProposalExDialog, setDropProposalExDialog] = useState(false);
    const [gradiationDialog, setGradiationDialog] = useState(false);
    const [tableColumnDetails, setTableColumnDetails] = useState({ "Table 1": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 2": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 3": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 4": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 5": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 6": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 7": { "columnNames": {}, "range": { "start": "", "end": "" } } });
    const [formTableColumnDetails, setFormTableColumnDetails] = useState({ "FormTable 1": { "columnNames": {}, "range": { "start": "", "end": "" } }, "FormTable 2": { "columnNames": {}, "range": { "start": "", "end": "" } }, "FormTable 3": { "columnNames": {}, "range": { "start": "", "end": "" } } });
    const [exTableColumnDetails, setExTableColumnDetails] = useState({ "ExTable 1": { "columnNames": {}, "range": { "start": "", "end": "" } } });
    const [proposalexTableColumnDetails, setProposalExTableColumnDetails] = useState({ "ProposalExTable 1": { "columnNames": {}, "range": { "start": "", "end": "" } } });
    const [qacTableColumnDetails, setQacTableColumnDetails] = useState({});
    const [summaryTableColumnDetails, setSummaryTableColumnDetails] = useState({ "Table 1": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 2": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 3": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 4": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 5": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 6": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 7": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 8": { "columnNames": {}, "range": { "start": "", "end": "" } } });
    let token = sessionStorage.getItem('token');
    const brokerId = jobId.slice(0, 4);
    const [ msgVisible, setMsgVisible ] = useState( false );
    const [ msgClass, setMsgClass ] = useState( '' );
    const AODDBrokerIds = ["1003", "1150", "1165", "1167", "1005", "1132"];    //broker config for formsCmp & exclusion broker to be shown;
    const reqEndorsementColHideBrokerId = ["1162"];
    const consolidatedXrayBrokerIds = ["1150"];
    const renderBrokerIdsQac = ["1162"];
    const renderBrokerIdsSummary = ["1003", "1150", "1005"];
    const [endorsementColflag, setEndorsementColflag] = useState("");
    const [brokerData, setBrokerData] = useState([]);
    const [reviewData, setReviewData] = useState([]);
    const [sendPolicyInsuredData, setSendPolicyInsuredData] = useState([]);
    const [csrProXray, setCsrProXray] = useState({});
    sessionStorage.removeItem('removedArrays');//for icon grouping dont remove 
    sessionStorage.removeItem('hitedselectedValues');//for icon grouping dont remove
    sessionStorage.removeItem('IconShownIndex');//for icon grouping dont remove
    const [userName, setUserName] = useState("");
    const sessionUserName = sessionStorage.getItem("csrAuthUserName") || sessionStorage.getItem("userName");
    const [activeUserName, SetActiveUserName] = useState(props?.defaultSheetUserNameData);
    const value = 9;
    const header = 9;
    const possibleColumns = [3, 4, 5, 6, 7];
    const gradiation_possibleColumns = [2, 3, 4, 5];
    const nonRenderBrokerIdsPolicyCheck = [];
    const isSelectedEnabled = brokerId === "1162";
    const docCol = ["Current Term Policy", "Prior Term Policy", "Binder", "Proposal", "Quote", "Application", "Schedule"];
    
    if (["1176hmo20251104103802739", "1176pau20251104103913108", "1176cgl20251104104158055"]?.includes(props?.selectedJob?.toLowerCase())) {
        renderBrokerIdsSummary.push("1176");
        nonRenderBrokerIdsPolicyCheck.push("1176");

    }

    if (props?.isCsrProOnly) {
        renderBrokerIdsSummary.push(brokerId);
    }

    // For Production
    const addOnEnabledBrokers = ["1005", "1132"];
    // const addOnEnabledBrokers = ["1003"]; // for Staging
    const FormsCompareSheetName = brokerId && addOnEnabledBrokers?.includes(brokerId) ? "“Add On” Forms Compare" : "Forms Compare";
    const ExclusionSheetName = brokerId && addOnEnabledBrokers?.includes(brokerId) ? "“Add On” Exclusion" : "Exclusions";

    if (props?.isCsrProOnly) {
        renderBrokerIdsSummary.push(brokerId);
    }

    const summaryReviewChecklistDatafigdata = {
        summaryReviewChecklist: {
            name: "CSR Pro",
            config: {
                merge: {
                    "0_1": {
                        "rs": 1,
                        "cs": 7,
                        "r": 0,
                        "c": 1
                    },
                    "1_1": {
                        "rs": 1,
                        "cs": 1,
                        "r": 0,
                        "c": 1
                    },
                },
                borderInfo: [],
                columnlen: {
                    "0": 50,
                    "1": 305,
                    "2": 300,
                    "3": 100,
                    "4": 200,
                    "5": 200,
                    "6": 200,
                    "7": 200,
                    "8": 200,
                    "9": 200,
                    "10": 50,
                    "11": 50,
                    "12": 60,
                    "13": 50,
                    "14": 20,
                    "15": 20,
                },
                rowlen: {},
                "curentsheetView": "viewPage",
                "sheetViewZoom": {
                    "viewNormalZoomScale": 0.6,
                    "viewPageZoomScale": 0.6,
                },
            },
            status: "1",
            column: 50,
            row: 500,
            celldata: [],
            ch_width: 2322,
            rh_height: 949,
            scrollLeft: 0,
            scrollTop: 0,
            luckysheet_select_save: [],
            calcChain: [],
            isPivotTable: false,
            pivotTable: {},
            luckysheet_alternateformat_save: [],
            luckysheet_alternateformat_save_modelCustom: [],
            sheets: [],
        },
    };
    const Policy_appDataConfig = {
        demo: {
            name: "Summary Checklist",
            color: "",
            config: {
                merge: {
                    "0_1": {
                        "rs": 1,
                        "cs": 6,
                        "r": 0,
                        "c": 1
                    },
                    "1_1": {
                        "rs": 1,
                        "cs": 2,
                        "r": 0,
                        "c": 1
                    },
                },
                borderInfo: [],
                rowlen: {
                    "0": 20,
                    "1": 20,
                    "2": 20,
                    "3": 35,
                    "4": 50,
                    "5": 35,
                    "6": 35,
                    "7": 35,
                    "8": 35,
                    "9": 35,
                    "10": 50,
                    "11": 50,
                    "12": 60,
                    "13": 20,
                    "14": 20,
                    "15": 20,
                    "16": 20,
                    "17": 31
                },
                columnlen: {
                    "0": 63,
                    "1": 280,
                    "2": 250,
                    "3": 250,
                    "4": 250,
                    "5": 250,
                    "6": 250,
                    "7": 250,
                    "8": 250,
                    "9": 250,
                    "10": 250,
                    "11": 250,
                    "12": 250,
                    "13": 250,
                    "14": 250
                },
                "curentsheetView": "viewPage",
                "sheetViewZoom": {
                    "viewNormalZoomScale": 0.6,
                    "viewPageZoomScale": 0.6,
                },
            },

            chart: [],
            status: "1",
            order: "0",
            hide: 0,
            column: 20,
            celldata: [],
            ch_width: 2322,
            rh_height: 949,
            scrollLeft: 0,
            scrollTop: 0,
            luckysheet_select_save: [],
            calcChain: [],
            luckysheet_alternateformat_save: [],
            luckysheet_alternateformat_save_modelCustom: [],
            sheets: []
        }
    };
    const FormCompare_appconfigdata = {
        forms: {
            name: FormsCompareSheetName,
            color: "",
            config: {
                merge: {
                    "1_1": {
                        "rs": 1,
                        "cs": 2,
                        "r": 0,
                        "c": 1
                    },
                },
                borderInfo: [],
                rowlen: {
                    "3": 20,
                    "4": 20,
                    "5": 35,
                    "6": 35,
                    "7": 35,
                    "8": 35,
                    "9": 35,
                    "10": 50,
                    "11": 50,
                    "12": 20,
                    "13": 20,
                    "14": 20,
                    "15": 20,
                    "16": 20,
                    "17": 31
                },
                columnlen: {
                    "0": 62,
                    "1": 250,
                    "2": 250,
                    "3": 250,
                    "4": 250,
                    "5": 250,
                    "6": 250,
                    "7": 250,
                    "8": 250,
                    "9": 250,
                    "10": 250,
                    "11": 250,
                    "12": 250,
                    "13": 250,
                    "14": 250
                },
                "curentsheetView": "viewPage",
                "sheetViewZoom": {
                    "viewNormalZoomScale": 0.6,
                    "viewPageZoomScale": 0.6,
                },
            },

            chart: [],
            order: "0",
            hide: 0,
            column: 20,
            celldata: [],
            ch_width: 2322,
            rh_height: 949,
            scrollLeft: 0,
            scrollTop: 0,
            luckysheet_select_save: [],
            calcChain: [],
            luckysheet_alternateformat_save: [],
            luckysheet_alternateformat_save_modelCustom: [],
            sheets: [],
        },
    };
    const Exclusion_appDataConfig = {
        exclusions: {
            name: ExclusionSheetName,
            config: {
                merge: {},
                borderInfo: [],
                columnlen: {
                    "0": 230,
                    "1": 230,
                    "2": 230,
                    "3": 230,
                    "4": 230,
                    "5": 230,
                    "6": 230,
                    "7": 230,
                    "8": 230,
                    "9": 230,
                },
                rowlen: {},
                "curentsheetView": "viewPage",
                "sheetViewZoom": {
                    "viewNormalZoomScale": 0.6,
                    "viewPageZoomScale": 0.6,
                },
            },
            status: "1",
            column: 20,
            row: 500,
            row: 500,
            celldata: [],
            ch_width: 2322,
            rh_height: 949,
            scrollLeft: 0,
            scrollTop: 0,
            luckysheet_select_save: [],
            calcChain: [],
            luckysheet_alternateformat_save: [],
            luckysheet_alternateformat_save_modelCustom: [],
            sheets: [],
        },
    };
    const Proposal_appDataConfig = {
    proposal: {
        name: "ProposalExclusions",
        config: {
            merge: {},
            borderInfo: [],

            columnlen: {
                "0": 230,
                "1": 230,
                "2": 230,
                "3": 230,
                "4": 230,
                "5": 230,
                "6": 230,
                "7": 230,
                "8": 230,
                "9": 230,
                "10": 230,
                "11": 230,
            },

            rowlen: {},

            "curentsheetView": "viewPage",

            "sheetViewZoom": {
                "viewNormalZoomScale": 0.6,
                "viewPageZoomScale": 0.6
            }
        },

        status: "1",
        column: 20,
        row: 500,
        celldata: [],
        ch_width: 2322,
        rh_height: 949,
        scrollLeft: 0,
        scrollTop: 0,
        luckysheet_select_save: [],
        calcChain: [],
        luckysheet_alternateformat_save: [],
        luckysheet_alternateformat_save_modelCustom: [],
        sheets: []
    }
};
    const qac_appDataConfig = {
        name: "QA Checklist",
        color: "",
        config: {
            merge: {
            },
            borderInfo: [],
            rowlen: {
            },
            columnlen: {
                "0": 550,
                "1": 300,
                "2": 300
            },
            "curentsheetView": "viewPage",
            "sheetViewZoom": {
                "viewNormalZoomScale": 0.6,
                "viewPageZoomScale": 0.6,
            },
        },
        chart: [],
        status: "0",
        order: "0",
        hide: 0,
        column: 50,
        row: 50,
        celldata: [],
        ch_width: 2322,
        rh_height: 949,
        scrollLeft: 0,
        scrollTop: 0,
        luckysheet_select_save: [],
        calcChain: [],
        isPivotTable: false,
        pivotTable: {},
        filter_select: null,
        filter: null,
        luckysheet_alternateformat_save: [],
        luckysheet_alternateformat_save_modelCustom: [],
        sheets: []
    };

    const luckyCss = {
        margin: '0px',
        padding: '0px',
        position: 'absolute',
        width: '100% !important',
        height: '50%',
        left: '0px',
        top: '0px',
    };

    const handleVisibilityChange = () => {
        if (luckysheet) {
            luckysheet?.refresh();
            luckysheet?.exitEditMode();
        }
    }

    const loadBrokerData = async () => {
        try {
            let brokerData = await brokerIdsGetData();
            sessionStorage.setItem('brokerDatas', JSON.stringify(brokerData))
            setBrokerData(brokerData);
        } catch (error) {
            console.error('Error fetching dat:', error);
        }
    };


    useEffect(() => {
        const mainData = state;
        const formCompareData = formstate;
        const exclusionData = exclusionstate;
        setUserName(sessionStorage.getItem("csrAuthUserName") || sessionStorage.getItem("userName"));

        document.addEventListener('visibilitychange', handleVisibilityChange, false);

        try {
            getCsrReviewData(jobId);
            // getSummaryReviewChecklistData(jobId);
        } catch (error) {
            console.log(error);
        }

        loadBrokerData();
        const renderTextBlock = () => {
            const textBlock = [
                {
                    ct: {
                        fa: "General",
                        t: "g"
                    },
                    fc: "#ff0000",
                    ff: "\"Tahoma\"",
                    m: Disclaimer,
                    v: Disclaimer,
                },
            ];

            return textBlock;
        };

        const renderList = () => {
            const listBlock = [
                {
                    ct: {
                        fa: "General",
                        t: "g"
                    },
                    fc: "#000000",
                    ff: "\"Tahoma\"",
                    m: Checklist,
                    v: Checklist,
                },
            ];

            return listBlock;
        };

        const renderForm = () => {
            const formBlock = [
                {
                    ct: {
                        fa: "General",
                        t: "g"
                    },
                    fc: "#000000",
                    ff: "\"Tahoma\"",
                    m: formCompare,
                    v: formCompare,
                },
            ];

            return formBlock;
        };

        const renderSummary = () => {
            const summaryBlock = [
                {
                    ct: {
                        fa: "General",
                        t: "g"
                    },
                    fc: "#000000",
                    ff: "\"Tahoma\"",
                    m: Summary,
                    v: Summary,
                },
            ];

            return summaryBlock;
        };

        const summaryReviewChecklistTable = () => {
            let data = props?.summaryReviewChecklistData || staticSummaryReviewChecklistCSRData;

            if(brokerId === "1150") {
                if (!csrPolicyData || !data ) {
                    return;
                }
                if (data?.IsLobSplitJob) {
                    return;
                }
                const table3 = csrPolicyData?.find(e => e?.Tablename === "Table 3");
                if (!table3?.TemplateData) {
                    return;
                }
            
                const parseObj = typeof table3?.TemplateData === "string" ? JSON?.parse(table3?.TemplateData) : table3?.TemplateData;
                const as1Source = parseObj?.find(item => item["Checklist Questions"] === "AS1");
            
                if (!as1Source) {
                    console.log("AS1 not found in csrChecklistData");
                    return;
                }
                const matchedDoc = docCol?.find( doc => as1Source?.[doc] !== null && as1Source?.[doc] !== undefined && as1Source?.[doc] !== "" );
                if (!matchedDoc) {
                    return;
                }
            
                const newStatus = as1Source[matchedDoc];
                data = {
                    ...data,
                    JobCoverage: data?.JobCoverage?.map(item => {
                        if (item?.ChecklistQuestions !== "AS1") {
                            return item;
                        }
    
                        return {
                            ...item,
                            Status: newStatus,
                            DocumentViewer: ""
                        };
                    })
                };
            }

            const Table1Job_Header = data?.JobHeader?.filter(f => ['Named Insured', 'Term', 'LOB']?.includes(f?.Headers))
            const Table8Job_Header = data?.JobHeader?.filter(f => !['Named Insured', 'Term', 'LOB']?.includes(f?.Headers))

            const apiSummaryData = [
                {
                    "Tablename": "Table 1",
                    "TemplateData": Table1Job_Header
                },
                {
                    "Tablename": "Table 2",
                    "TemplateData": data?.JobCommonDeclaration
                },
                {
                    "Tablename": "Table 3",
                    "TemplateData": data?.JobCoverage
                },
                {
                    "Tablename": "Table 4",
                    "TemplateData": data?.JobForm1
                },
                {
                    "Tablename": "Table 5",
                    "TemplateData": data?.JobForm2
                },
                {
                    "Tablename": "Table 6",
                    "TemplateData": data?.JobForm3
                },
                {
                    "Tablename": "Table 7",
                    "TemplateData": data?.JobForm4
                },
                {
                    "Tablename": "Table lst",
                    "TemplateData": Table8Job_Header
                }
            ];
            sessionStorage.setItem('summarryData', JSON.stringify(apiSummaryData))

            const templateData = apiSummaryData?.filter(array => array?.TemplateData?.length !== 0);
            const inputData = templateData;

            const renderSummaryJobHeader = () => {
                const tableData1Summary = inputData?.find((data) => data.Tablename === "Table 1");
                if (tableData1Summary) {
                    const table1json = tableData1Summary?.TemplateData;
                    const lob = table1json[0]?.PolicyLob;
                    sessionStorage.setItem("lob", JSON.stringify(lob))

                    let sheetDataTable1 = [];
                    let sheetDataTable2 = [];
                    const dummyData = [];

                    const rowIndexOfTable1 = 4
                    const textBlockData = renderTextBlock();
                    const listData = renderSummary();

                    textBlockData.forEach((item, index) => {
                        const mergeConfig = summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.merge["0_1"];

                        sheetDataTable2.push({
                            r: index + mergeConfig.r,
                            c: mergeConfig.c,
                            v: {
                                ct: item.ct,
                                m: item.m,
                                v: item.v,
                                bl: 1,
                                ff: item.ff,
                                fs: 9,
                                merge: mergeConfig,
                                fc: item.fc,
                            }
                        });
                    });

                    listData.forEach((item, index) => {
                        const mergeConfig = summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.merge["1_1"];

                        sheetDataTable2.push({
                            r: 1 + mergeConfig.r,
                            c: mergeConfig.c,
                            v: {
                                ct: item.ct,
                                m: item.m,
                                v: item.v,
                                ff: item.ff,
                                fs: 13,
                                merge: mergeConfig,
                                fc: item.fc,
                            }
                        });
                    });

                    table1json?.map((item, index) => {
                        if (item["Headers"] != null && item["Headers"] != undefined) {
                            if (item["Headers"] == "") {
                                sheetDataTable1.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 1,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr", s: [{ v: " " }] },
                                        m: " ",
                                        v: " ",
                                        merge: null,
                                        bg: "rgb(139,173,212)",
                                        tb: '2',
                                    }
                                });
                            } else {
                                sheetDataTable1.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 1,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr", s: [{ v: item["Headers"], ff: "Tahoma", fs: 9 }] },
                                        m: item["Headers"],
                                        v: item["Headers"],
                                        ff: "Tahoma",
                                        merge: null,
                                        bg: "rgb(139,173,212)",
                                        tb: '2',
                                    }
                                });
                            }

                            const tidleValue = item["Value"] !== null && item["Value"] != undefined ? item["Value"].replace(/~~/g, "\n") : "";

                            if (item['Headers']?.toLowerCase() === 'exdion csrdigit'.toLowerCase()) {
                                sheetDataTable1.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 2,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr" },
                                        m: tidleValue,
                                        v: tidleValue,
                                        fs: 9,
                                        un: 1,
                                        fc: "#0b5394",
                                        ff: "\"Tahoma\"",
                                        merge: null,
                                        tb: '2',
                                    }
                                });
                            } else {
                                sheetDataTable1.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 2,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr" },
                                        m: tidleValue,
                                        v: tidleValue,
                                        fs: 9,
                                        ff: "Tahoma",
                                        merge: null,
                                        tb: '2',
                                    }
                                });
                            }

                            let maxLength = 0;
                            const lengths = [];
                            Object.keys(item).forEach((key) => {
                                if (item[key]) {
                                    lengths.push(item[key].length);
                                }
                            });
                            lengths.forEach((length) => {
                                if (length > maxLength) {
                                    maxLength = length;
                                }
                            });
                            const rowHeight = parseInt(maxLength / 3 + 15);
                            summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.rowlen[`${rowIndexOfTable1 + index}`] = rowHeight;
                        }
                    });

                    const matchedUnMatchedFilter = [
                        {
                            "r": 4,
                            "c": 4,
                            "v": {
                                "ct": {
                                    "fa": "General",
                                    "t": "inlineStr",
                                    "s": [
                                        {
                                            "fs": "16",
                                            "v": "□ "
                                        },
                                        {
                                            "vt": "0",
                                            "ht": "1",
                                            "fs": "9",
                                            "un": 0,
                                            "bl": 1,
                                            "fc": "#0000ff",
                                            "ff": "\"Tahoma\"",
                                            "m": brokerId === "1167" ? "Full Variances" : "All Variances",
                                            "v": brokerId === "1167" ? "Full Variances" : "All Variances",
                                        }
                                    ]
                                },
                                "merge": null,
                                "w": 55,
                                "tb": "2",
                                "fc": "#0000ff",
                                "fs": "16"
                            }
                        },
                        {
                            "r": 5,
                            "c": 4,
                            "v": {
                                "ct": {
                                    "fa": "General",
                                    "t": "inlineStr",
                                    "s": [
                                        {
                                            "fs": "16",
                                            "v": "□ "
                                        },
                                        {
                                            "vt": "0",
                                            "ht": "1",
                                            "fs": "9",
                                            "un": 0,
                                            "bl": 1,
                                            "fc": "#0000ff",
                                            "ff": "\"Tahoma\"",
                                            "m": "Matched",
                                            "v": "Matched"
                                        }
                                    ]
                                },
                                "merge": null,
                                "w": 55,
                                "tb": "2",
                                "fc": "#0000ff",
                                "fs": "16"
                            }
                        },
                        {
                            "r": 6,
                            "c": 4,
                            "v": {
                                "ct": {
                                    "fa": "General",
                                    "t": "inlineStr",
                                    "s": [
                                        {
                                            "fs": "16",
                                            "v": "□ "
                                        },
                                        {
                                            "vt": "0",
                                            "ht": "1",
                                            "fs": "9",
                                            "un": 0,
                                            "bl": 1,
                                            "fc": "#0000ff",
                                            "ff": "\"Tahoma\"",
                                            "m": "Mismatch",
                                            "v": "Mismatch"
                                        }
                                    ]
                                },
                                "merge": null,
                                "w": 55,
                                "tb": "2",
                                "fc": "#0000ff",
                                "fs": "16"
                            }
                        },
                        {
                            "r": 7,
                            "c": 4,
                            "v": {
                                "ct": {
                                    "fa": "General",
                                    "t": "inlineStr",
                                    "s": [
                                        {
                                            "fs": "16",
                                            "v": "□ "
                                        },
                                        {
                                            "vt": "0",
                                            "ht": "1",
                                            "fs": "9",
                                            "un": 0,
                                            "bl": 1,
                                            "fc": "#0000ff",
                                            "ff": "\"Tahoma\"",
                                            "m": "Details not available in the document",
                                            "v": "Details not available in the document"
                                        }
                                    ]
                                },
                                "merge": null,
                                "w": 55,
                                "tb": "2",
                                "fc": "#0000ff",
                                "fs": "16"
                            }
                        },
                    ];

                    if (canRenderFormData && addOnEnabledBrokers?.includes(brokerId)) {
                        matchedUnMatchedFilter.push({
                            "r": 8,
                            "c": 4,
                            "v": {
                                "ct": {
                                    "fa": "General",
                                    "t": "inlineStr",
                                    "s": [
                                        {
                                            "fs": "16",
                                            "v": "□ "
                                        },
                                        {
                                            "vt": "0",
                                            "ht": "1",
                                            "fs": "9",
                                            "un": 0,
                                            "bl": 1,
                                            "fc": "#0000ff",
                                            "ff": "\"Tahoma\"",
                                            "m": "“Add On” Forms Compare",
                                            "v": "“Add On” Forms Compare"
                                        }
                                    ]
                                },
                                "merge": null,
                                "w": 55,
                                "tb": "2",
                                "fc": "#0000ff",
                                "fs": "16"
                            }
                        });
                        possibleColumns.push(8);
                    }
                    if (canRenderExclusionData && addOnEnabledBrokers?.includes(brokerId)) {
                        matchedUnMatchedFilter.push({
                            "r": canRenderFormData ? 9 : 8,
                            "c": 4,
                            "v": {
                                "ct": {
                                    "fa": "General",
                                    "t": "inlineStr",
                                    "s": [
                                        {
                                            "fs": "16",
                                            "v": "□ "
                                        },
                                        {
                                            "vt": "0",
                                            "ht": "1",
                                            "fs": "9",
                                            "un": 0,
                                            "bl": 1,
                                            "fc": "#0000ff",
                                            "ff": "\"Tahoma\"",
                                            "m": "“Add On” Exclusion",
                                            "v": "“Add On” Exclusion"
                                        }
                                    ]
                                },
                                "merge": null,
                                "w": 55,
                                "tb": "2",
                                "fc": "#0000ff",
                                "fs": "16"
                            }
                        });
                        possibleColumns.push(canRenderFormData ? 9 : 8);
                    }

                    summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.columnlen[4] = 250;

                    const alltable1Rows = [...sheetDataTable1, ...matchedUnMatchedFilter, ...sheetDataTable2];

                    if (sheetDataTable1 && sheetDataTable1?.length > 0) {
                        const summaryTblColumnDetails1 = summaryTableColumnDetails;
                        summaryTblColumnDetails1["Table 1"] = { "columnNames": table1json.map((e) => e?.Headers), "range": { "start": 0, "end": sheetDataTable1[sheetDataTable1?.length - 1]?.r } }
                        setSummaryTableColumnDetails(summaryTblColumnDetails1);
                    }

                    alltable1Rows.sort((a, b) => a.r - b.r);
                    dummyData.push(...alltable1Rows);
                    summaryReviewChecklistDatafigdata.summaryReviewChecklist.celldata = dummyData;

                    alltable1Rows?.forEach((row) => {
                        if (sheetDataTable1.includes(row) || matchedUnMatchedFilter.includes(row)) {
                            summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.borderInfo.push({
                                "rangeType": "cell",
                                "value": {
                                    "row_index": row?.r,
                                    "col_index": row?.c,
                                    "l": {
                                        "style": 1,
                                        "color": "#000"
                                    },
                                    "r": {
                                        "style": 1,
                                        "color": "#000"
                                    },
                                    "t": {
                                        "style": 1,
                                        "color": "#000"
                                    },
                                    "b": {
                                        "style": 1,
                                        "color": "#000"
                                    }
                                }
                            });
                        }
                    });

                    inputData?.forEach((e, index) => {
                        if (e?.Tablename != 'Table 1' && e?.Tablename != 'Table lst' && e?.TemplateData?.length >= 1) {
                            // For lob split table mapping
                            if (e?.Tablename === 'Table 3' && props?.isLobSplitJob) {
                                let policys = e?.TemplateData?.map((e) => e?.PolicyLob)?.filter((pol) => pol != null && pol !== undefined && pol?.trim() !== '');
                                policys = Array.from(new Set(policys))
                                if (policys?.length > 0) {
                                    policys?.forEach((policy) => {
                                        let filteredData = summaryReviewChecklistDatafigdata.summaryReviewChecklist.celldata.filter((f, index) => f != null || !f);
                                        renderSummaryChecklistDataTables([...filteredData], e?.Tablename, true, policy);
                                    });
                                } else {
                                    let filteredData = summaryReviewChecklistDatafigdata.summaryReviewChecklist.celldata.filter((f, index) => f != null || !f);
                                    renderSummaryChecklistDataTables([...filteredData], e?.Tablename);
                                }
                            }
                            else {
                                let filteredData = summaryReviewChecklistDatafigdata.summaryReviewChecklist.celldata.filter((f, index) => f != null || !f);
                                renderSummaryChecklistDataTables([...filteredData], e?.Tablename);
                            }
                        }
                    });

                    const finalFilteredData = summaryReviewChecklistDatafigdata.summaryReviewChecklist.celldata.filter((f) => f != null);
                    renderSummaryJobHeader2([...finalFilteredData], 'Table lst');
                }
            };

            let currentTableNo = 2;
            const renderSummaryChecklistDataTables = (combinedata1, tableName, IsLobSplit = false, policyLob = "") => {
                if (!Array.isArray(combinedata1)) {
                    console.error("combinedata1 is not an array:", combinedata1);
                    return;
                }

                // CSR pro xray tracking variable
                const csrProXray_Copy = csrProXray;

                const tableSummaryColumnNamesOfValid = {};
                const basedata = [...combinedata1];

                const tableChecklistData = inputData?.find((data) => data?.Tablename === tableName);

                let tableChecklistDatajson = tableChecklistData?.TemplateData;
                if (props?.isLobSplitJob && policyLob) {
                    tableChecklistDatajson = tableChecklistDatajson?.filter(f => f?.PolicyLob === policyLob);
                }
                const tableChecklistDatajsoncopy = tableChecklistDatajson?.map(item => {
                    const {
                        Id,
                        JobId,
                        TableName,
                        OrderId,
                        ChecklistQuestions,
                        PolicyLob,
                        ...filteredItem
                    } = item;
                    return filteredItem;

                });

                let headers = Object.keys(tableChecklistDatajsoncopy[0]);

                let headerRows1 = [];
                let rowIndexForLOBStart = 0;

                // if (tableName === "Table 3") {
                //     rowIndexForLOBStart = canRenderFormData && addOnEnabledBrokers?.includes(brokerId) ? basedata[basedata?.length - 1]?.r + 2 : basedata[basedata?.length - 1]?.r + 2;
                //     headerRows1 = [
                //         {
                //             r: canRenderFormData && addOnEnabledBrokers?.includes(brokerId) ? basedata[basedata?.length - 1]?.r + 2 : basedata[basedata?.length - 1]?.r + 2,
                //             rs: 1,
                //             c: 1,
                //             cs: headers.length + 1,
                //             v: {
                //                 ct: { fa: "General", t: "g" },
                //                 m: tableName === "Table 3" ? policyLob || JSON.parse(sessionStorage.getItem('lob')) : "",
                //                 v: tableName === "Table 3" ? policyLob || JSON.parse(sessionStorage.getItem('lob')) : "",
                //                 fs: `${header}`,
                //                 ff: "\"Tahoma\"",
                //                 bg: "rgb(139,173,212)",
                //                 bl: 0,
                //                 tb: '2',
                //                 s: [{ bl: 0 }],
                //                 w: 55,
                //             }
                //         }
                //     ]
                // };

                const removalCode = headers.map(item => {
                    if (item === "CoverageSpecificationMaster") {
                        if (tableName === "Table 2") {
                            return "Common Declarations";
                        } else if (["Table 3", "Table 4", "Table 5", "Table 6", "Table 7"].includes(tableName)) {
                            const question = tableChecklistDatajson[0]?.PolicyLob || "";
                            return question
                        }
                    }

                    if (item === "CoverageSpecificationMaster" && tableName === "Table 3") {
                        return "Coverage Specifications";
                    }

                    if (item === "Status") {
                        if (["Table 2", "Table 3", "Table 4", "Table 5", "Table 6", "Table 7"]?.includes(tableName)) {
                            return "Comparison Summary";
                        }
                    }

                    if (item === "DocumentViewer") {
                        if (["Table 2", "Table 3", "Table 4", "Table 5", "Table 6", "Table 7"]?.includes(tableName)) {
                            return "Document Viewer";
                        }
                    }

                    return item;
                });

                headerRows1 = [
                    ...headerRows1,
                    ...removalCode?.map((item, index) => {
                        const lastRow = basedata[basedata?.length - 1]?.r || 0;

                        const rowValue =
                            tableName === "Table 3"
                                ? lastRow + 3
                                : (canRenderFormData && addOnEnabledBrokers?.includes(brokerId) && tableName === "Table 2"
                                    ? lastRow + 2
                                    : lastRow + 3);
                        summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.merge[`${rowValue}_${1 + index}`] = {
                            "r": rowValue,
                            "c": 1 + index,
                            "rs": 2,
                            "cs": 1
                        }

                        return {
                            r: rowValue,
                            rs: 2,
                            c: 1 + index,
                            cs: 1,
                            v: {
                                ct: { fa: "General", t: "g" },
                                ff: "\"Tahoma\"",
                                m: item,
                                v: item,
                                merge: null,
                                bg: "rgb(139,173,212)",
                                bl: 0,
                                "ht": item === "Comparison Summary" ? "0" : item === "Document Viewer" ? "0" : null,
                                tb: '2',
                                w: 55,
                                fs: `${header}`
                            }
                        }
                    })
                ];

                if (headerRows1?.length > 0) {
                    headerRows1.forEach((f, index) => {
                        // if(tableName === "Table 3" && index != 0) {
                            tableSummaryColumnNamesOfValid[f?.v?.v] = f?.c;
                        // } else if(tableName !== "Table 3"){tableSummaryColumnNamesOfValid[f?.v?.v] = f?.c;}
                    });
                }

                headerRows1 = [...headerRows1];

                if (tableName === "Table 3") {
                    summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.merge[`${rowIndexForLOBStart}_${1}`] = {
                        "r": rowIndexForLOBStart,
                        "c": 1,
                        "rs": 1,
                        "cs": headerRows1.length - 1
                    }
                }

                let headerRows1Values = [];

                let rowIndex = headerRows1[headerRows1.length - 1]?.r + 2;

                headers = [...headers];

                tableChecklistDatajson?.map((item, cIndex) => {
                    let rowHeight = 41;
                    headers.map((key, rIndex) => {
                        rowIndex = headerRows1Values?.length == 0 ? rowIndex : headerRows1Values?.length > 0 && rIndex == 0 ? headerRows1Values[headerRows1Values.length - 1]?.r + 1 : headerRows1Values[headerRows1Values.length - 1]?.r;
                        let text = item[key]?.toString()?.split('~~');
                        let ss = [];
                        if (key !== 'DocumentViewer' && text && text?.length > 0) {
                            text?.map((e) => {
                                if (e?.toLowerCase().includes('page')) {
                                    ss.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": "rgb(68, 114, 196)",
                                        "fs": `${value}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 1,
                                        "it": 0,
                                        "v": e.trim() + "\r\n"
                                    });
                                } else if (e?.toLowerCase() === 'mismatch' || e?.toLowerCase() === 'mismatched') {
                                    ss.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": "#ff0000",
                                        "fs": `${value}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 1,
                                        "it": 0,
                                        "v": e.trim()
                                    });
                                } else if (e?.toLowerCase() === 'match' || e?.toLowerCase() === 'matched') {
                                    ss.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": "rgb(0, 128, 0)",
                                        "fs": `${value}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 1,
                                        "it": 0,
                                        "v": e.trim()
                                    });
                                } else {
                                    ss.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": "#000000",
                                        "fs": `${value}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": e.trim() + "\r\n"
                                    });
                                }
                            })
                        };

                        if (key === 'DocumentViewer') {
                            const dvData = item[key];
                            if (dvData != undefined && dvData != null && dvData?.trim() != '') {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(61, 133, 198)",
                                    "fs": `${value}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "ht": "0",
                                    "un": 1,
                                    "v": "X-Ray"
                                });
                                // set the xray into state
                                csrProXray_Copy[rowIndex] = dvData;
                            } else {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "#000000",
                                    "fs": `${value}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "v": "  "
                                });
                            }
                        }

                        headerRows1Values.push({
                            r: rowIndex,
                            c: rIndex + 1,
                            v: {
                                ct: { fa: "General", t: "inlineStr", s: ss },
                                merge: null,
                                w: 55,
                                tb: '2',
                                "ht": key === 'DocumentViewer' ? "0" : key === "Status" ? "0" : key === 'RequestEndorsement' ? "0" :
                                    key === 'Notes' ? "0" : null
                            }
                        });

                        if (text && rowHeight < parseInt(item[key]?.length / 3 + 20)) {
                            rowHeight = parseInt(item[key]?.length / 3 + 20);
                            summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.rowlen[`${rowIndex}`] = rowHeight;
                        }
                        if (rIndex == 0) {
                            summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.rowlen[`${rowIndex}`] = rowHeight;
                        }
                    })
                });

                summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.borderInfo.push({
                    "rangeType": "range",
                    "borderType": "border-all",
                    "color": "#000",
                    "style": "1",
                    "range": [
                        {
                            "left": 74,
                            "width": 300,
                            "top": 470,
                            "height": 42,
                            "left_move": 74,
                            "width_move": 4213,
                            "top_move": 471,
                            "height_move": 1107,
                            "row": [
                                headerRows1[0]?.r,
                                headerRows1Values[headerRows1Values?.length - 1]?.r
                            ],
                            "column": [
                                headerRows1[0]?.c,
                                headerRows1Values[headerRows1Values?.length - 1]?.c
                            ],
                            "row_focus": headerRows1[0]?.r,
                            "column_focus": headerRows1[0]?.c
                        }
                    ]
                });


                headerRows1 = [...headerRows1, ...headerRows1Values];

                const allRows2 = [...headerRows1];
                allRows2.sort((a, b) => a.r - b.r);

                if (allRows2 && allRows2?.length > 0) {
                    const tableSummaryColumnDetailss = summaryTableColumnDetails;
                    if (props?.isLobSplitJob) {

                        if (tableChecklistData?.Tablename !== "Table 2") {

                            currentTableNo++;

                            tableChecklistData.Tablename =
                                `Table ${currentTableNo}`;
                        }
                        const split_jc_start = tableSummaryColumnDetailss[tableChecklistData?.Tablename]?.range?.start || allRows2[0]?.r;
                        tableSummaryColumnDetailss[tableChecklistData?.Tablename] = { "columnNames": tableSummaryColumnNamesOfValid, "range": { "start": split_jc_start, "end": allRows2[allRows2?.length - 1]?.r } }
                    } else {
                        tableSummaryColumnDetailss[tableChecklistData?.Tablename] = { "columnNames": tableSummaryColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }
                    }
                    console.log(tableSummaryColumnDetailss)
                    setSummaryTableColumnDetails(tableSummaryColumnDetailss);
                }
                setCsrProXray(csrProXray_Copy);
                basedata.push(...allRows2);
                summaryReviewChecklistDatafigdata.summaryReviewChecklist.celldata = basedata;
            };

            const renderSummaryJobHeader2 = (combinedata1, tableName) => {
                const basedata = [...combinedata1];
                const tableData1Summary = inputData?.find((data) => data.Tablename === tableName);
                if (tableData1Summary) {
                    const table1json = tableData1Summary?.TemplateData;

                    let sheetDataTable1 = [];

                    const rowIndexOfTable1 = basedata[basedata.length - 1].r + 3

                    table1json?.map((item, index) => {
                        if (item["Headers"] != null && item["Headers"] != undefined) {
                            if (item["Headers"] == "") {
                                sheetDataTable1.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 1,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr", s: [{ v: " " }] },
                                        m: " ",
                                        v: " ",
                                        merge: null,
                                        bg: "rgb(139,173,212)",
                                        tb: '2',
                                    }
                                });
                            } else {
                                sheetDataTable1.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 1,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr", s: [{ v: item["Headers"], ff: "Tahoma", fs: 9 }] },
                                        m: item["Headers"],
                                        v: item["Headers"],
                                        ff: "Tahoma",
                                        merge: null,
                                        bg: "rgb(139,173,212)",
                                        tb: '2',
                                    }
                                });
                            }

                            const tidleValue = item["Value"] !== null && item["Value"] != undefined ? item["Value"].replace(/~~/g, "\n") : "";

                            if (item['Headers']?.toLowerCase() === 'exdion csrdigit'.toLowerCase()) {
                                sheetDataTable1.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 2,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr" },
                                        m: tidleValue,
                                        v: tidleValue,
                                        fs: 9,
                                        un: 1,
                                        fc: "#0b5394",
                                        ff: "\"Tahoma\"",
                                        merge: null,
                                        tb: '2',
                                    }
                                });
                            } else {
                                sheetDataTable1.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 2,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr" },
                                        m: tidleValue,
                                        v: tidleValue,
                                        fs: 9,
                                        ff: "Tahoma",
                                        merge: null,
                                        tb: '2',
                                    }
                                });
                            }

                            let maxLength = 0;
                            const lengths = [];
                            Object.keys(item).forEach((key) => {
                                if (item[key]) {
                                    lengths.push(item[key].length);
                                }
                            });
                            lengths.forEach((length) => {
                                if (length > maxLength) {
                                    maxLength = length;
                                }
                            });
                            const rowHeight = parseInt(maxLength / 3 + 15);
                            summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.rowlen[`${rowIndexOfTable1 + index}`] = rowHeight;
                        }
                    });

                    const alltable1Rows = [...sheetDataTable1];
                    if (sheetDataTable1 && sheetDataTable1?.length > 0) {
                        const summaryTblColumnDetails1 = summaryTableColumnDetails;
                        const lstTblLen =  Object.keys(summaryTableColumnDetails).length;
                        summaryTblColumnDetails1[ `Table ${lstTblLen + 1}`] = { "columnNames": table1json?.map((e) => e?.Headers), "range": { "start": sheetDataTable1[0].r, "end": sheetDataTable1[sheetDataTable1?.length - 1]?.r } }
                        setSummaryTableColumnDetails(summaryTblColumnDetails1);
                    }

                    alltable1Rows.sort((a, b) => a.r - b.r);
                    basedata.push(...alltable1Rows);
                    summaryReviewChecklistDatafigdata.summaryReviewChecklist.celldata = basedata;

                    alltable1Rows?.forEach((row) => {
                        if (sheetDataTable1.includes(row)) {
                            summaryReviewChecklistDatafigdata.summaryReviewChecklist.config.borderInfo.push({
                                "rangeType": "cell",
                                "value": {
                                    "row_index": row?.r,
                                    "col_index": row?.c,
                                    "l": {
                                        "style": 1,
                                        "color": "#000"
                                    },
                                    "r": {
                                        "style": 1,
                                        "color": "#000"
                                    },
                                    "t": {
                                        "style": 1,
                                        "color": "#000"
                                    },
                                    "b": {
                                        "style": 1,
                                        "color": "#000"
                                    }
                                }
                            });
                        }
                    });
                }
            }

            renderSummaryJobHeader()
        };

        if (canRenderSummaryData && renderBrokerIdsSummary?.includes(brokerId)) {
            summaryReviewChecklistTable();
        }

        const csrTable1 = () => {
            const tableData1 = mainData.find((data) => data.Tablename === "Table 1");
            if (tableData1) {
                const table1json = typeof tableData1.TemplateData === 'string' ? JSON.parse(tableData1.TemplateData) : tableData1.TemplateData;

                let sheetDataTable1 = [];
                let sheetDataTable2 = [];

                const rowIndexOfTable1 = 3
                const textBlockData = renderTextBlock();
                const listData = renderList();

                textBlockData.forEach((item, index) => {
                    const mergeConfig = Policy_appDataConfig.demo.config.merge["0_1"];

                    sheetDataTable2.push({
                        r: index + mergeConfig.r,
                        c: mergeConfig.c,
                        v: {
                            ct: item.ct,
                            m: item.m,
                            v: item.v,
                            bl: 1,
                            fs: 8.5,
                            ff: item.ff,
                            merge: mergeConfig,
                            fc: item.fc,
                            // tb: '55',
                        }
                    });
                });

                listData.forEach((item, index) => {
                    const mergeConfig = Policy_appDataConfig.demo.config.merge["1_1"];

                    sheetDataTable2.push({
                        r: 1 + mergeConfig.r,
                        c: mergeConfig.c,
                        v: {
                            ct: item.ct,
                            m: item.m,
                            v: item.v,
                            ff: item.ff,
                            fs: 13,
                            merge: mergeConfig,
                            fc: item.fc,
                        }
                    });
                });

                table1json.map((item, index) => {
                    if (item["Headers"] != null) {
                        sheetDataTable1.push({
                            r: rowIndexOfTable1 + index,
                            c: 1,
                            v: {
                                ct: { fa: "@", t: "inlineStr", s: [{ v: item["Headers"], ff: "Tahoma" }] },
                                m: item["Headers"],
                                v: item["Headers"],
                                fs: 10,
                                ff: "Tahoma",
                                merge: null,
                                bg: "rgb(139,173,212)",
                                tb: '2',
                            }
                        });

                        const tidleValue = item["(No column name)"] !== null ? item["(No column name)"].replace(/~~/g, "\n") : "";
                        if (item['Headers']?.toLowerCase() === 'exdion csrdigit'.toLowerCase()) {
                            sheetDataTable1.push({
                                r: rowIndexOfTable1 + index,
                                c: 2,
                                v: {
                                    ct: { fa: "@", t: "inlineStr" },
                                    m: tidleValue,
                                    v: tidleValue,
                                    fs: 9,
                                    un: 1,
                                    fc: "#0b5394",
                                    ff: "\"Tahoma\"",
                                    merge: null,
                                    tb: '2',
                                }
                            });
                        } else {
                            sheetDataTable1.push({
                                r: rowIndexOfTable1 + index,
                                c: 2,
                                v: {
                                    ct: { fa: "@", t: "inlineStr" },
                                    m: tidleValue,
                                    v: tidleValue,
                                    fs: 9,
                                    ff: "\"Tahoma\"",
                                    merge: null,
                                    tb: '2',
                                }
                            });
                        }

                        let maxLength = 0;
                        const lengths = [];
                        Object.keys(item).forEach((key) => {
                            if (item[key]) {
                                lengths.push(item[key].length);
                            }
                        });
                        lengths.forEach((length) => {
                            if (length > maxLength) {
                                maxLength = length;
                            }
                        });
                        const rowHeight = parseInt(maxLength / 3 + 15);
                        Policy_appDataConfig.demo.config.rowlen[`${rowIndexOfTable1 + index}`] = rowHeight;
                    }
                });

                const dummyData = [];
                const matchedUnMatchedFilter = [
                    {
                        "r": 3,
                        "c": 4,
                        "v": {
                            "ct": {
                                "fa": "General",
                                "t": "inlineStr",
                                "s": [
                                    {
                                        "fs": "16",
                                        "v": "□ "
                                    },
                                    {
                                        "vt": "0",
                                        "ht": "1",
                                        "fs": "9",
                                        "un": 0,
                                        "bl": 1,
                                        "fc": "#0000ff",
                                        "ff": "\"Tahoma\"",
                                        "m": brokerId === "1167" ? "Full Variances" : "All Variances",
                                        "v": brokerId === "1167" ? "Full Variances" : "All Variances",
                                    }
                                ]
                            },
                            "merge": null,
                            "w": 55,
                            "tb": "2",
                            "fc": "#0000ff",
                            "fs": "16"
                        }
                    },
                    {
                        "r": 4,
                        "c": 4,
                        "v": {
                            "ct": {
                                "fa": "General",
                                "t": "inlineStr",
                                "s": [
                                    {
                                        "fs": "16",
                                        "v": "□ "
                                    },
                                    {
                                        "vt": "0",
                                        "ht": "1",
                                        "fs": "9",
                                        "un": 0,
                                        "bl": 1,
                                        "fc": "#0000ff",
                                        "ff": "\"Tahoma\"",
                                        "m": "Matched",
                                        "v": "Matched"
                                    }
                                ]
                            },
                            "merge": null,
                            "w": 55,
                            "tb": "2",
                            "fc": "#0000ff",
                            "fs": "16"
                        }
                    },
                    {
                        "r": 5,
                        "c": 4,
                        "v": {
                            "ct": {
                                "fa": "General",
                                "t": "inlineStr",
                                "s": [
                                    {
                                        "fs": "16",
                                        "v": "□ "
                                    },
                                    {
                                        "vt": "0",
                                        "ht": "1",
                                        "fs": "9",
                                        "un": 0,
                                        "bl": 1,
                                        "fc": "#0000ff",
                                        "ff": "\"Tahoma\"",
                                        "m": "Variances",
                                        "v": "Variances"
                                    }
                                ]
                            },
                            "merge": null,
                            "w": 55,
                            "tb": "2",
                            "fc": "#0000ff",
                            "fs": "16"
                        }
                    },
                    {
                        "r": 6,
                        "c": 4,
                        "v": {
                            "ct": {
                                "fa": "General",
                                "t": "inlineStr",
                                "s": [
                                    {
                                        "fs": "16",
                                        "v": "□ "
                                    },
                                    {
                                        "vt": "0",
                                        "ht": "1",
                                        "fs": "9",
                                        "un": 0,
                                        "bl": 1,
                                        "fc": "#0000ff",
                                        "ff": "\"Tahoma\"",
                                        "m": "Details not available in the document",
                                        "v": "Details not available in the document"
                                    }
                                ]
                            },
                            "merge": null,
                            "w": 55,
                            "tb": "2",
                            "fc": "#0000ff",
                            "fs": "16"
                        }
                    },
                ];

                if (canRenderFormData && addOnEnabledBrokers?.includes(brokerId)) {
                    matchedUnMatchedFilter.push({
                        "r": 7,
                        "c": 4,
                        "v": {
                            "ct": {
                                "fa": "General",
                                "t": "inlineStr",
                                "s": [
                                    {
                                        "fs": "16",
                                        "v": "□ "
                                    },
                                    {
                                        "vt": "0",
                                        "ht": "1",
                                        "fs": "9",
                                        "un": 0,
                                        "bl": 1,
                                        "fc": "#0000ff",
                                        "ff": "\"Tahoma\"",
                                        "m": "“Add On” Forms Compare",
                                        "v": "“Add On” Forms Compare"
                                    }
                                ]
                            },
                            "merge": null,
                            "w": 55,
                            "tb": "2",
                            "fc": "#0000ff",
                            "fs": "16"
                        }
                    });
                    possibleColumns.push(7);
                }
                if (canRenderExclusionData && addOnEnabledBrokers?.includes(brokerId)) {
                    matchedUnMatchedFilter.push({
                        "r": canRenderFormData ? 8 : 7,
                        "c": 4,
                        "v": {
                            "ct": {
                                "fa": "General",
                                "t": "inlineStr",
                                "s": [
                                    {
                                        "fs": "16",
                                        "v": "□ "
                                    },
                                    {
                                        "vt": "0",
                                        "ht": "1",
                                        "fs": "9",
                                        "un": 0,
                                        "bl": 1,
                                        "fc": "#0000ff",
                                        "ff": "\"Tahoma\"",
                                        "m": "“Add On” Exclusion",
                                        "v": "“Add On” Exclusion"
                                    }
                                ]
                            },
                            "merge": null,
                            "w": 55,
                            "tb": "2",
                            "fc": "#0000ff",
                            "fs": "16"
                        }
                    });
                    possibleColumns.push(canRenderFormData ? 8 : 7);
                }

                const allRows = [...sheetDataTable1, ...matchedUnMatchedFilter, ...sheetDataTable2];
                if (sheetDataTable1 && sheetDataTable1?.length > 0) {
                    const tableColumnDetails1 = tableColumnDetails;
                    tableColumnDetails1["Table 1"] = { "columnNames": table1json.map((e) => e?.Headers), "range": { "start": 0, "end": sheetDataTable1[sheetDataTable1?.length - 1]?.r } }
                    setTableColumnDetails(tableColumnDetails1);
                }
                allRows.sort((a, b) => a.r - b.r);

                dummyData.push(...allRows);
                Policy_appDataConfig.demo.config.borderInfo.push({
                    "rangeType": "range",
                    "borderType": "border-all",
                    "color": "#000",
                    "style": "1",
                    "range": [
                        {
                            "left": 857,
                            "width": 250,
                            "top": 114,
                            "height": 50,
                            "left_move": 857,
                            "width_move": 250,
                            "top_move": 114,
                            "height_move": 122,
                            "row": [
                                3,
                                (6 + (canRenderFormData && addOnEnabledBrokers?.includes(brokerId) ? 1 : 0) + (canRenderExclusionData && addOnEnabledBrokers?.includes(brokerId) ? 1 : 0))
                            ],
                            "column": [
                                4,
                                4
                            ],
                            "row_focus": 4,
                            "column_focus": 4
                        }
                    ]
                });
                Policy_appDataConfig.demo.celldata = dummyData;
                allRows.forEach((row) => {
                    if (sheetDataTable1.includes(row)) {
                        Policy_appDataConfig.demo.config.borderInfo.push({
                            "rangeType": "cell",
                            "value": {
                                "row_index": row?.r,
                                "col_index": row?.c,
                                "l": {
                                    "style": 1,
                                    "color": "#000"
                                },
                                "r": {
                                    "style": 1,
                                    "color": "#000"
                                },
                                "t": {
                                    "style": 1,
                                    "color": "#000"
                                },
                                "b": {
                                    "style": 1,
                                    "color": "#000"
                                }
                            }
                        });
                    }
                });

                // const excludedTablenames = ["JobHeader", "JobCommonDeclaration", "JobCoverages", "Tbl_ChecklistForm1", "Tbl_ChecklistForm2", "Tbl_ChecklistForm3", "Tbl_ChecklistForm4"];
                let policyDataTracked = [];
                let positioningForPolicy = [];
                let xRAyDataMap = [];
                mainData.map((e, index) => {
                    if (e?.Tablename != 'Table 1' && e?.TemplateData?.length >= 1) {   //!excludedTablenames.includes(e?.Tablename) && 
                        let filteredData = Policy_appDataConfig.demo.celldata.filter((f, index) => f != null || !f);
                        csrTable2([...filteredData], e?.Tablename);
                        const trackedData = csrTable2([...filteredData], e?.Tablename);
                        policyDataTracked = [...policyDataTracked, ...trackedData?.dataForReturn];
                        positioningForPolicy = [...positioningForPolicy, ...trackedData?.tableColumnDetailsForPolicySave];
                        xRAyDataMap = [...xRAyDataMap, ...trackedData?.tableColumnDetailsForXRay];
                    }
                    if (mainData?.length === (index + 1)) {
                        setDataForSavePolicy(policyDataTracked);
                        sessionStorage.setItem('policyDataTracked', JSON.stringify(policyDataTracked))
                        setDataForSavePolicyPosition(positioningForPolicy);
                        sessionStorage.setItem('positioningForPolicy', JSON.stringify(positioningForPolicy))
                        setDataForXRayMapping(xRAyDataMap);
                    }
                });
                csrLuckySheet();
            }
        };

        const csrTable2 = (combinedata1, tableName) => {
            if (!Array.isArray(combinedata1)) {
                return;
            }
            const tableColumnNamesOfValid = {};
            const needDocumentViewer = false;
            let DefaultColumns;
            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                DefaultColumns = ["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
            } else {
                DefaultColumns = ["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
            }
            const basedata = [...combinedata1];
            const parsedData = mainData;
            const parseTemplateData = (data) => {
                return data.map(item => ({
                    ...item,
                    TemplateData: typeof item.TemplateData == 'object' ? item.TemplateData : JSON.parse(item.TemplateData)
                }));
            };

            const inputData = parseTemplateData(parsedData);
            setCsrPolicydata(inputData);

            let defaultText = csrPolicyData2_3[0];
            if (tableName == 'Table 2' || tableName == 'Table 3') {
                let propsUpdateData = JSON.parse(defaultText.TemplateData);
                for (let i = 0; i < inputData.length; i++) {
                    if (inputData[i].TemplateData.length === 0) {
                        inputData[i].TemplateData = propsUpdateData;
                    }
                }
            }

            inputData.forEach(item => {
                if (item.Tablename != 'Table 1') {
                    if (Array.isArray(item.TemplateData)) {
                        item.TemplateData.forEach(data => {
                            if (typeof data === 'object' && data !== null) {
                                if (!data.hasOwnProperty('COVERAGE_SPECIFICATIONS_MASTER')) {
                                    data.CoverageSpecificationsMaster = null;
                                }
                            }
                        });
                    }
                }
            });

            const tableData2 = inputData.find((data) => data.Tablename === tableName);
            let applicaleLob = inputData[0].AvailableLobs;
            const policyLOBValuesForLobSplit = tableData2?.TemplateData?.filter(item =>
                applicaleLob.includes(item["POLICY LOB"] || item["Policy LOB"])
            );

            if (policyLOBValuesForLobSplit && policyLOBValuesForLobSplit?.length > 0) {
                tableName = 'Table 3';
                // tableData2.Tablename = 'Table 3';
            }

            if (!tableData2) {
                //console.error( "Table 2 data not found" );
                return;
            }

            const table22sonCopy = tableData2.TemplateData;

            let tableColumnKeys = [];
            if (table22sonCopy && table22sonCopy?.length > 0) {
                const allKeys = Object.keys(table22sonCopy[0]);
                allKeys.map((e) => {
                    if (e) {
                        let keyHasData = table22sonCopy?.filter((f) => (f[e] != null && f[e] !== "") || (e == "Lob" && tableData2?.isMultipleLobSplit) || (e == "COVERAGE_SPECIFICATIONS_MASTER" && (f[e] === null || f[e] === "")) || (e == "ActionOnDiscrepancy" && (f[e] === null || f[e] === ""))
                            || (e == "RequestEndorsement" && (f[e] === null || f[e] === "")) || (e == "Notes" && (f[e] === null || f[e] === "")) || (e == "NotesFreeFill" && (f[e] === null || f[e] === "")));
                        if (keyHasData?.length > 0) {
                            tableColumnKeys.push(e);
                        }
                    }
                });
                tableColumnKeys.push("Document Viewer");
            }

            const table2JsonCopy = table22sonCopy.map(obj => {
                let newObj = {};
                tableColumnKeys.forEach((key) => {
                    newObj[key] = obj[key];
                });
                return newObj;
            });

            const table2json = table2JsonCopy.map(item => {
                const {
                    JobId,
                    Jobid,
                    CreatedOn,
                    UpdatedOn,
                    Columnid,
                    columnid,
                    IsDataForSp,
                    ...filteredItem
                } = item;
                return filteredItem;

            });
            
            const extractPageNo = (text) => {
                if (!text) return Infinity;

                const value = String(text);

                const match = value.match(
                    /(page\s*#?|current\s*policy\s*listed\s*#?|current\s*policy\s*attached\s*#?)\s*(\d+)/i
                );

                return match ? parseInt(match[2], 10) : Infinity;
            };

            const getCurrentTermText = (row) => {
                return row["Current Term Policy"] ||
                    row["CurrentTermPolicy"] ||
                    row["Current Term Policy Listed"] ||
                    row["CurrentTermPolicyListed"] ||
                    row["Current Term Policy - Listed"] ||
                    row["CurrentTermPolicyListed1"] ||
                    row["Current Term Policy Attached"] ||
                    row["CurrentTermPolicyAttached"] ||
                    "";
            };

            const getQuestionText = (row) => {
                return row["Checklist Questions"] ||
                    row["ChecklistQuestions"] ||
                    row["POLICY LOB"] ||
                    row["Policy LOB"] ||
                    "";
            };

            const sortWithinSameQuestionOnly = (rows) => {
                const groups = [];

                rows.forEach((row) => {
                    const question = String(getQuestionText(row)).trim();
                    const lastGroup = groups[groups.length - 1];

                    if (lastGroup && lastGroup.question === question) {
                        lastGroup.rows.push(row);
                    } else {
                        groups.push({ question, rows: [row] });
                    }
                });

                return groups.flatMap(group =>
                    group.rows
                        .map((row, index) => ({ row, index }))
                        .sort((a, b) => {
                            const aPage = extractPageNo(getCurrentTermText(a.row));
                            const bPage = extractPageNo(getCurrentTermText(b.row));

                            if (aPage !== bPage) return aPage - bPage;

                            return a.index - b.index;
                        })
                        .map(x => x.row)
                );
            };

            const sortedTable2json = sortWithinSameQuestionOnly(table2json);

            let header = Object.keys(sortedTable2json[0]);
            header = header.filter(f => !["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]?.includes(f));
            const value = Object.values(sortedTable2json);

            const policyLOBValues = value.map(item => item["POLICY LOB"] || item["Policy LOB"]);
            let headerRows1 = [];
            let rowIndexForLOBStart = 0;
            let rowIndexForLOBEnd = 0;

            if (tableName === "Table 3") {
                rowIndexForLOBStart = basedata[basedata?.length - 1]?.r + 2;
                headerRows1 = [
                    {
                        r: basedata[basedata?.length - 1]?.r + 2,
                        rs: 1,
                        c: 1,
                        cs: header.length + 1,
                        v: {
                            ct: { fa: "General", t: "g" },
                            m: policyLOBValues[0],
                            v: policyLOBValues[0],
                            fs: 11,
                            ff: "\"Tahoma\"",
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                ]
            };


            const excludedColumns = ["Id", "POLICY LOB", "PolicyLob", "Policy LOB", "Checklist Questions", "Observation", "PageNumber", "OBSERVATION", "Page Number", "ActionOnDiscrepancy", "RequestEndorsement", "NotesforEndorsement", "NotesFreeFill", "Notes"];
            let headers = Object.keys(table2json[0]).filter(headerw => !excludedColumns.includes(headerw));
            if (policyLOBValues && policyLOBValues?.length > 0 && policyLOBValues[0] === 'Are the forms and endorsements attached, listed in current term policy?') {
                const indexListed = headers.indexOf("CurrentTermPolicyListed");
                const indexAttached = headers.indexOf("CurrentTermPolicyAttached");
                if (indexListed !== -1 && indexAttached !== -1 && indexAttached > indexListed) {
                    // Swap the elements at the identified indices
                    [headers[indexListed], headers[indexAttached]] = [headers[indexAttached], headers[indexListed]];
                }
            }
            const removalCode = headers.map(item => {
                if (tableName !== "Table 3" && (item === "COVERAGE_SPECIFICATIONS_MASTER" || item === "Coverage_Specifications_Master")) {
                    return policyLOBValues[0];
                } else if (tableName === "Table 3" && (item === "COVERAGE_SPECIFICATIONS_MASTER" || item === "Coverage_Specifications_Master")) {
                    return "COVERAGE SPECIFICATIONS";
                }
                else {
                    return item;
                }
            });


            headerRows1 = [
                ...headerRows1,
                ...removalCode.map((item, index) => {
                    if (index === 0) {
                        Policy_appDataConfig.demo.config.merge[`${tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 2 : basedata[basedata?.length - 1]?.r + 2}_${index}`] = {
                            "r": tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 2 : basedata[basedata?.length - 1]?.r + 2,
                            "c": index,
                            "rs": tableName === "Table 3" ? 3 : 2,
                            "cs": 1
                        }
                    }
                    Policy_appDataConfig.demo.config.merge[`${tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2}_${1 + index}`] = {
                        "r": tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2,
                        "c": 1 + index,
                        "rs": 2,
                        "cs": 1
                    }

                    return {
                        r: tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2, // Start from row 1 for headers
                        rs: 2,
                        c: 1 + index,
                        cs: 1,
                        v: {
                            ct: { fa: "General", t: "g" },
                            m: item,
                            v: item,
                            fs: 11,
                            ff: "\"Tahoma\"",
                            merge: null,
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                }),
            ]
            if (headerRows1?.length > 0) {
                headerRows1.forEach((f, index) => {
                    if (tableName === "Table 3" && (index === 0 || index === 1)) {
                        tableColumnNamesOfValid["COVERAGE_SPECIFICATIONS_MASTER"] = f?.c;
                    } else if (index === 0) {
                        tableColumnNamesOfValid["COVERAGE_SPECIFICATIONS_MASTER"] = f?.c;
                    } else {
                        tableColumnNamesOfValid[f?.v?.v] = f?.c;
                    }
                });
            }
            //add documentviewer
            if (needDocumentViewer) {
                Policy_appDataConfig.demo.config.merge[`${tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2}_${1 + headerRows1[headerRows1?.length - 1]?.c}`] = {
                    "r": tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2,
                    "c": 1 + headerRows1[headerRows1?.length - 1]?.c,
                    "rs": 2,
                    "cs": 1
                }

                const DocumentViewer = [{
                    r: tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 2 : basedata[basedata?.length - 1]?.r + 1,
                    rs: 2,
                    c: 1 + headerRows1[headerRows1?.length - 1]?.c,
                    cs: 1,
                    v: {
                        ct: { fa: "General", t: "g" },
                        v: 'Document Viewer',
                        merge: null,
                        bg: "rgb(139,173,212)",
                        tb: '2',
                        w: 55,
                    }
                }];
                headerRows1 = [...headerRows1, ...DocumentViewer];
            }

            const defaultHeaderRows1 = DefaultColumns.map((item, index) => {
                if (DefaultColumns?.length === index + 1) {
                    rowIndexForLOBEnd = tableName === "Table 3" ? headerRows1.length + index : headerRows1.length + index;
                }
                if (index == 0) {
                    Policy_appDataConfig.demo.config.merge[`${tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2}_${tableName === "Table 3" ? headerRows1.length + index : headerRows1.length + index + 1}`] = {
                        "r": tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2,
                        "c": tableName === "Table 3" ? headerRows1.length + index : headerRows1.length + index + 1,
                        "rs": 1,
                        "cs": reqEndorsementColHideBrokerId.includes(brokerId) ? 3 : 4,
                    }
                    return {
                        r: tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2,
                        rs: 1,
                        c: tableName === "Table 3" ? headerRows1.length + index : headerRows1.length + index + 1,
                        cs: 1,
                        v: {
                            ht: 0,
                            ct: { fa: "General", t: "g" },
                            m: item,
                            v: item,
                            fs: 11,
                            ff: "\"Tahoma\"",
                            merge: null,
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                }
                else {
                    return {
                        r: tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 4 : basedata[basedata?.length - 1]?.r + 3,
                        rs: 1,
                        c: tableName === "Table 3" ? headerRows1.length + index - 1 : headerRows1.length + index,
                        cs: 1,
                        v: {
                            ct: { fa: "General", t: "g" },
                            m: item,
                            v: item,
                            fs: 11,
                            ff: "\"Tahoma\"",
                            merge: null,
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                }
            });

            if (tableName === "Table 3") {
                Policy_appDataConfig.demo.config.merge[`${rowIndexForLOBStart}_${1}`] = {
                    "r": rowIndexForLOBStart,
                    "c": 1,
                    "rs": 1,
                    "cs": rowIndexForLOBEnd - 1,
                }
            }

            let headerRows1Values = [];
            let rowIndex = defaultHeaderRows1[defaultHeaderRows1.length - 1]?.r + 1;
            let actionColumnKeys;
            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                actionColumnKeys = ["ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
            } else {
                actionColumnKeys = ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
            }
            headers = [...headers, ...actionColumnKeys];
            let dataToUpDate = sortedTable2json.map((item, cIndex) => {

                let rowIndexForStateData = 0; //by gokul
                let rowMaxValue = 30;
                let fs = 9;
                function escapeRegExp(str) {
                    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
                }

                function splitWordsWithComma(array) {
                    if (!array || array.length === 0) {
                        return [];
                    }
                    let newArray = [];

                    array.forEach((word) => {
                        // Check if the word ends with a comma
                        word = word.trim();
                        if (word.endsWith(',')) {
                            const wordWithoutComma = word.slice(0, -1).trim();
                            // Add the word without the comma as a separate character, excluding leading spaces
                            if (wordWithoutComma !== '') {
                                newArray.push(wordWithoutComma);
                            }
                            newArray.push(',');
                        } else if (word.includes('(') && word.includes(')')) {
                            // If the word contains both '(' and ')', split them into separate characters
                            const openingParen = word.indexOf('(');
                            const closingParen = word.indexOf(')');
                            const beforeParen = word.slice(0, openingParen);
                            const insideParen = word.slice(openingParen + 1, closingParen);
                            const afterParen = word.slice(closingParen + 1);
                            if (beforeParen !== '') {
                                newArray.push(beforeParen);
                            }
                            newArray.push('(');
                            if (insideParen !== '') {
                                newArray.push(insideParen);
                            }
                            newArray.push(')');
                            if (afterParen !== '') {
                                newArray.push(afterParen);
                            }
                        } else if (word.includes('(')) {
                            // If the word contains an open parenthesis, split it into separate characters
                            const openingParen = word.indexOf('(');
                            const beforeParen = word.slice(0, openingParen);
                            const insideParen = word.slice(openingParen + 1);
                            if (beforeParen !== '') {
                                newArray.push(beforeParen);
                            }
                            newArray.push('(');
                            if (insideParen !== '') {
                                newArray.push(insideParen);
                            }
                        } else if (word.includes(')')) {
                            // If the word contains a closing parenthesis, split it into separate characters
                            let closingParen = word.indexOf(')');
                            let insideParen = word.slice(0, closingParen).trim();
                            const afterParen = word.slice(closingParen + 1);
                            if (insideParen !== '') {
                                newArray.push(insideParen);
                            }
                            newArray.push(')');
                            if (afterParen !== '') {
                                newArray.push(afterParen);
                            }
                        } else {
                            // If no comma, just add the word to the new array
                            newArray.push(word);
                        }
                    });

                    return newArray;
                }
                headers.map((key, rIndex) => {
                    rowIndex = headerRows1Values?.length == 0 ? rowIndex : headerRows1Values?.length > 0 && rIndex == 0 ? headerRows1Values[headerRows1Values.length - 1]?.r + 1 : headerRows1Values[headerRows1Values.length - 1]?.r;
                    rowIndexForStateData = rowIndex;
                    const item_data = item[key]?.split('~~');
                    let final_arr_txt = [];

                    if (item_data && item_data?.length > 0) {
                        const page_keys = ['page #', 'endorsement page #', 'current policy listed', 'current policy endorsement listed',
                            'current policy attached', 'current policy endorsement attached'
                        ]

                        const txt_arry1 = [];
                        const txt_arry2 = [];

                        item_data?.forEach((txt_l) => {
                            let is_page_key = false;
                            page_keys?.forEach((page_key) => {
                                if (txt_l?.toLowerCase().includes(page_key)) {
                                    is_page_key = true;
                                }
                            });
                            if (txt_arry2?.length > 0 || is_page_key) {
                                txt_arry2.push(txt_l);
                            } else if (txt_l && txt_arry2?.length === 0) {
                                txt_arry1.push(txt_l);
                            }
                        });
                        const arr1_combined = txt_arry1?.length > 0 ? txt_arry1?.join(' ') : "";
                        final_arr_txt = [arr1_combined, ...txt_arry2];

                    }

                    let text = final_arr_txt;
                    if (final_arr_txt?.length === 0) {
                        text = item[key]?.split('~~');;
                    }
                    let ct = [];

                    if (key != 'Document Viewer' && text && text?.length > 0) {
                        text?.map((e) => {
                            if (e?.toLowerCase().includes('page #')) {
                                ct.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(68, 114, 196)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 1,
                                    "it": 0,
                                    "v": "\r\n" + e.trim() + "\r\n"
                                });
                            } else if (e?.toLowerCase().includes('endorsement page #')) {
                                ct.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(68, 114, 196)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 1,
                                    "it": 0,
                                    "v": e.trim() + "\r\n"
                                });
                            }
                            else if (key === "PageNumber") {
                                ct.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "#000000",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "v": e.trim() + "\r\n"
                                });
                            }
                            else if (e?.toLowerCase().includes('current policy listed')) {
                                ct.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(68, 114, 196)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 1,
                                    "it": 0,
                                    "v": e.trim() + "\r\n"
                                });
                            } else if (e?.toLowerCase().includes('current policy endorsement listed')) {
                                ct.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(68, 114, 196)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 1,
                                    "it": 0,
                                    "v": e.trim() + "\r\n"
                                });
                            } else if (e?.toLowerCase().includes('current policy attached')) {
                                ct.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(68, 114, 196)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 1,
                                    "it": 0,
                                    "v": e.trim() + "\r\n"
                                });
                            } else if (e?.toLowerCase().includes('current policy endorsement attached')) {
                                ct.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(68, 114, 196)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 1,
                                    "it": 0,
                                    "v": e.trim() + "\r\n"
                                });
                            } else if (e === 'MATCHED') {
                                ct.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(0, 128, 0)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 1,
                                    "it": 0,
                                    "v": e.trim()
                                });
                            }
                            else if (key === "Prior Term Policy" && item["Prior Term Policy"]?.trim() != item["Current Term Policy"]?.trim()
                                && !(item["Prior Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document")
                                    || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") 
                                    || item["Prior Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")
                                    || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Binder" && item["Binder"]?.trim() != item["Current Term Policy"]?.trim()
                                && !(item["Binder"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document")
                                    || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document")
                                || item["Binder"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")
                                    || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Proposal" && item["Proposal"]?.trim() != item["Current Term Policy"]?.trim()
                                && !(item["Proposal"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document")
                                    || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document")
                                    || item["Proposal"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")
                                    || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Quote" && item["Quote"]?.trim() != item["Current Term Policy"]?.trim()
                                && !(item["Quote"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document")
                                    || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document")
                                    || item["Quote"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")
                                    || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))){

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Schedule" && item["Schedule"]?.trim() != item["Current Term Policy"]?.trim()
                               && !((item["Schedule"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Schedule"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Current Term Policy Attached" && item["Current Term Policy Attached"]?.trim() != item["Current Term Policy Listed"]?.trim()
                               && !((item["Current Term Policy Attached"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy Attached"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy Listed"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Application" && item["Application"]?.trim() != item["Current Term Policy"]?.trim()
                                  && !((item["Application"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Application"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document") ))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word?.toLowerCase()?.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Application - Listed" && item["Application - Listed"]?.trim() != item["Current Term Policy - Listed"]?.trim()
                                && !((item["Application - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Application - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy - Listed"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Quote - Listed" && item["Quote - Listed"]?.trim() != item["Current Term Policy - Listed"]?.trim()
                                && !((item["Quote - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Quote - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy - Listed"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Proposal - Listed" && item["Proposal - Listed"]?.trim() != item["Current Term Policy - Listed"]?.trim()
                                && !((item["Proposal - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Proposal - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document") )
                                    || (item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy - Listed"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Binder - Listed" && item["Binder - Listed"]?.trim() != item["Current Term Policy - Listed"]?.trim()
                                && !((item["Binder - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Binder - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy - Listed"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Schedule - Listed" && item["Schedule - Listed"]?.trim() != item["Current Term Policy - Listed"]?.trim()
                                && !((item["Schedule - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Schedule - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy - Listed"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Prior Term Policy - Listed" && item["Prior Term Policy - Listed"]?.trim() != item["Current Term Policy - Listed"]?.trim()
                                && !((item["Prior Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Prior Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy - Listed"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Prior Term Policy - Listed" && item["Prior Term Policy - Listed"]?.trim() != item["Current Term Policy - Listed"]?.trim()
                                && !((item["Prior Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Prior Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy - Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy - Listed"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else if (key === "Current Term Policy Attached" && item["Current Term Policy Attached"]?.trim() != item["Current Term Policy Listed"]?.trim()
                                && !((item["Current Term Policy Attached"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy Attached"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document"))
                                    || (item["Current Term Policy Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("details not available in the document") || item["Current Term Policy Listed"]?.toLowerCase()?.replace(/\\r\\n/g, '')?.includes("form not attached in the document")))) {

                                let ptpSplitArray = e?.split(" ");
                                let ctpSplitArray = item["Current Term Policy Listed"]?.replace('~~', " ")?.split(" ");

                                const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                ctpFlattenedArray && ctpFlattenedArray?.length > 0 && ptpFlattenedArray.forEach((ptpe) => {
                                    let css = "#000000";
                                    let ctpText = ctpFlattenedArray.join(" ");

                                    try {
                                        ctpText = ctpText?.toLowerCase()
                                    } catch (error) {
                                        ctpText = ctpFlattenedArray.join(" ");
                                    }

                                    if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                        css = "#000000";
                                    } else {
                                        let pattern = new RegExp(`\\b${escapeRegExp(ptpe.trim())}\\b`, 'i');
                                        const ctpWordsArray = ctpText.split(' ');

                                        // Check if each word in ptpe is present in ctpWordsArray
                                        ptpe.split(' ').forEach((word) => {
                                            if (!ctpWordsArray.includes(word.trim())) {
                                                css = "#ff0000";
                                            }
                                        });

                                        if (!pattern.test(ctpText)) {
                                            css = "#ff0000";
                                        }
                                    }
                                    ct.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": css,
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": ptpe.trim() + " "
                                    });
                                });
                            }
                            else {
                                ct.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "#000000",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "v": e.trim() + "\r\n"
                                });
                            }
                        })
                    }
                    if (key === 'Document Viewer') {

                        const dvData = item[key];
                        if (dvData != undefined && dvData != null && dvData?.trim() != '') {
                            ct.push({
                                "ff": "\"Tahoma\"",
                                "fc": "rgb(61, 133, 198)",
                                "fs": `${fs}`,
                                "cl": 0,
                                "un": 0,
                                "bl": 0,
                                "it": 0,
                                "ht": "0",
                                "un": 1,
                                "v": "X-Ray"
                            });
                        } else {
                            ct.push({
                                "ff": "\"Tahoma\"",
                                "fc": "#000000",
                                "fs": `${fs}`,
                                "cl": 0,
                                "un": 0,
                                "bl": 0,
                                "it": 0,
                                "v": "  "
                            });
                        }
                    } else if (key === 'ActionOnDiscrepancy' || key === 'RequestEndorsement') {
                        // } else if (key === 'ActionOnDiscrepancy' || key === 'RequestEndorsement' || key === 'Notes') {
                        const dvData = item[key];
                        if (dvData == "" || dvData == undefined || dvData == null) {
                            ct.push({
                                "ff": "\"Tahoma\"",
                                "fc": "rgba(171, 160, 160, 0.957)",
                                "fs": `${fs}`,
                                "cl": 0,
                                "un": 0,
                                "bl": 0,
                                "it": 0,
                                "ht": "0",
                                "v": "Click here"
                            });
                        }
                    }
                    if (key === "PageNumber") {
                        const textOfct = ct[ct.length - 1]?.v?.replace('\r\n', ' ');
                        if (textOfct && ct?.length > 0) {
                            ct[ct.length - 1]["v"] = textOfct;
                        }
                    }
                    if (item[key]) {
                        const text = item[key];
                        if (typeof text === 'string') {
                            rowMaxValue = rowMaxValue < (text?.length / 2) + 10 ? (text?.length / 3 + 25) : rowMaxValue;
                        }
                    }

                    headerRows1Values.push({
                        r: rowIndex,
                        c: rIndex + 1,
                        v: {
                            ct: { fa: "General", t: "inlineStr", s: ct },
                            // m: item[key]?.replace(/~~/g, '\r\n'), 
                            // v: item[key]?.replace(/~~/g, '\r\n'), 
                            merge: null,
                            w: 55,
                            tb: '2',
                            "ht": key === 'Document Viewer' ? "0" : key === 'ActionOnDiscrepancy' ? "0" : key === 'RequestEndorsement' ? "0" :
                                key === 'Notes' ? "0" : null
                        }
                    });
                    let maxLength = 0;
                    const lengths = [];
                    Object.keys(item).forEach((key) => {
                        if (key != "Document Viewer") {
                            if (item[key]) {
                                lengths.push(item[key].length);
                            }
                        }
                    });
                    lengths.forEach((length) => {
                        if (length > maxLength) {
                            maxLength = length;
                        }
                    });
                    const rowHeight = parseInt(maxLength && maxLength > 30 ? maxLength / 3 + 15 : 20);
                    Policy_appDataConfig.demo.config.rowlen[`${rowIndex}`] = rowHeight;

                    if (rIndex == 0) {
                        Policy_appDataConfig.demo.config.rowlen[`${rowIndex}`] = rowHeight;
                    }
                });
                item["sheetPosition"] = rowIndexForStateData;
                return item;
            });
            // if ( dataForSavePolicy?.length > 0 ){
            //     const hasData = dataForSavePolicy?.filter( ( f ) => f?.tableName === tableName );
            //     if(hasData.length > 0){
            //         let trackingDataPolicy = dataForSavePolicy.map((e) => {
            //             if ( e?.TableName === tableName ){
            //                 e.data = dataToUpDate;
            //             }
            //             return e;
            //         });
            //         setDataForSavePolicy( trackingDataPolicy );
            //     }else{
            //         setDataForSavePolicy( [ ...dataForSavePolicy ,... [ { "TableName": tableName, "data": dataToUpDate } ]] );
            //     }
            // }else{
            //     setDataForSavePolicy( [ { "TableName": tableName, "data": dataToUpDate }]);
            // }

            const dataForReturn = [{ "TableName": tableName, "data": dataToUpDate }];
            const xRaydataForReturn = [{ dataToUpDate }];

            Policy_appDataConfig.demo.config.borderInfo.push({
                "rangeType": "range",
                "borderType": "border-all",
                "color": "#000",
                "style": "1",
                "range": [
                    {
                        "left": 74,
                        "width": 300,
                        "top": 470,
                        "height": 42,
                        "left_move": 74,
                        "width_move": 4213,
                        "top_move": 471,
                        "height_move": 1107,
                        "row": [
                            headerRows1[0]?.r,
                            headerRows1Values[headerRows1Values?.length - 1]?.r
                        ],
                        "column": [
                            headerRows1[0]?.c,
                            defaultHeaderRows1[defaultHeaderRows1?.length - 1]?.c
                        ],
                        "row_focus": headerRows1[0]?.r,
                        "column_focus": headerRows1[0]?.c
                    }
                ]
            });
            Policy_appDataConfig.demo.config.borderInfo.push({
                "rangeType": "range",
                "borderType": "border-all",
                "color": "#000",
                "style": "1",
                "range": [
                    {
                        "left": 74,
                        "width": 300,
                        "top": 470,
                        "height": 42,
                        "left_move": 74,
                        "width_move": 4213,
                        "top_move": 471,
                        "height_move": 1107,
                        "row": [
                            headerRows1[0]?.r,
                            headerRows1[0]?.r + (tableName == "Table 3" ? 2 : 1)
                        ],
                        "column": [
                            0,
                            0
                        ],
                        "row_focus": headerRows1[0]?.r,
                        "column_focus": headerRows1[0]?.c
                    }
                ]
            });
            defaultHeaderRows1.forEach(row => {
                if (row?.v && row?.v?.m && typeof row?.c === 'number' && row.v.m !== 'Actions on Discrepancy (from AMs)') {
                    tableColumnNamesOfValid[row.v.m] = row?.c;
                }
            });

            const groupingHeader = [{
                "r": headerRows1[0]?.r,
                "rs": tableName == "Table 3" ? 3 : 2,
                "c": 0,
                "cs": 1,
                "v": {
                    "ct": {
                        "fa": "General",
                        "t": "g"
                    },
                    "m": "Grouping",
                    "v": "Grouping",
                    "fs": 11,
                    "ff": "\"Tahoma\"",
                    "merge": null,
                    "bg": "rgb(139,173,212)",
                    "tb": "2",
                    "w": 55
                }
            }]

            headerRows1 = [...groupingHeader, ...headerRows1, ...defaultHeaderRows1, ...headerRows1Values];

            const allRows2 = [...headerRows1];
            allRows2.sort((a, b) => a.r - b.r);
            if (allRows2 && allRows2?.length > 0) {
                const tableColumnDetailss = tableColumnDetails;
                tableColumnDetailss[tableData2?.Tablename] = { "columnNames": tableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }
                setTableColumnDetails(tableColumnDetailss);
            }

            basedata.push(...allRows2);
            Policy_appDataConfig.demo.celldata = basedata;
            return {
                dataForReturn, xRaydataForReturn, tableColumnDetailsForXRay: [{ "TableName": tableName, "Data": xRaydataForReturn, "columnNames": tableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }],
                tableColumnDetailsForPolicySave: [{ "TableName": tableName, "columnNames": tableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }]
            };
        };
        if (canRenderChecklist) {
            csrTable1();
        }

        const csrformTable1 = () => {
            const formTableData1 = formCompareData.find((data) => data.Tablename === "FormTable 1");
            if (formTableData1) {
                const formtable1 = JSON.parse(formTableData1.TemplateData);

                let sheetDataTable3 = [];
                let sheetDataTable4 = [];
                const rowIndexOfTable1 = 3
                const formData = renderForm();
                formData.forEach((item, index) => {
                    const mergeConfig = FormCompare_appconfigdata.forms.config.merge["1_1"];
                    sheetDataTable3.push({
                        r: 1 + mergeConfig.r,
                        c: mergeConfig.c,
                        v: {
                            ct: item.ct,
                            m: item.m,
                            v: item.v,
                            fs: 13,
                            ff: item.ff,
                            merge: mergeConfig,
                            fc: item.fc,
                        }
                    });
                });

                formtable1.map((item, index) => {
                    if (item["Headers"] != null) {
                        // Calculate row height
                        let maxLength = 0;
                        const lengths = [];
                        Object.keys(item).forEach((key) => {
                            if (item[key]) {
                                lengths.push(item[key].length);
                            }
                        });
                        lengths.forEach((length) => {
                            if (length > maxLength) {
                                maxLength = length;
                            }
                        });
                        const rowHeight = parseInt(maxLength / 3 + 15);
                        FormCompare_appconfigdata.forms.config.rowlen[`${rowIndexOfTable1 + index}`] = rowHeight;

                        sheetDataTable4.push({
                            r: rowIndexOfTable1 + index,
                            c: 1,
                            v: {
                                ct: { fa: "@", t: "inlineStr", s: [{ v: item["Headers"], ff: "Tahoma" }] },
                                m: item["Headers"],
                                v: item["Headers"],
                                fs: 9,
                                ff: "Tahoma",
                                merge: null,
                                bg: "rgb(139,173,212)",
                                tb: '2',
                            }
                        });

                        const tidleValue = item["(No column name)"] !== null ? item["(No column name)"].replace(/~~/g, "\n") : "";
                        if (item['Headers']?.toLowerCase() === 'exdion csrdigit'.toLowerCase()) {
                            sheetDataTable4.push({
                                r: rowIndexOfTable1 + index,
                                c: 2,
                                v: {
                                    ct: { fa: "@", t: "inlineStr" },
                                    m: tidleValue,
                                    v: tidleValue,
                                    fs: 9,
                                    un: 1,
                                    fc: "#0b5394",
                                    ff: "\"Tahoma\"",
                                    merge: null,
                                    tb: '2',
                                }
                            });
                        } else {
                            sheetDataTable4.push({
                                r: rowIndexOfTable1 + index,
                                c: 2,
                                v: {
                                    ct: { fa: "@", t: "inlineStr" },
                                    m: tidleValue,
                                    v: tidleValue,
                                    ff: "\"Tahoma\"",
                                    merge: null,
                                    tb: '2',
                                }
                            });
                        }
                    }
                });

                const dummyData1 = [];
                const allFormRows = [...sheetDataTable4, ...sheetDataTable3];
                if (sheetDataTable4 && sheetDataTable4?.length > 0) {
                    const formTableColumnDetails1 = formTableColumnDetails;
                    formTableColumnDetails1["FormTable 1"] = { "columnNames": formtable1.map((e) => e?.Headers), "range": { "start": 0, "end": sheetDataTable4[sheetDataTable4?.length - 1]?.r } }
                    setFormTableColumnDetails(formTableColumnDetails1);
                }
                allFormRows.sort((a, b) => a.r - b.r);

                dummyData1.push(...allFormRows);
                FormCompare_appconfigdata.forms.celldata = dummyData1;

                allFormRows.forEach((row) => {
                    if (sheetDataTable4.includes(row)) {
                        FormCompare_appconfigdata.forms.config.borderInfo.push({
                            "rangeType": "cell",
                            "value": {
                                "row_index": row?.r,
                                "col_index": row?.c,
                                "l": {
                                    "style": 1,
                                    "color": "#000"
                                },
                                "r": {
                                    "style": 1,
                                    "color": "#000"
                                },
                                "t": {
                                    "style": 1,
                                    "color": "#000"
                                },
                                "b": {
                                    "style": 1,
                                    "color": "#000"
                                }
                            }
                        });
                    }
                });

                let formsCompareDataTracked = [];
                let positioningForFormsCompareData = [];
                let xRAyFormDataMap = [];
                formCompareData.map((e, index) => {
                    if (e?.Tablename != 'FormTable 1' && (e?.TemplateData?.length >= 3 || e?.TemplateData?.length < 3)) {
                        let filteredData = FormCompare_appconfigdata.forms.celldata.filter((f, index) => f != null || !f);
                        csrformTable2([...filteredData], e?.Tablename);
                        const trackedData = csrformTable2([...filteredData], e?.Tablename);
                        formsCompareDataTracked = [...formsCompareDataTracked, ...trackedData?.formsdataForReturn];
                        positioningForFormsCompareData = [...positioningForFormsCompareData, ...trackedData?.formTableColumnDetailsForSave];
                        xRAyFormDataMap = [...xRAyFormDataMap, ...trackedData?.formTableColumnDetailsForXRay];
                    }
                    if (formCompareData?.length === (index + 1)) {
                        setDataForSaveFormsCompare(formsCompareDataTracked);
                        sessionStorage.setItem('formsCompareDataTracked', JSON.stringify(formsCompareDataTracked))
                        setDataForSaveFormsComparePosition(positioningForFormsCompareData);
                        sessionStorage.setItem('positioningForFormsCompareData', JSON.stringify(positioningForFormsCompareData))
                        setFormDataForXRayMapping(xRAyFormDataMap);
                    }
                });
            }
            csrLuckySheet();
        }

        const csrformTable2 = (combinedata1, tableName) => {
            if (!Array.isArray(combinedata1)) {
                return;
            }
            const tableColumnNamesOfValid = {};
            const needDocumentViewer = true;
            const DefaultColumns = ["Actions on Discrepancy (from AMs)"];
            const basedata = [...combinedata1];

            const parsedData = formstate;
            const parseTemplateData = (data) => {
                return data.map(item => ({
                    ...item,
                    TemplateData: JSON.parse(item.TemplateData)
                }));
            };

            let formCompareData = parseTemplateData(parsedData);
            const isMatchedSection = formCompareData && formCompareData?.length > 0 ? formCompareData.filter((f) => f?.IsMatched === true)?.length > 0 : false;
            if (isMatchedSection) {
                formCompareData = formCompareData.map(({ "Document Viewer": _, ...rest }) => rest);
            }
            setFormsComparedata(formCompareData);

            let defaultText = updateData[0];
            let propsUpdateData = JSON.parse(defaultText.TemplateData);
            for (let i = 0; i < formCompareData.length; i++) {
                if (formCompareData[i].TemplateData.length === 0) {
                    formCompareData[i].TemplateData = propsUpdateData;
                }
            }

            formCompareData.forEach((data) => {
                if (data.TemplateData && Array.isArray(data.TemplateData)) {
                    data.TemplateData.forEach((template) => {
                        Object.keys(template).forEach((key) => {
                            if (template[key] === null) {
                                template[key] = '';
                            }
                        });
                    });
                }
            });

            const formTableData2 = formCompareData.find((data) => data.Tablename === tableName && data.TemplateData.length > 0);
            if (formTableData2?.TemplateData?.length > 0) {
                const headersKeys = Object.keys(formTableData2?.TemplateData[0]);
                headersKeys.forEach((column) => {
                    if (formTableData2?.TemplateData?.filter((f) => f[column] != null)?.length > 0 || (tableName === "FormTable 2" && formTableData2) || (tableName === "FormTable 3" && formTableData2)) {
                        tableColumnNamesOfValid[column] = 0
                    }
                });
            }

            if (!formTableData2) {
                return;
            }
            const formtable2copy = formTableData2.TemplateData;

            const formDataCopy = formtable2copy.map(obj => {
                let newObj = {};
                Object.keys(obj).forEach(key => {
                    if (obj[key] !== null) {
                        newObj[key] = obj[key];
                    }
                });
                return newObj;
            });

            const formtable2 = formDataCopy.map(item => {
                const {
                    JobId,
                    Jobid,
                    CreatedOn,
                    UpdatedOn,
                    columnid,
                    IsMatched,
                    ...filteredItem
                } = item;
                return filteredItem;

            });
            const header = Object.keys(formtable2[0]);
            const value = Object.values(formtable2);
            const policyLOBValues = value?.map(item => item["Policy LOB"]);
            const tableNameMap = formDataCopy?.map(e => e.IsMatched)[0];

            let headerRows1 = [];
            let rowIndexForLOBStart = 0;
            let rowIndexForLOBEnd = 0;

            if (tableName === "FormTable 2" || tableName === "FormTable 3") {
                rowIndexForLOBStart = basedata[basedata?.length - 1]?.r + 2;
                headerRows1 = [
                    {
                        r: basedata[basedata?.length - 1]?.r + 2,
                        rs: 1,
                        c: 1,
                        cs: header.length + 1,
                        v: {
                            ct: { fa: "General", t: "g" },
                            m: tableNameMap == true ? "Matched Forms" : "Unmatched Forms",
                            v: tableNameMap == true ? "Matched Forms" : "Unmatched Forms",
                            fs: 9,
                            ff: "\"Tahoma\"",
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                ]
            };

            let excludedColumns;
            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                excludedColumns = ["Policy LOB", "Checklist Questions", "Observation", "PageNumber", "OBSERVATION", "Page Number", "Id", "RequestEndorsement"];
            } else {
                excludedColumns = ["Policy LOB", "Checklist Questions", "Observation", "PageNumber", "OBSERVATION", "Page Number", "Id"];
            }

            let headers = Object.keys(formtable2[0]).filter(headerw => !excludedColumns.includes(headerw));

            const AODColumnKeys = ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];

            // const filteredHeadersForEndorsement = brokerId === "1003"  
            const filteredHeadersForEndorsement = AODDBrokerIds.includes(brokerId)
                ? headers :
                headers.filter(item => !AODColumnKeys.includes(item))

            const removalCode = filteredHeadersForEndorsement.map(item => (item === "COVERAGE_SPECIFICATIONS_MASTER") ? policyLOBValues[0] : item);

            headerRows1 = [
                ...headerRows1,
                ...removalCode.map((item, index) => {
                    // if(brokerId != "1003" && index === 0){
                    if (AODDBrokerIds.includes(brokerId) && index === 0) {
                        if (!AODColumnKeys?.includes(item)) {
                            FormCompare_appconfigdata.forms.config.merge[`${basedata[basedata?.length - 1]?.r + 3}_${index + 1}`] = {
                                "r": basedata[basedata?.length - 1]?.r + 3,
                                "c": index,
                                "rs": 3,
                                "cs": 1
                            }
                        }
                    }
                    if (!AODColumnKeys?.includes(item)) {
                        FormCompare_appconfigdata.forms.config.merge[`${basedata[basedata?.length - 1]?.r + 3}_${1 + index}`] = {
                            "r": basedata[basedata?.length - 1]?.r + 3,
                            "c": 1 + index,
                            "rs": 2,
                            "cs": 1
                        }
                    }

                    // if (removalCode?.length === index + 1) {
                    //     rowIndexForLOBEnd = headerRows1.length + index + 1;
                    // }
                    return {
                        r: basedata[basedata?.length - 1]?.r + 3 + (AODColumnKeys?.includes(item) ? 1 : 0),
                        rs: 2,
                        c: 1 + index,
                        cs: 1,
                        v: {
                            ct: { fa: "General", t: "g" },
                            m: item,
                            v: item,
                            fs: 9,
                            ff: "\"Tahoma\"",
                            merge: null,
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                })
            ];

            if (headerRows1?.length > 0) {
                headerRows1.forEach((f, index) => {
                    if (tableName === "FormTable 3" && (index === 0 || index === 1)) {
                        tableColumnNamesOfValid["COVERAGE_SPECIFICATIONS_MASTER"] = f?.c;
                    } else if (index === 0) {
                        tableColumnNamesOfValid["COVERAGE_SPECIFICATIONS_MASTER"] = f?.c;
                    } else {
                        tableColumnNamesOfValid[f?.v?.v] = f?.c;
                    }
                });
            }

            if (needDocumentViewer) {
                const DocumentViewer = [{
                    r: basedata[basedata?.length - 1]?.r + 3,
                    rs: 2,
                    c: 1 + headerRows1[headerRows1?.length - 1]?.c,
                    cs: 1,
                    v: {
                        ct: { fa: "General", t: "g" },
                        m: 'Document Viewer',
                        v: 'Document Viewer',
                        ff: "\"Tahoma\"",
                        merge: null,
                        bg: "rgb(139,173,212)",
                        tb: '2',
                        w: 55,
                    }
                }];

                // headerRows1 = [...headerRows1, ...DocumentViewer];
                headerRows1 = [...headerRows1];
            }

            const defaultHeaderRows1 = DefaultColumns.map((item, index) => {
                if (DefaultColumns?.length === index + 1) {
                    rowIndexForLOBEnd = headerRows1.length + index + 1;
                }
                // if (brokerId != "1003" && index == 0) {
                if (AODDBrokerIds.includes(brokerId) && index == 0) {
                    FormCompare_appconfigdata.forms.config.merge[`${basedata[basedata?.length - 1]?.r + 3}_${reqEndorsementColHideBrokerId.includes(brokerId) ? headerRows1.length - 3 : headerRows1.length - 4}`] = {
                        "r": basedata[basedata?.length - 1]?.r + 3,
                        "c": reqEndorsementColHideBrokerId.includes(brokerId) ? headerRows1.length - 3 : headerRows1.length - 4,
                        "rs": 1,
                        "cs": reqEndorsementColHideBrokerId.includes(brokerId) ? 3 : 4,
                    }
                    return {
                        r: basedata[basedata?.length - 1]?.r + 3,
                        rs: 1,
                        c: reqEndorsementColHideBrokerId.includes(brokerId) ? headerRows1.length - 3 : headerRows1.length - 4,
                        cs: 1,
                        v: {
                            ht: 0,
                            ct: { fa: "General", t: "g" },
                            m: item,
                            v: item,
                            fs: 9,
                            ff: "\"Tahoma\"",
                            merge: null,
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                }
                else {
                    return {
                        r: basedata[basedata?.length - 1]?.r + 3,
                        rs: 1,
                        c: headerRows1.length + index - 1,
                        cs: 1,
                        v: {
                            ct: { fa: "General", t: "g" },
                            m: item,
                            v: item,
                            fs: 9,
                            ff: "\"Tahoma\"",
                            merge: null,
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                }
            });

            if (tableName === "FormTable 2" || tableName === "FormTable 3") {
                FormCompare_appconfigdata.forms.config.merge[`${rowIndexForLOBStart}_${1}`] = {
                    "r": rowIndexForLOBStart,
                    "c": 1,
                    "rs": 1,
                    "cs": rowIndexForLOBEnd - 2
                }
            }

            let headerRows1Values = [];
            let fs = 9;

            function splitWordsWithComma(array) {
                if (!array || array.length === 0) {
                    return [];
                }
                let newArray = [];

                array.forEach((word) => {
                    // Check if the word ends with a comma
                    word = word.trim();
                    if (word.endsWith(',')) {
                        const wordWithoutComma = word.slice(0, -1).trim();
                        // Add the word without the comma as a separate character, excluding leading spaces
                        if (wordWithoutComma !== '') {
                            newArray.push(wordWithoutComma);
                        }
                        newArray.push(',');
                    } else if (word.includes('(') && word.includes(')')) {
                        // If the word contains both '(' and ')', split them into separate characters
                        const openingParen = word.indexOf('(');
                        const closingParen = word.indexOf(')');
                        const beforeParen = word.slice(0, openingParen);
                        const insideParen = word.slice(openingParen + 1, closingParen);
                        const afterParen = word.slice(closingParen + 1);
                        if (beforeParen !== '') {
                            newArray.push(beforeParen);
                        }
                        newArray.push('(');
                        if (insideParen !== '') {
                            newArray.push(insideParen);
                        }
                        newArray.push(')');
                        if (afterParen !== '') {
                            newArray.push(afterParen);
                        }
                    } else if (word.includes('(')) {
                        // If the word contains an open parenthesis, split it into separate characters
                        const openingParen = word.indexOf('(');
                        const beforeParen = word.slice(0, openingParen);
                        const insideParen = word.slice(openingParen + 1);
                        if (beforeParen !== '') {
                            newArray.push(beforeParen);
                        }
                        newArray.push('(');
                        if (insideParen !== '') {
                            newArray.push(insideParen);
                        }
                    } else if (word.includes(')')) {
                        // If the word contains a closing parenthesis, split it into separate characters
                        let closingParen = word.indexOf(')');
                        let insideParen = word.slice(0, closingParen).trim();
                        const afterParen = word.slice(closingParen + 1);
                        if (insideParen !== '') {
                            newArray.push(insideParen);
                        }
                        newArray.push(')');
                        if (afterParen !== '') {
                            newArray.push(afterParen);
                        }
                    } else {
                        // If no comma, just add the word to the new array
                        newArray.push(word);
                    }
                });

                return newArray;
            }

            let rowIndex = basedata[basedata?.length - 1]?.r + 5;
            let dataToUpDate = formtable2.map((item, cIndex) => {
                let rowIndexForStateData = 0;
                // let filteredHeadersForEndorsement = brokerId === "1003" ? headers.filter(item => !AODColumnKeys.includes(item)) : headers;
                let filteredHeadersForEndorsement = AODDBrokerIds.includes(brokerId) ? headers : headers.filter(item => !AODColumnKeys.includes(item));
                filteredHeadersForEndorsement.map((key, rIndex) => {
                    if (item[key] !== null) {
                        rowIndex = headerRows1Values?.length == 0 ? rowIndex : headerRows1Values?.length > 0 && rIndex == 0 ? headerRows1Values[headerRows1Values.length - 1]?.r + 1 : headerRows1Values[headerRows1Values.length - 1]?.r;
                        rowIndexForStateData = rowIndex;
                        let text = item[key].toString().split('~~');
                        let ss = [];
                        if (key != "Document Viewer" && text && text?.length > 0) {
                            text.map((e, splitIndex) => {
                                if (e.toLowerCase().includes('page')) {
                                    ss.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": "rgb(68, 114, 196)",
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": "\r\n" + e.trim()
                                    });
                                }
                                else if (key === "Prior Term Policy Attached"
                                    && item["Prior Term Policy Attached"]?.trim() !== item["Current Term Policy Attached"]?.trim()
                                    && !(item["Prior Term Policy Attached"]?.toLowerCase().replace(/\\r\\n/g, '').includes("details not available in the document")
                                        || item["Current Term Policy Attached"]?.toLowerCase().replace(/\\r\\n/g, '').includes("details not available in the document"))) {

                                    let ptpSplitArray = item["Prior Term Policy Attached"]?.split('~~')[0]?.split(" ");
                                    let ctpSplitArray = item["Current Term Policy Attached"]?.split('~~')[0]?.split(" ");

                                    const ptpFlattenedArray = splitWordsWithComma(ptpSplitArray);
                                    const ctpFlattenedArray = splitWordsWithComma(ctpSplitArray);

                                    if (ctpFlattenedArray && ctpFlattenedArray.length > 0) {
                                        for (let i = 0; i < ptpFlattenedArray.length; i++) {
                                            let ptpe = ptpFlattenedArray[i].trim();
                                            let ctp = ctpFlattenedArray[i]?.trim();
                                            let css = "#000000"; // Default color

                                            // Apply specific CSS color if certain characters are present
                                            if (ptpe.includes("$||") || ptpe.includes("||") || ptpe.includes("(") || ptpe.includes(")")) {
                                                css = "#000000";
                                            } else {
                                                // Set color to red if there's a mismatch at the same index
                                                if (ptpe !== ctp) {
                                                    css = "#ff0000";
                                                }
                                            }

                                            ss.push({
                                                "ff": "\"Tahoma\"",
                                                "fc": css,
                                                "fs": `${fs}`,
                                                "cl": 0,
                                                "un": 0,
                                                "bl": 0,
                                                "it": 0,
                                                "v": ptpe + " "
                                            });
                                        }
                                    }
                                }
                                else {
                                    ss.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": "#000000",
                                        "fs": `${fs}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": e.trim() + " "
                                    });
                                }
                            });
                        }
                        if (key === "Document Viewer") {
                            const dvData = item[key];
                            if (dvData != undefined && dvData != null && dvData?.trim() != '') {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(61, 133, 198)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 1,
                                    "bl": 0,
                                    "it": 0,
                                    "ht": "0",
                                    "v": "X-Ray"
                                });
                            }
                        }
                        // if ( brokerId != "1003" && (key === 'ActionOnDiscrepancy' || key === 'RequestEndorsement' || key === 'Notes')) {
                        if (AODDBrokerIds.includes(brokerId) && (key === 'ActionOnDiscrepancy' || key === 'RequestEndorsement' || key === 'Notes')) {
                            const dvData = item[key];
                            if (dvData == "" || dvData == undefined || dvData == null) {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgba(171, 160, 160, 0.957)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "ht": "0",
                                    "v": "Click here"
                                });
                            }
                        }
                        headerRows1Values.push({
                            r: rowIndex,
                            c: rIndex + 1,
                            v: {
                                ct: { fa: "General", t: "inlineStr", s: ss },
                                merge: null,
                                w: 55,
                                ff: "\"Tahoma\"",
                                tb: '2',
                                "ht": key === 'Document Viewer' ? "0" : key === 'ActionOnDiscrepancy' ? "0" : key === 'RequestEndorsement' ? "0" :
                                    key === 'Notes' ? "0" : null
                            }
                        });
                        let maxLength = 0;
                        const lengths = [];

                        Object.keys(item).forEach((key) => {
                            if (item[key]) {
                                lengths.push(item[key].length);
                            }
                        });
                        lengths.forEach((length) => {
                            if (length > maxLength) {
                                maxLength = length;
                            }
                        });
                        const len = maxLength > 100 ? 40 : maxLength;
                        const rowHeight = parseInt(len);
                        FormCompare_appconfigdata.forms.config.rowlen[`${rowIndex}`] = rowHeight;

                        if (rIndex == 0) {
                            FormCompare_appconfigdata.forms.config.rowlen[`${rowIndex}`] = rowHeight;
                        }
                    }
                })
                item["sheetPosition"] = rowIndexForStateData;
                return item;
            });

            const formsdataForReturn = [{ "TableName": tableName, "data": dataToUpDate }];
            const xRayformsdataForReturn = [{ dataToUpDate }];

            FormCompare_appconfigdata.forms.config.borderInfo.push({
                "rangeType": "range",
                "borderType": "border-all",
                "color": "#000",
                "style": "1",
                "range": [
                    {
                        "left": 74,
                        "width": 300,
                        "top": 470,
                        "height": 42,
                        "left_move": 74,
                        "width_move": 4213,
                        "top_move": 471,
                        "height_move": 1107,
                        "row": [
                            headerRows1[0]?.r,
                            headerRows1Values[headerRows1Values?.length - 1]?.r
                        ],
                        "column": [
                            headerRows1[0]?.c,
                            headerRows1Values[headerRows1Values?.length - 1]?.c
                        ],
                        "row_focus": headerRows1[0]?.r,
                        "column_focus": headerRows1[0]?.c
                    }
                ]
            });


            // if(brokerId === "1003") {
            if (!AODDBrokerIds.includes(brokerId)) {
                headerRows1 = [...headerRows1, ...headerRows1Values];
            } else {
                headerRows1 = [...headerRows1, ...defaultHeaderRows1, ...headerRows1Values];
            }

            const allRows2 = [...headerRows1];
            if (allRows2 && allRows2?.length > 0) {
                const formTableColumnDetailss = formTableColumnDetails;
                formTableColumnDetailss[formTableData2?.Tablename] = { "columnNames": tableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }
                setFormTableColumnDetails(formTableColumnDetailss);
            }
            allRows2.sort((a, b) => a.r - b.r);

            basedata.push(...allRows2);
            FormCompare_appconfigdata.forms.celldata = basedata;
            return {
                formsdataForReturn, xRayformsdataForReturn, formTableColumnDetailsForXRay: [{ "TableName": tableName, "Data": xRayformsdataForReturn, "columnNames": tableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }],
                formTableColumnDetailsForSave: [{ "TableName": tableName, "columnNames": tableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }]
            };
        };
        if (canRenderFormData) {
            csrformTable1();
        }

        const csrexclusionTable = () => {
            const basedata = [];
            let data = exclusionData;
            if(!isSelectedEnabled){
               data = data?.map(({ Selected, ...rest }) => rest)
            }
            const dataMap = data;
            const needDocumentViewer = true;
            const tableColumnNamesOfValid = {};
            let headersKeys = Object.keys(dataMap[0]);

            let DefaultColumns;
            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                DefaultColumns = ["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
            } else {
                DefaultColumns = ["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
            }

            if (dataMap?.length > 0) {
                headersKeys.forEach((column) => {
                    tableColumnNamesOfValid[column] = 0
                });
            }

            if (dataMap && dataMap?.length > 0 && !Array.isArray(dataMap[0])) {
                const exclusionjson = dataMap.map(item => {
                    const {
                        JobId,
                        CreatedOn,
                        UpdatedOn,
                        ConfidenceScore,
                        ExclusionFeedback,
                        ...filteredItem
                    } = item;
                    return filteredItem;
                });

                let excludedColumns;
                if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                    excludedColumns = ["Id", "ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
                } else {
                    excludedColumns = ["Id", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
                }

                let headers = Object.keys(exclusionjson[0]).filter(headerw => !excludedColumns.includes(headerw));
                headers = headers.filter(f => !["ActionOnDiscrepancy", "RequestEndorsement", "NotesFreeFill", "Notes"]?.includes(f));
                let headerRows1 = headers.map((item, index) => {
                    const displayHeader = item === "Exclusion" ? "Exclusions" : item;
                    Exclusion_appDataConfig.exclusions.config.merge[`${0}_${index}`] = {
                        "r": 0,
                        "c": index,
                        "rs": 2,
                        "cs": 1
                    }
                    return {
                        r: 0,
                        rs: 2,
                        c: index,
                        cs: 1,
                        v: {
                            ct: { fa: "General", t: "g" },
                            m: displayHeader,
                            v: displayHeader,
                            fs: 10,
                            ff: "\"Tahoma\"",
                            merge: null,
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                });

                headerRows1 = [...headerRows1];

                const defaultHeaderRows1 = DefaultColumns.map((item, index) => {
                    if (index == 0) {
                        Exclusion_appDataConfig.exclusions.config.merge[`${headerRows1[headerRows1?.length - 1]?.r}_${headerRows1.length + index}`] = {
                            "r": headerRows1[headerRows1?.length - 1]?.r,
                            "c": isSelectedEnabled ? (reqEndorsementColHideBrokerId.includes(brokerId) ? 5 : 6) : (reqEndorsementColHideBrokerId.includes(brokerId) ? 4 : 5),
                            "rs": 1,
                            "cs": reqEndorsementColHideBrokerId.includes(brokerId) ? 3 : 4,
                        }
                        return {
                            r: headerRows1[headerRows1?.length - 1]?.r,
                            rs: 1,
                            c: headerRows1.length,
                            cs: 1,
                            v: {
                                ht: 0,
                                ct: { fa: "General", t: "g" },
                                m: item,
                                v: item,
                                fs: 11,
                                ff: "\"Tahoma\"",
                                merge: null,
                                bg: "rgb(139,173,212)",
                                tb: '2',
                                w: 55,
                            }
                        }
                    }
                    else {
                        return {
                            r: headerRows1[headerRows1?.length - 1]?.r + 1,
                            rs: 1,
                            c: headerRows1.length + index - 1,
                            cs: 1,
                            v: {
                                ct: { fa: "General", t: "g" },
                                m: item,
                                v: item,
                                fs: 11,
                                ff: "\"Tahoma\"",
                                merge: null,
                                bg: "rgb(139,173,212)",
                                tb: '2',
                                w: 55,
                            }
                        }
                    }
                });

                let headerRows1Values = [];
                let rowIndex = defaultHeaderRows1[defaultHeaderRows1.length - 1]?.r + 1;
                let rowHeight = 60;
                let fs = 9;
                let dataToUpDate = exclusionjson.map((item, indexr) => {
                    let actionColumnKeys;
                    if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                        actionColumnKeys = ["ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
                    } else {
                        actionColumnKeys = ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
                    }
                    // if(brokerId != "1003") { 
                    if (AODDBrokerIds.includes(brokerId)) {
                        headers = [...headers, ...actionColumnKeys];
                    } else {
                        headers = [...headers];
                    }
                    let uniqueHeaderSet = Array.from(new Set(headers))
                    let rowIndexForStateData = 0;
                    uniqueHeaderSet.map((key, rIndex) => {
                        // if(item[key] != null) {
                        rowIndexForStateData = indexr + 2;
                        let text = item[key] != null ? item[key].toString().split('~~') : [];
                        let ss = [];
                        if (key != 'Document Viewer' && text && text?.length > 0) {
                            text.map((e) => {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "#000000",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "v": e.trim() + "\r\n"
                                });
                            }
                            );
                        }

                        if (key === "Document Viewer") {
                            const dvData = item[key];
                            if (dvData != undefined && dvData != null && dvData?.trim() != '') {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(61, 133, 198)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "ht": "0",
                                    "un": 1,
                                    "v": "X-Ray"
                                });
                            }
                            //  else {
                            //     ss.push({
                            //         "ff": "\"Tahoma\"",
                            //         "fc": "rgb(61, 133, 198)",
                            //         "fs": `${fs}`,
                            //         "cl": 0,
                            //         "un": 1,
                            //         "bl": 0,
                            //         "it": 0,
                            //         "ht": "0",
                            //         "v": " "
                            //     });
                            // }
                        }

                        if (AODDBrokerIds.includes(brokerId) && (key === 'ActionOnDiscrepancy' || key === 'RequestEndorsement' || key === 'Notes')) {
                            const dvData = item[key];
                            if (dvData == "" || dvData == undefined || dvData == null) {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgba(171, 160, 160, 0.957)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "ht": "0",
                                    "v": "Click here"
                                });
                            }
                        }
                        headerRows1Values.push({
                            r: rowIndex + indexr,
                            c: rIndex,
                            v: {
                                ct: { fa: "General", t: "inlineStr", s: ss },
                                merge: null,
                                w: 55,
                                ff: "\"Tahoma\"",
                                tb: '2',
                                "ht": key === 'Document Viewer' ? "0" : key === 'ActionOnDiscrepancy' ? "0" : key === 'RequestEndorsement' ? "0" :
                                    key === 'Notes' ? "0" : null
                            }
                        });

                        let maxLength = 0;
                        const lengths = [];

                        Object.keys(item).forEach((key) => {
                            if (item[key]) {
                                lengths.push(item[key].length);
                            }
                        });
                        lengths.forEach((length) => {
                            if (length > maxLength) {
                                maxLength = length;
                            }
                        });
                        const len = maxLength > 100 ? 60 : maxLength;
                        const rowHeight = parseInt(len);
                        Exclusion_appDataConfig.exclusions.config.rowlen[`${rowIndex + indexr}`] = rowHeight;

                        if (rIndex == 0) {
                            Exclusion_appDataConfig.exclusions.config.rowlen[`${rowIndex}`] = 60;
                        }

                        // if (text && rowHeight < parseInt(item[key]?.length / 2 + 10)) {
                        //     rowHeight = parseInt(item[key]?.length / 2 + 10);
                        //     Exclusion_appDataConfig.exclusion.config.rowlen[`${rowIndex}`] = rowHeight;
                        // }
                        // }
                    })
                    item["sheetPosition"] = rowIndexForStateData;
                    return item;
                });

                const exclusionTableForReturn = [{ "TableName": "ExTable 1", "data": dataToUpDate }];
                const xRayexclusiondataForReturn = [{ dataToUpDate }];
                Exclusion_appDataConfig.exclusions.config.borderInfo.push({
                    "rangeType": "range",
                    "borderType": "border-all",
                    "color": "#000",
                    "style": "1",
                    "range": [
                        {
                            "left": 74,
                            "width": 300,
                            "top": 470,
                            "height": 42,
                            "left_move": 74,
                            "width_move": 4213,
                            "top_move": 471,
                            "height_move": 1107,
                            "row": [
                                headerRows1[0]?.r,
                                headerRows1Values[headerRows1Values?.length - 1]?.r
                            ],
                            "column": [
                                headerRows1[0]?.c,
                                // brokerId != "1003" ? 7 : 3,
                                reqEndorsementColHideBrokerId.includes(brokerId) ? 6 : AODDBrokerIds.includes(brokerId) ? isSelectedEnabled ? 9 : 8 : 4,
                            ],
                            "row_focus": headerRows1[0]?.r,
                            "column_focus": headerRows1[0]?.c
                        }
                    ]
                });

                // if(brokerId != "1003") {
                if (AODDBrokerIds.includes(brokerId)) {
                    headerRows1 = [...headerRows1, ...defaultHeaderRows1, ...headerRows1Values];
                } else {
                    headerRows1 = [...headerRows1, ...headerRows1Values];
                }

                const allRows2 = [...headerRows1];
                if (headerRows1 && headerRows1?.length > 0) {


                    const ExTableColumnDetails = exTableColumnDetails;
                    if (headerRows1?.length > 0) {

                        const columnHeaderss = Object.keys(tableColumnNamesOfValid);
                        headerRows1.forEach((f, index) => {
                            let cellValue = f?.v?.v;
                            if (columnHeaderss.includes(f?.v?.m) || columnHeaderss.includes(f?.v?.v)) {
                                tableColumnNamesOfValid[f?.v?.v] = f?.c;
                            } else if (cellValue === "Exclusions" && columnHeaderss.includes("Exclusion")) {
                                // Map the new header name to the old data key index
                                tableColumnNamesOfValid["Exclusion"] = f?.c;
                                tableColumnNamesOfValid["Exclusions"] = f?.c;
                            }
                        });
                    }

                    ExTableColumnDetails["ExTable 1"] = {
                        "columnNames": tableColumnNamesOfValid,
                        "range": {
                            "start": 0,
                            "end": headerRows1[headerRows1.length - 1]?.r
                        }
                    };
                    setExTableColumnDetails(ExTableColumnDetails);
                }

                allRows2.sort((a, b) => a.r - b.r);
                basedata.push(...allRows2);
                Exclusion_appDataConfig.exclusions.celldata = basedata;

                let exclusionDataTracked = [];
                let positioningForexclusionData = [];
                let xRAyExclusionDataMap = [];
                xRAyExclusionDataMap.push({
                    Data: exclusionTableForReturn,
                    columnNames: exTableColumnDetails["ExTable 1"]?.columnNames,
                    range: {
                        start: allRows2[0]?.r,
                        end: allRows2[allRows2?.length - 1]?.r
                    }
                });

                sessionStorage.setItem('positioningForexclusionData', JSON.stringify(xRAyExclusionDataMap))
                // exclusionData.map((index) => {
                // if (exclusionData?.length === (index + 1)) {
                exclusionDataTracked.push(exclusionTableForReturn);
                setDataForSaveExclusion([...exclusionDataTracked]);
                sessionStorage.setItem('exclusionDataTracked', JSON.stringify(exclusionDataTracked))
                setDataForSaveExclusionPosition([...positioningForexclusionData]);
                setExclusionDataForXRayMapping([...xRAyExclusionDataMap]);
                // }
                // });
                return {
                    exclusionTableForReturn, xRayexclusiondataForReturn
                };
            }
        };
        if (canRenderExclusionData) {
            csrexclusionTable();
        }
        
        // const csrproposalTable = () => {
        //     const basedata = [];
        //     const dataMap = proposalstate;
        //     if (
        //         !dataMap ||
        //         !Array.isArray(dataMap) ||
        //         dataMap.length === 0
        //     ) {
        //         return;
        //     }
        //     const tableColumnNamesOfValid = {};
        //     let headersKeys = Object.keys(dataMap[0]);
        //     let DefaultColumns;
        //     if (reqEndorsementColHideBrokerId.includes(brokerId)) {
        //         DefaultColumns = ["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
        //     } else {
        //         DefaultColumns = ["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
        //     }

        //     if (dataMap?.length > 0) {
        //         headersKeys.forEach((column) => {
        //             tableColumnNamesOfValid[column] = 0
        //         });
        //     }

        //     Proposal_appDataConfig.proposal.celldata = [];
        //     Proposal_appDataConfig.proposal.config.merge = {};

        //     const proposalColumnOrder = [
        //         "FormName",
        //         "FormDescription",
        //         "Proposal",
        //         "PageNumber",
        //         "Selected",
        //         "Document Viewer"
        //     ];

        //     // const actionColumns = [
        //     //     "ActionOnDiscrepancy",
        //     //     "RequestEndorsement",
        //     //     "Notes",
        //     //     "NotesFreeFill"
        //     // ];
        //     let actionColumns;
        //     if (reqEndorsementColHideBrokerId.includes(brokerId)) {
        //         actionColumns = ["ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
        //     } else {
        //         actionColumns = ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
        //     }

        //     proposalColumnOrder.forEach((columnName, index) => {
        //         Proposal_appDataConfig.proposal.config.merge[`${0}_${index}`] = {
        //             r: 0,
        //             c: index,
        //             rs: 2,
        //             cs: 1
        //         };

        //         basedata.push({
        //             r: 0,
        //             rs: 2,
        //             c: index,
        //             cs: 1,
        //             v: {
        //                 ct: {
        //                     fa: "General",
        //                     t: "g"
        //                 },
        //                 m: columnName,
        //                 v: columnName,
        //                 fs: 10,
        //                 ff: "\"Tahoma\"",
        //                 merge: null,
        //                 bg: "rgb(139,173,212)",
        //                 tb: "2",
        //                 w: 55
        //             }
        //         });
        //     });

        //     const actionStartColumn = proposalColumnOrder.length; // 6 = G
        //     Proposal_appDataConfig.proposal.config.merge[
        //         `${0}_${actionStartColumn}`
        //     ] = {
        //         r: 0,
        //         c: actionStartColumn,
        //         rs: 1,
        //         cs: actionColumns.length
        //     };

        //     basedata.push({
        //         r: 0,
        //         rs: 1,
        //         c: actionStartColumn,
        //         cs: actionColumns.length,
        //         v: {
        //             ht: 0,
        //             ct: {
        //                 fa: "General",
        //                 t: "g"
        //             },
        //             m: "Actions on Discrepancy (from AMs)",
        //             v: "Actions on Discrepancy (from AMs)",
        //             fs: 11,
        //             ff: "\"Tahoma\"",
        //             merge: null,
        //             bg: "rgb(139,173,212)",
        //             tb: "2",
        //             w: 55
        //         }
        //     });

        //     actionColumns.forEach((columnName, index) => {
        //         basedata.push({
        //             r: 1,
        //             rs: 1,
        //             c: actionStartColumn + index,
        //             cs: 1,
        //             v: {
        //                 ct: {
        //                     fa: "General",
        //                     t: "g"
        //                 },
        //                 m: columnName,
        //                 v: columnName,
        //                 fs: 11,
        //                 ff: "\"Tahoma\"",
        //                 merge: null,
        //                 bg: "rgb(139,173,212)",
        //                 tb: "2",
        //                 w: 55
        //             }
        //         });
        //     });

        //     dataMap?.forEach((item, rowIndex) => {
        //         const actualRow = rowIndex + 2;
        //         proposalColumnOrder.forEach((columnName, columnIndex) => {
        //             let value = item?.[columnName];
        //             if (
        //                 value === null ||
        //                 value === undefined
        //             ) {
        //                 value = "";
        //             }

        //             let ss = [];
        //             if (columnName === "Document Viewer") {
        //                 if (
        //                     value !== undefined &&
        //                     value !== null &&
        //                     value.toString().trim() !== ""
        //                 ) {
        //                     ss.push({
        //                         ff: "\"Tahoma\"",
        //                         fc: "rgb(61, 133, 198)",
        //                         fs: 9,
        //                         cl: 0,
        //                         bl: 0,
        //                         it: 0,
        //                         ht: "0",
        //                         un: 1,
        //                         v: "X-Ray"
        //                     });
        //                 }

        //             } else if (value !== "") {
        //                 ss.push({
        //                     ff: "\"Tahoma\"",
        //                     fc: "#000000",
        //                     fs: 9,
        //                     cl: 0,
        //                     un: 0,
        //                     bl: 0,
        //                     it: 0,
        //                     v: value.toString()
        //                 });
        //             }

        //             basedata.push({
        //                 r: actualRow,
        //                 c: columnIndex,
        //                 v: {
        //                     ct: {
        //                         fa: "General",
        //                         t: "inlineStr",
        //                         s: ss
        //                     },
        //                     merge: null,
        //                     w: 55,
        //                     ff: "\"Tahoma\"",
        //                     tb: "2",
        //                     ht: columnName === "Document Viewer" ? "0" : null
        //                 }
        //             });
        //         });

        //         actionColumns.forEach((columnName, index) => {
        //             let value = item?.[columnName];
        //             if (
        //                 value === null ||
        //                 value === undefined
        //             ) {
        //                 value = "";
        //             }

        //             let ss = [];
        //             if (value !== "") {
        //                 ss.push({
        //                     ff: "\"Tahoma\"",
        //                     fc: "#000000",
        //                     fs: 9,
        //                     cl: 0,
        //                     un: 0,
        //                     bl: 0,
        //                     it: 0,
        //                     v: value.toString()
        //                 });

        //             } else if (
        //                 columnName === "ActionOnDiscrepancy" ||
        //                 columnName === "RequestEndorsement" ||
        //                 columnName === "Notes"
        //             ) {

        //                 // Same "Click here" behavior as CSR Exclusion
        //                 ss.push({
        //                     ff: "\"Tahoma\"",
        //                     fc: "rgba(171, 160, 160, 0.957)",
        //                     fs: 9,
        //                     cl: 0,
        //                     un: 0,
        //                     bl: 0,
        //                     it: 0,
        //                     ht: "0",
        //                     v: "Click here"
        //                 });
        //             }

        //             basedata.push({
        //                 r: actualRow,
        //                 c: actionStartColumn + index,
        //                 v: {
        //                     ct: {
        //                         fa: "General",
        //                         t: "inlineStr",
        //                         s: ss
        //                     },
        //                     merge: null,
        //                     w: 55,
        //                     ff: "\"Tahoma\"",
        //                     tb: "2",
        //                     ht:
        //                         columnName === "ActionOnDiscrepancy" ||
        //                         columnName === "RequestEndorsement" ||
        //                         columnName === "Notes"
        //                             ? "0"
        //                             : null
        //                 }
        //             });
        //         });

        //         // Row height
        //         Proposal_appDataConfig.proposal.config.rowlen[
        //             `${actualRow}`
        //         ] = 60;
        //     });

        //     basedata.sort((a, b) => {
        //         if (a.r !== b.r) {
        //             return a.r - b.r;
        //         }

        //         return a.c - b.c;
        //     });

        //     Proposal_appDataConfig.proposal.config.borderInfo = [];
        //     Proposal_appDataConfig.proposal.config.borderInfo.push({
        //         rangeType: "range",
        //         borderType: "border-all",
        //         color: "#000",
        //         style: "1",
        //         range: [
        //             {
        //                 left: 74,
        //                 width: 300,
        //                 top: 470,
        //                 height: 42,
        //                 left_move: 74,
        //                 width_move: 4213,
        //                 top_move: 471,
        //                 height_move: 1107,

        //                 row: [
        //                     0,
        //                     proposalstate.length + 1
        //                 ],

        //                 column: [
        //                     0,
        //                     9
        //                 ],

        //                 row_focus: 0,
        //                 column_focus: 0
        //             }
        //         ]
        //     });

        //     Proposal_appDataConfig.proposal.celldata = basedata;
        // };

        const csrproposalTable = () => {
            const basedata = [];
            const data = proposalstate;
            const dataMap = data;
            const tableColumnNamesOfValid = {};
            let headersKeys = Object.keys(dataMap[0]);

            let DefaultColumns;
            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                DefaultColumns = ["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
            } else {
                DefaultColumns = ["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
            }

            if (dataMap?.length > 0) {
                headersKeys.forEach((column) => {
                    tableColumnNamesOfValid[column] = 0
                });
            }

            if (dataMap && dataMap?.length > 0 && !Array.isArray(dataMap[0])) {
                const exclusionjson = dataMap.map(item => {
                    const {
                        JobId,
                        CreatedOn,
                        UpdatedOn,
                        ConfidenceScore,
                        ExclusionFeedback,
                        ...filteredItem
                    } = item;
                    return filteredItem;
                });

                let excludedColumns;
                if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                    excludedColumns = ["Id", "ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
                } else {
                    excludedColumns = ["Id", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
                }

                let headers = Object.keys(exclusionjson[0]).filter(headerw => !excludedColumns.includes(headerw));
                headers = headers.filter(f => !["ActionOnDiscrepancy", "RequestEndorsement", "NotesFreeFill", "Notes"]?.includes(f));
                let headerRows1 = headers.map((item, index) => {
                    const displayHeader = item === "Exclusion" ? "Exclusions" : item;
                    Proposal_appDataConfig.proposal.config.merge[`${0}_${index}`] = {
                        "r": 0,
                        "c": index,
                        "rs": 2,
                        "cs": 1
                    }
                    return {
                        r: 0,
                        rs: 2,
                        c: index,
                        cs: 1,
                        v: {
                            ct: { fa: "General", t: "g" },
                            m: displayHeader,
                            v: displayHeader,
                            fs: 10,
                            ff: "\"Tahoma\"",
                            merge: null,
                            bg: "rgb(139,173,212)",
                            tb: '2',
                            w: 55,
                        }
                    }
                });

                headerRows1 = [...headerRows1];
                const defaultHeaderRows1 = DefaultColumns.map((item, index) => {
                    if (index == 0) {
                        Proposal_appDataConfig.proposal.config.merge[`${headerRows1[headerRows1?.length - 1]?.r}_${headerRows1.length + index}`] = {
                            "r": headerRows1[headerRows1?.length - 1]?.r,
                            "c": reqEndorsementColHideBrokerId.includes(brokerId) ? 5 : 6,
                            "rs": 1,
                            "cs": reqEndorsementColHideBrokerId.includes(brokerId) ? 3 : 4,
                        }
                        return {
                            r: headerRows1[headerRows1?.length - 1]?.r,
                            rs: 1,
                            c: headerRows1.length,
                            cs: reqEndorsementColHideBrokerId.includes(brokerId) ? 3 : 4,
                            v: {
                                ht: 0,
                                ct: { fa: "General", t: "g" },
                                m: item,
                                v: item,
                                fs: 11,
                                ff: "\"Tahoma\"",
                                merge: null,
                                bg: "rgb(139,173,212)",
                                tb: '2',
                                w: 55,
                            }
                        }
                    }
                    else {
                        return {
                            r: headerRows1[headerRows1?.length - 1]?.r + 1,
                            rs: 1,
                            c: headerRows1.length + index - 1,
                            cs: 1,
                            v: {
                                ct: { fa: "General", t: "g" },
                                m: item,
                                v: item,
                                fs: 11,
                                ff: "\"Tahoma\"",
                                merge: null,
                                bg: "rgb(139,173,212)",
                                tb: '2',
                                w: 55,
                            }
                        }
                    }
                });

                let headerRows1Values = [];
                let rowIndex = defaultHeaderRows1[defaultHeaderRows1.length - 1]?.r + 1;
                let rowHeight = 60;
                let fs = 9;
                let dataToUpDate = exclusionjson.map((item, indexr) => {
                    let actionColumnKeys;
                    if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                        actionColumnKeys = ["ActionOnDiscrepancy", "Notes", "NotesFreeFill"];
                    } else {
                        actionColumnKeys = ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
                    }
                    // if(brokerId != "1003") { 
                    if (AODDBrokerIds.includes(brokerId)) {
                        headers = [...headers, ...actionColumnKeys];
                    } else {
                        headers = [...headers];
                    }
                    let uniqueHeaderSet = Array.from(new Set(headers))
                    let rowIndexForStateData = 0;
                    uniqueHeaderSet.map((key, rIndex) => {
                        // if(item[key] != null) {
                        rowIndexForStateData = indexr + 2;
                        let text = item[key] != null ? item[key].toString().split('~~') : [];
                        let ss = [];
                        if (key != 'Document Viewer' && text && text?.length > 0) {
                            text.map((e) => {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "#000000",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "v": e.trim() + "\r\n"
                                });
                            }
                            );
                        }

                        if (key === "Document Viewer") {
                            const dvData = item[key];
                            if (dvData != undefined && dvData != null && dvData?.trim() != '') {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgb(61, 133, 198)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "ht": "0",
                                    "un": 1,
                                    "v": "X-Ray"
                                });
                            }
                            //  else {
                            //     ss.push({
                            //         "ff": "\"Tahoma\"",
                            //         "fc": "rgb(61, 133, 198)",
                            //         "fs": `${fs}`,
                            //         "cl": 0,
                            //         "un": 1,
                            //         "bl": 0,
                            //         "it": 0,
                            //         "ht": "0",
                            //         "v": " "
                            //     });
                            // }
                        }

                        if (AODDBrokerIds.includes(brokerId) && (key === 'ActionOnDiscrepancy' || key === 'RequestEndorsement' || key === 'Notes')) {
                            const dvData = item[key];
                            if (dvData == "" || dvData == undefined || dvData == null) {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "rgba(171, 160, 160, 0.957)",
                                    "fs": `${fs}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "ht": "0",
                                    "v": "Click here"
                                });
                            }
                        }
                        headerRows1Values.push({
                            r: rowIndex + indexr,
                            c: rIndex,
                            v: {
                                ct: { fa: "General", t: "inlineStr", s: ss },
                                merge: null,
                                w: 55,
                                ff: "\"Tahoma\"",
                                tb: '2',
                                "ht": key === 'Document Viewer' ? "0" : key === 'ActionOnDiscrepancy' ? "0" : key === 'RequestEndorsement' ? "0" :
                                    key === 'Notes' ? "0" : null
                            }
                        });

                        let maxLength = 20;
                        const lengths = [];

                        Object.keys(item).forEach((key) => {
                            if (item[key]) {
                                lengths.push(item[key].length);
                            }
                        });
                        lengths.forEach((length) => {
                            if (length > maxLength) {
                                maxLength = length;
                            }
                        });
                        const len = maxLength > 100 ? 60 : maxLength;
                        const rowHeight = parseInt(len);
                        Proposal_appDataConfig.proposal.config.rowlen[`${rowIndex + indexr}`] = rowHeight;

                        if (rIndex == 0) {
                            Proposal_appDataConfig.proposal.config.rowlen[`${rowIndex}`] = 60;
                        }

                        // if (text && rowHeight < parseInt(item[key]?.length / 2 + 10)) {
                        //     rowHeight = parseInt(item[key]?.length / 2 + 10);
                        //     Proposal_appDataConfig.proposal.config.rowlen[`${rowIndex}`] = rowHeight;
                        // }
                        // }
                    })
                    item["sheetPosition"] = rowIndexForStateData;
                    return item;
                });

                const exclusionTableForReturn = [{ "TableName": "ProposalExTable 1", "data": dataToUpDate }];
                const xRayexclusiondataForReturn = [{ dataToUpDate }];
                Proposal_appDataConfig.proposal.config.borderInfo.push({
                    "rangeType": "range",
                    "borderType": "border-all",
                    "color": "#000",
                    "style": "1",
                    "range": [
                        {
                            "left": 74,
                            "width": 300,
                            "top": 470,
                            "height": 42,
                            "left_move": 74,
                            "width_move": 4213,
                            "top_move": 471,
                            "height_move": 1107,
                            "row": [
                                headerRows1[0]?.r,
                                headerRows1Values[headerRows1Values?.length - 1]?.r
                            ],
                            "column": [
                                headerRows1[0]?.c,
                                // brokerId != "1003" ? 7 : 3,
                                reqEndorsementColHideBrokerId.includes(brokerId) ? 6 : AODDBrokerIds.includes(brokerId) ? 9 : 4,
                            ],
                            "row_focus": headerRows1[0]?.r,
                            "column_focus": headerRows1[0]?.c
                        }
                    ]
                });

                // if(brokerId != "1003") {
                if (AODDBrokerIds.includes(brokerId)) {
                    headerRows1 = [...headerRows1, ...defaultHeaderRows1, ...headerRows1Values];
                } else {
                    headerRows1 = [...headerRows1, ...headerRows1Values];
                }

                const allRows2 = [...headerRows1];
                if (headerRows1 && headerRows1?.length > 0) {


                    const ExTableColumnDetails = proposalexTableColumnDetails;
                    if (headerRows1?.length > 0) {

                        const columnHeaderss = Object.keys(tableColumnNamesOfValid);
                        headerRows1.forEach((f, index) => {
                            let cellValue = f?.v?.v;
                            if (columnHeaderss.includes(f?.v?.m) || columnHeaderss.includes(f?.v?.v)) {
                                tableColumnNamesOfValid[f?.v?.v] = f?.c;
                            } else if (cellValue === "Exclusions" && columnHeaderss.includes("Exclusion")) {
                                // Map the new header name to the old data key index
                                tableColumnNamesOfValid["Exclusion"] = f?.c;
                                tableColumnNamesOfValid["Exclusions"] = f?.c;
                            }
                        });
                    }

                    ExTableColumnDetails["ProposalExTable 1"] = {
                        "columnNames": tableColumnNamesOfValid,
                        "range": {
                            "start": 0,
                            "end": headerRows1[headerRows1.length - 1]?.r
                        }
                    };
                    setProposalExTableColumnDetails(ExTableColumnDetails);
                }

                allRows2.sort((a, b) => a.r - b.r);
                basedata.push(...allRows2);
                Proposal_appDataConfig.proposal.celldata = basedata;

                let exclusionDataTracked = [];
                let positioningForexclusionData = [];
                let xRAyExclusionDataMap = [];
                xRAyExclusionDataMap.push({
                    Data: exclusionTableForReturn,
                    columnNames: proposalexTableColumnDetails["ProposalExTable 1"]?.columnNames,
                    range: {
                        start: allRows2[0]?.r,
                        end: allRows2[allRows2?.length - 1]?.r
                    }
                });

                sessionStorage.setItem('positioningForProposalexclusionData', JSON.stringify(xRAyExclusionDataMap))
                // exclusionData.map((index) => {
                // if (exclusionData?.length === (index + 1)) {
                exclusionDataTracked.push(exclusionTableForReturn);
                setDataForSaveProposalExclusion([...exclusionDataTracked]);
                sessionStorage.setItem('proposalexclusionDataTracked', JSON.stringify(exclusionDataTracked))
                setDataForSaveProposalExclusionPosition([...positioningForexclusionData]);
                setProposalExclusionDataForXRayMapping([...xRAyExclusionDataMap]);
                // }
                // });
                return {
                    exclusionTableForReturn, xRayexclusiondataForReturn
                };
            }
        };

        if (canRenderProposalData) {
            csrproposalTable();
        }

        const qacRender = () => {
            const basedata = [];
            const cellData = [];
            const apiData = canRenderQac ? typeof canRenderQac === 'string' ? JSON?.parse(canRenderQac) : {} : {};
            let finalQacData = apiData;
            let rowIndex = 0;
            let lobIndex = 0;
            const tableRangeState = {};

            Object.entries(apiData)?.forEach(([category, subCategories], clrIdx) => {
                tableRangeState[category] = [];

                cellData.push({
                    r: rowIndex,
                    c: 0,
                    v: {
                        ct: { fa: "@", t: "inlineStr" },
                        m: category,
                        v: category,
                        merge: null,
                        tb: "2",
                        fs: "10",
                        ff: "\"Tahoma\"",
                        bl: 1,
                    },
                });

                rowIndex += 1;

                Object.entries(subCategories)?.forEach(([lob, questions]) => {
                    const LobIndex = lobIndex;
                    const lobStartIndex = rowIndex;
                    const lobDataLength = questions?.length;

                    qac_appDataConfig.config.merge[`${lobStartIndex}_${0}`] = {
                        "r": lobStartIndex,
                        "c": 0,
                        "rs": 1,
                        "cs": 3
                    };

                    cellData.push({
                        r: rowIndex,
                        c: 0,
                        v: {
                            ct: { fa: "@", t: "inlineStr" },
                            m: lob,
                            v: lob,
                            merge: null,
                            tb: "2",
                            fs: 7,
                            ff: "\"Tahoma\"",
                            bl: 1,
                            bg: category?.toLowerCase()?.includes('high') ? "rgb(241, 169, 131)" : "rgb(139,173,212)",
                        },
                    });

                    rowIndex += 1;

                    const headers = Object?.keys(questions[0]);
                    headers?.forEach((header, index) => {
                        cellData.push({
                            r: rowIndex,
                            c: index,
                            v: {
                                ct: { fa: "@", t: "inlineStr" },
                                m: header,
                                v: header,
                                merge: null,
                                tb: "2",
                                fs: 7,
                                ff: "\"Tahoma\"",
                                bl: 1,
                                bg: category?.toLowerCase()?.includes('high') ? "rgb(241, 169, 131)" : "rgb(139,173,212)",
                            },
                        });
                    });
                    rowIndex += 1;

                    questions?.forEach((question, dIndex) => {
                        headers?.forEach((header, index) => {
                            const questionValue = question[header] !== null ? question[header].replace(/~~/g, "\n") : "";
                            cellData.push({
                                r: rowIndex,
                                c: index,
                                v: {
                                    ct: { fa: "@", t: "inlineStr" },
                                    m: questionValue,
                                    v: questionValue,
                                    merge: null,
                                    tb: "2",
                                    fs: 7,
                                    ff: "\"Tahoma\"",
                                },
                            });
                        });
                        finalQacData[category][lob][dIndex]["RowIndex"] = rowIndex;
                        rowIndex += 1;
                    });

                    if (!tableRangeState[category]) {
                        tableRangeState[category] = [];
                    }

                    tableRangeState[category].push({
                        [`qacTable ${LobIndex}`]: {
                            columnNames: headers.reduce((acc, header, index) => {
                                acc[header] = index;
                                return acc;
                            }, {}),
                            range: {
                                start: lobStartIndex,
                                end: rowIndex - 1,
                            },
                            policyLob: [lob],
                        }

                    });


                    if (lobDataLength == ((questions?.length - 1) + 1)) {
                        qac_appDataConfig["config"]["borderInfo"][LobIndex] = {
                            "rangeType": "range",
                            "borderType": "border-all",
                            "color": "#000",
                            "style": "1",
                            "range": [
                                {
                                    "left": 0,
                                    "width": 830,
                                    "top": 0,
                                    "height": 19,
                                    "left_move": 0,
                                    "width_move": 830,
                                    "top_move": 0,
                                    "height_move": 199,
                                    "row": [lobStartIndex, (lobStartIndex + lobDataLength) + 1],
                                    "column": [0, headers?.length - 1],
                                    "row_focus": 0,
                                    "column_focus": 0
                                }
                            ]
                        }
                        rowIndex += 2;
                        lobIndex += 1;
                    }
                });
            });
            const allRows2 = [...cellData]
            allRows2.sort((a, b) => a.r - b.r);
            basedata.push(...allRows2);
            qac_appDataConfig.celldata = basedata;
            setSheetDataRowIndex((prev) => {
                const updatedData = { ...prev, ...finalQacData };
                sheetDataRowIndexRef.current = updatedData; // Store the latest data in ref
                return updatedData;
            });
            sessionStorage.setItem("qacTblRange", JSON.stringify(tableRangeState))
            setQacTableColumnDetails(tableRangeState);
        };
        if (canRenderQac && renderBrokerIdsQac?.includes(brokerId)) {
            qacRender();
        }

        csrLuckySheet();

        setTimeout(() => {
            if (luckysheet?.getSheet()?.name != 'QA Checklist' && luckysheet?.getSheet()?.name != ExclusionSheetName && luckysheet?.getSheet()?.name != 'CSR Pro') {
                dataGrouping();
            }
        }, 2000);

        let interval;
        if (activeUserName === sessionUserName) {
            setTimeout(() => {
                const { UpdatePeriod } = autoupdate();
                interval = setInterval(() => {
                    const { UpdateEnable } = autoupdate();
                    if (UpdateEnable && issavessheet === false) {
                        Autoupdateclick(true);
                    }
                }, UpdatePeriod);
            }, 2000);
        }

        return () => {
            clearInterval(interval)
            if (activeUserName === sessionUserName) {
                const allowautoup = sessionStorage.getItem("IsAutoUpdate")
                if (autoprogress && issavessheet == false && (allowautoup == "true" || allowautoup == true)) {
                    Autoupdateclick(true);
                }
                if (issavessheet == false && (allowautoup == "true" || allowautoup == true)) {
                    Autoupdateclick(true);
                }
            }
        };
    }, [props.data, activeUserName, sessionUserName]);

    const getCsrReviewData = async (jobId) => {
        try {
            let token = sessionStorage.getItem("token");
            token = await processAndUpdateToken(token);
            const response = await axios.get(
                baseUrl + `/api/JobConfiguration/GetJobReviewData?jobId=${jobId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response?.data?.length > 0) {
                setReviewData(response?.data);
                setSendPolicyInsuredData(response?.data);
            } else {
                setReviewData([]);
                setSendPolicyInsuredData([]);
            }
        } catch (error) {
            setReviewData([]);
            setSendPolicyInsuredData([]);
        }
    }

    const setCellValue = (row, column, data) => {
        if (luckysheet && (luckysheet != undefined || luckysheet != null)) {
            luckysheet?.setcellvalue(row, column, luckysheet?.flowdata(), data);
            luckysheet?.jfrefreshgrid();
        }
    }

    const setCsrCellValue = (row, column, data) => {
        if (luckysheet && (luckysheet != undefined || luckysheet != null)) {
            luckysheet?.setcellvalue(row, column, luckysheet.flowdata(), data);
            luckysheet?.jfrefreshgrid();
            luckysheet?.setCellFormat(row, column, "ct", { fa: "General", t: "g" })
        }
    }

    const toggleDropDialog = () => {
        let flagCheck = luckysheet.getSheet().name;
        if (flagCheck != 'Red' && flagCheck != 'Green') {
            setDropDialog(!dropDialog);
            const propsData = luckysheet.getSheetData();
            setsheetState(propsData);
        }
        else {
            setGradiationDialog(!gradiationDialog);
        }
    };

    const toggleProposalExDropDialog = () => {
        let flagCheck = luckysheet.getSheet().name;
        if (flagCheck != 'Red' && flagCheck != 'Green') {
            setDropProposalExDialog(!dropProposalExDialog);
        }
    };

    const tbl1HyperFun = (range, flagCheck) => {
        if (range) {
            const rowIdx = range[0].row[0];
            const columnIdx = range[0].column[0];

            if (flagCheck === "Summary Checklist" || flagCheck === FormsCompareSheetName) {
                let checklistData = [...props?.data];
                if (checklistData && checklistData?.length > 0) {
                    checklistData = checklistData.map((e) => {
                        if (e?.TemplateData && typeof e?.TemplateData != 'object' && typeof e?.TemplateData === 'string') {
                            let templateData = JSON.parse(e.TemplateData);
                            e["TemplateData"] = templateData;
                        }
                        return e;
                    })
                }

                const tableDetails = tableColumnDetails;
                let keys = Object.keys(tableDetails);
                if (keys && keys?.length > 0 && checklistData && checklistData.length > 0 && rowIdx > 0 && columnIdx > 0) {
                    let tableName = '';
                    keys.forEach((f) => {
                        const tableNameData = tableDetails[f];
                        const tblRangeData = tableNameData?.range;
                        if (tableNameData && tblRangeData && tblRangeData?.start <= rowIdx && tblRangeData?.end >= rowIdx) {
                            tableName = f;
                        }
                    });
                    if (tableName && tableName == 'Table 1') {
                        const filterTbl1 = tableDetails[tableName];
                        // const hyperLinkColumn = filterTbl1?.columnNames.indexOf("Exdion CSRDigiT");
                        const hyperLinkColumn = filterTbl1?.columnNames?.findIndex(item => item.toLowerCase()?.includes("csrdigit".toLowerCase()));
                        let tbl1Data = {};
                        const filteredTbl1Data = checklistData.filter((f) => f?.Tablename === tableName);
                        if (filteredTbl1Data && filteredTbl1Data?.length > 0) {
                            tbl1Data = filteredTbl1Data[0];
                            const selectedRecordData = tbl1Data?.TemplateData[hyperLinkColumn];
                            if (selectedRecordData != undefined) {
                                if (selectedRecordData['Headers']?.toLowerCase() === 'exdion csrdigit'.toLowerCase() && columnIdx === 2 && filterTbl1?.range?.end === rowIdx) {
                                    const tbl1HyperLink = selectedRecordData['(No column name)'];
                                    if (tbl1HyperLink) {
                                        window.open(tbl1HyperLink, '_blank', 'noopener');
                                    }
                                }
                            }
                        }
                    }
                }
            } else if (flagCheck === "CSR Pro") {
                const summaryData = JSON.parse(sessionStorage.getItem('summarryData'));
                const tableDetails = summaryTableColumnDetails;

                let keys = Object.keys(tableDetails);
                if (keys && keys?.length > 0 && summaryData && rowIdx > 0 && columnIdx > 0) {
                    let tableName = '';
                    keys.forEach((f) => {
                        const tableNameData = tableDetails[f];
                        const tblRangeData = tableNameData?.range;
                        if (tableNameData && tblRangeData && tblRangeData?.start <= rowIdx && tblRangeData?.end >= rowIdx) {
                            tableName = f;
                        }
                    });
                    if (tableName && tableName == 'Table 1') {
                        const filterTbl1 = tableDetails[tableName];
                        const hyperLinkColumn = filterTbl1?.columnNames?.findIndex(item => item.toLowerCase()?.includes("csrdigit".toLowerCase()));
                        let tbl1Data = {};
                        const filteredTbl1Data = summaryData?.filter((f) => f?.Tablename === tableName);
                        if (filteredTbl1Data && filteredTbl1Data?.length > 0) {
                            tbl1Data = filteredTbl1Data[0];
                            const selectedRecordData = tbl1Data?.TemplateData[hyperLinkColumn];
                            if (selectedRecordData != undefined) {
                                if (selectedRecordData['Headers']?.toLowerCase() === 'exdion csrdigit'.toLowerCase() && columnIdx === 2 && filterTbl1?.range?.end === rowIdx) {
                                    const tbl1HyperLink = selectedRecordData['Value'];
                                    if (tbl1HyperLink) {
                                        window.open(tbl1HyperLink, '_blank', 'noopener');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    const XRayRoute = (range, flag) => {
        if (range) {
            const row = range[0].row[0];
            const column = range[0].column[0];

            if (flag === "Summary Checklist") {
                let checklistData = [...props?.data];
                if (checklistData && checklistData?.length > 0) {
                    checklistData = checklistData.map((e) => {
                        if (e?.TemplateData && typeof e?.TemplateData != 'object' && typeof e?.TemplateData === 'string') {
                            let templateData = JSON.parse(e.TemplateData);
                            e["TemplateData"] = templateData;
                        }
                        return e;
                    })
                }
                const tableDetails = tableColumnDetails;
                let keys = Object.keys(tableDetails);
                if (keys && keys?.length > 0 && checklistData && checklistData.length > 0 && row > 0 && column > 0) {
                    let tableName = '';
                    keys.forEach((f) => {
                        const tableCData = tableDetails[f];
                        const tRangeData = tableCData?.range;
                        if (tableCData && tRangeData && tRangeData?.start <= row && tRangeData?.end >= row) {
                            tableName = f;
                        }
                    });
                    if (tableName && tableName != 'Table 1') {
                        const activeTableData = tableDetails[tableName];
                        const documentviewerIndex = activeTableData?.columnNames["Document Viewer"];
                        if (documentviewerIndex && documentviewerIndex === column) {
                            let activeTableDBData = {};
                            const filteredData = checklistData.filter((f) => f?.Tablename === tableName);
                            if (filteredData && filteredData?.length > 0) {
                                activeTableDBData = filteredData[0];
                                const activeTableRange = activeTableData?.range;
                                const configureStartFrom = (activeTableRange?.end - activeTableRange.start) - activeTableDBData?.TemplateData?.length;
                                const startT = activeTableRange?.start + configureStartFrom + 1;
                                const endT = activeTableRange?.end;
                                const indexSet = Array.from({ length: endT - startT + 1 }, (_, i) => startT + i);
                                // console.log(indexSet);
                                if (indexSet && indexSet?.length > 0) {
                                    const recordIndexToGet = indexSet.indexOf(row);
                                    const columns = Object.keys(activeTableData?.columnNames);
                                    const startIndex = columns.indexOf("COVERAGE_SPECIFICATIONS_MASTER") + 1;
                                    const endIndex = columns.indexOf("Document Viewer") + 1;
                                    const filteredColumns = columns.slice(startIndex, endIndex - 1);
                                    const rowData = luckysheet.getSheetData()?.[row];
                                    const columnDetails = activeTableData?.columnNames;

                                    const filteredTextData = filteredColumns?.map(col => {
                                        const columnIndex = columnDetails[col];
                                        const pageData = rowData[columnIndex];

                                        const texrt = getText(pageData, false);
                                        return {
                                            columnName: col,
                                            text: texrt?.replace(/\s+Page\s*#/gi, 'Page #')?.replace(/\s+Page\s*:/gi, 'Page:')
                                            ?.replace(/\s+Current policy attached\s*#/gi, 'Current policy attached #')?.replace(/\s+Current policy attached\s*:/gi, 'Current policy attached:')
                                            ?.replace(/\s+Current policy listed\s*#/gi, 'Current policy listed #')?.replace(/\s+Current policy listed\s*:/gi, 'Current policy listed:')
                                        };
                                    });

                                    const normalizeText = (text = "") => {
                                        return text
                                            ?.replace(/~~Page\s*#/gi, 'Page #')?.replace(/\s+Page\s*#/gi, 'Page #')
                                            ?.replace(/~~Current policy attached\s*#/gi, 'Current policy attached #')?.replace(/\s+Current policy attached\s*#/gi, 'Current policy attached #')
                                            ?.replace(/~~Current policy listed\s*#/gi, 'Current policy listed #')?.replace(/\s+Current policy listed\s*#/gi, 'Current policy listed #')
                                            ?.trim();
                                    };

                                    if (recordIndexToGet >= 0) {
                                        const selectedRecordData = activeTableDBData?.TemplateData;
                                        const normalizeForComparison = (value) => {
                                            return value
                                                ?.replace(/\r\n/g, '')
                                                ?.replace(/\s+/g, '')   
                                                ?.trim()
                                                ?.toLowerCase();
                                        };

                                        const matchedRecords = selectedRecordData?.filter(item => {
                                            return filteredTextData?.every(f => {
                                                const dbValue = normalizeText(item[f.columnName]);
                                                const result = dbValue?.replace(/\s*~~\s*/g, '');

                                                const filterValue = f.text;

                                                return normalizeForComparison(result) === normalizeForComparison(filterValue);
                                            });
                                        });

                                        const XRrayURL = matchedRecords?.map(e => e['Document Viewer'])[0];
                                        if (XRrayURL) {
                                            window.open(XRrayURL, '_blank', 'noopener');
                                        }
                                    }
                                }
                            }

                        }
                    }
                }
            } else if (flag === "CSR Pro") {
                const summaryData = JSON.parse(sessionStorage.getItem('summarryData'));
                const tableDetails = summaryTableColumnDetails;

                let keys = Object.keys(tableDetails);
                if (keys && keys?.length > 0 && summaryData && row > 0 && column > 0) {
                    let tableName = '';
                    keys.forEach((f) => {
                        const tableCData = tableDetails[f];
                        const tRangeData = tableCData?.range;
                        if (tableCData && tRangeData && tRangeData?.start <= row && tRangeData?.end >= row) {
                            tableName = f;
                        }
                    });
                    if (tableName && tableName != 'Table 1') {
                        const activeTableData = tableDetails[tableName];
                        const documentviewerIndex = activeTableData?.columnNames["Document Viewer"];
                        if (documentviewerIndex && documentviewerIndex === column) {
                            const XRrayURL = csrProXray[row];
                            if (XRrayURL) {
                                window.open(XRrayURL, '_blank', 'noopener');
                            }
                            // let activeTableDBData = {};
                            // const filteredData = summaryData?.filter((f) => f?.Tablename === tableName);
                            // if (filteredData && filteredData?.length > 0) {
                            //     activeTableDBData = filteredData[0];
                            //     const activeTableRange = activeTableData?.range;
                            //     const configureStartFrom = (activeTableRange?.end - activeTableRange.start) - activeTableDBData?.TemplateData?.length;
                            //     const startT = activeTableRange?.start + configureStartFrom + 1;
                            //     const endT = activeTableRange?.end;
                            //     const indexSet = Array.from({ length: endT - startT + 1 }, (_, i) => startT + i);
                            //     if (indexSet && indexSet?.length > 0) {
                            //         const recordIndexToGet = indexSet.indexOf(row);
                            //         if (recordIndexToGet >= 0) {
                            //             const selectedRecordData = activeTableDBData?.TemplateData[recordIndexToGet];
                            //             const XRrayURL = selectedRecordData["DocumentViewer"];
                            //             if (XRrayURL) {
                            //                 window.open(XRrayURL, '_blank', 'noopener');
                            //             }
                            //         }
                            //     }
                            // }

                        }
                    }
                }
            } else if (flag === "Red" || flag === "Green") {
                let gradtionSheetData = flag == "Red" ? sessionStorage.getItem('redSheetData') : sessionStorage.getItem('greenSheetData');
                let data = JSON.parse(gradtionSheetData);
                let filterData = data.filter(item => Object.keys(item.data).length !== 0);
                filterData.forEach((item, index) => {
                    item.TableName = `Table ${index + 2}`;
                });
                let gradtionData = [...filterData];
                let tblRangeData = flag == "Red" ? sessionStorage.getItem('redTableRangeData') : sessionStorage.getItem('greenTableRangeData');
                let parsedSet = JSON.parse(tblRangeData);
                const tableDetails = parsedSet;
                let keys = Object.keys(tableDetails);

                if (keys && keys?.length > 0 && gradtionData && gradtionData.length > 0 && row > 0 && column > 0) {
                    let tableName = '';
                    keys.forEach((f) => {
                        const tableCData = tableDetails[f];
                        const tRangeData = tableCData?.range;
                        if (tableCData && tRangeData && tRangeData?.start <= row && tRangeData?.end >= row) {
                            tableName = f;
                        }
                    });
                    if (tableName && tableName != 'Table 1') {
                        const activeTableData = tableDetails[tableName];
                        const documentviewerIndex = activeTableData?.columnNames["Document Viewer"];
                        if (documentviewerIndex && documentviewerIndex === column) {
                            let activeTableDBData = {};
                            const filteredData = gradtionData.filter((f) => f?.TableName === tableName);
                            if (filteredData && filteredData?.length > 0) {
                                activeTableDBData = filteredData[0];
                                const activeTableRange = activeTableData?.range;
                                const configureStartFrom = (activeTableRange?.end - activeTableRange.start) - activeTableDBData?.data?.length;
                                const startT = activeTableRange?.start + configureStartFrom + 1;
                                const endT = activeTableRange?.end;
                                const indexSet = Array.from({ length: endT - startT + 1 }, (_, i) => startT + i);
                                // console.log(indexSet);
                                if (indexSet && indexSet?.length > 0) {
                                    const recordIndexToGet = indexSet.indexOf(row);
                                    // console.log("recordIndexToGet : ", recordIndexToGet);
                                    if (recordIndexToGet >= 0) {
                                        const selectedRecordData = activeTableDBData?.data[recordIndexToGet];
                                        const XRrayURL = selectedRecordData["Document Viewer"];
                                        if (XRrayURL) {
                                            window.open(XRrayURL, '_blank', 'noopener');
                                        }
                                    }
                                }
                            }

                        }
                    }
                }
            } else if (flag === FormsCompareSheetName) {
                const formData = [...props?.formCompareData];
                const formSectionDetails = formTableColumnDetails;
                const unMatchedSectionDetails = formSectionDetails["FormTable 2"];
                if (unMatchedSectionDetails && unMatchedSectionDetails?.range && unMatchedSectionDetails?.columnNames) {
                    const rangeData = unMatchedSectionDetails?.range;
                    const columnDetails = unMatchedSectionDetails?.columnNames;
                    const documentviewerPosition = columnDetails["Document Viewer"];
                    const start = rangeData?.start;
                    const end = rangeData?.end;
                    const modifiedStart = start + 3;
                    const indexSet = Array.from({ length: end - modifiedStart + 1 }, (_, i) => modifiedStart + i);
                    if (indexSet && indexSet?.length > 0 && start && end && documentviewerPosition === column && start <= row && end >= row && formData && formData?.length > 0) {
                        const unmatchedFormSectionData = formData[1];
                        if (unmatchedFormSectionData && unmatchedFormSectionData?.TemplateData) {
                            const unMatchedSectionParsedData = typeof unmatchedFormSectionData?.TemplateData === "string" ? JSON.parse(unmatchedFormSectionData?.TemplateData) : unmatchedFormSectionData?.TemplateData;
                            if (Array.isArray(unMatchedSectionParsedData) && unMatchedSectionParsedData?.length > 0) {
                                const recordIndexToGet = indexSet.indexOf(row);
                                // console.log("recordIndexToGet : ", recordIndexToGet);
                                if (recordIndexToGet >= 0) {
                                    const selectedRecordData = unMatchedSectionParsedData[recordIndexToGet];
                                    const XRrayURL = selectedRecordData["Document Viewer"];
                                    if (XRrayURL) {
                                        luckysheet.exitEditMode();
                                        setTimeout(() => {
                                            // luckysheet.setRangeShow({ row: [row, row], column: [column - 1, column - 1] });
                                            // setTimeout(() => {
                                                // luckysheet.enterEditMode();
                                                // setTimeout(() => {
                                                    window.open(XRrayURL, '_blank', 'noopener');
                                                // }, 50);
                                            // }, 100);
                                        }, 100);
                                    }
                                }
                            }
                        }
                    }
                }
            } else if (flag === ExclusionSheetName) {
                const exData = [...props?.exclusionRenderData];
                const exSectionDetails = exTableColumnDetails;
                const exclusionSectionDetails = exSectionDetails["ExTable 1"];

                if (exclusionSectionDetails && exclusionSectionDetails?.range && exclusionSectionDetails?.columnNames) {
                    const rangeData = exclusionSectionDetails?.range;
                    const columnDetails = exclusionSectionDetails?.columnNames;

                    // Fix: Ensure documentviewerPosition is an object or single value
                    const documentviewerPosition = columnDetails["Document Viewer"];

                    const start = rangeData?.start;
                    const end = rangeData?.end;
                    const modifiedStart = start + 2;
                    let indexSet = Array.from({ length: end - modifiedStart + 1 }, (_, i) => modifiedStart + i);
                    indexSet = indexSet?.map((_, index) => index);

                    // if (columnDetails["PageNumber"] < column && columnDetails["ActionOnDiscrepancy"] > column) {
                    if (indexSet?.length > 0 && documentviewerPosition === column && start <= row && end >= row && exData?.length > 0) {
                        const exTableSectionData = exData;

                        if (exTableSectionData) {
                            if (Array.isArray(exTableSectionData) && exTableSectionData?.length > 0) {
                                let recordIndexToGet = indexSet.indexOf(row - 2);

                                if (recordIndexToGet >= 0) {
                                    const selectedRecordData = exTableSectionData[recordIndexToGet];

                                    // if (documentviewerPosition) { // Ensure it exists
                                    const XRrayURL = selectedRecordData["Document Viewer"];

                                    if (XRrayURL) {
                                        luckysheet.exitEditMode();
                                        setTimeout(() => {
                                            // luckysheet.setRangeShow({ row: [row, row], column: [column - 1, column - 1] });
                                            // setTimeout(() => {
                                                // setTimeout(() => {
                                                    window.open(XRrayURL, '_blank', 'noopener');
                                                // }, 50);
                                            // }, 100);
                                        }, 100);
                                    }
                                    // }
                                }
                            }
                        }
                    }
                    // }

                    //

                }
            } else if (flag === "ProposalExclusions") {
                const exData = [...props?.proposalRenderData];
                const exSectionDetails = proposalexTableColumnDetails;
                const exclusionSectionDetails = exSectionDetails["ProposalExTable 1"];

                if (exclusionSectionDetails && exclusionSectionDetails?.range && exclusionSectionDetails?.columnNames) {
                    const rangeData = exclusionSectionDetails?.range;
                    const columnDetails = exclusionSectionDetails?.columnNames;

                    // Fix: Ensure documentviewerPosition is an object or single value
                    const documentviewerPosition = columnDetails["Document Viewer"];

                    const start = rangeData?.start;
                    const end = rangeData?.end;
                    const modifiedStart = start + 2;
                    let indexSet = Array.from({ length: end - modifiedStart + 1 }, (_, i) => modifiedStart + i);
                    indexSet = indexSet?.map((_, index) => index);

                    // if (columnDetails["PageNumber"] < column && columnDetails["ActionOnDiscrepancy"] > column) {
                    if (indexSet?.length > 0 && documentviewerPosition === column && start <= row && end >= row && exData?.length > 0) {
                        const exTableSectionData = exData;

                        if (exTableSectionData) {
                            if (Array.isArray(exTableSectionData) && exTableSectionData?.length > 0) {
                                let recordIndexToGet = indexSet.indexOf(row - 2);

                                if (recordIndexToGet >= 0) {
                                    const selectedRecordData = exTableSectionData[recordIndexToGet];

                                    // if (documentviewerPosition) { // Ensure it exists
                                    const XRrayURL = selectedRecordData["Document Viewer"];

                                    if (XRrayURL) {
                                        luckysheet.exitEditMode();
                                        setTimeout(() => {
                                            // luckysheet.setRangeShow({ row: [row, row], column: [column - 1, column - 1] });
                                            // setTimeout(() => {
                                                // setTimeout(() => {
                                                    window.open(XRrayURL, '_blank', 'noopener');
                                                // }, 50);
                                            // }, 100);
                                        }, 100);
                                    }
                                    // }
                                }
                            }
                        }
                    }
                    // }
                    //
                }
            }

        }
    }

    const funForDiscrepancyCol = (e) => {
        let range = luckysheet.getRange();
        let flagCheck = luckysheet.getSheet().name;
        if (flagCheck == "Summary Checklist" || flagCheck == FormsCompareSheetName || flagCheck == ExclusionSheetName) {
            let selectedIndex = range[0].row[0];
            let tabledata = flagCheck == "Summary Checklist" ? tableColumnDetails : flagCheck == FormsCompareSheetName ? formTableColumnDetails : exTableColumnDetails;
            const excludedColumns = ["Id", "sheetPosition", "columnid"];
            const selectedTable = findTableForIndex(selectedIndex, tabledata, excludedColumns);

            let actionColumnTable = flagCheck == "Summary Checklist" ? tableColumnDetails[selectedTable] : flagCheck == FormsCompareSheetName ? formTableColumnDetails[selectedTable] : exTableColumnDetails[selectedTable];
            let values = Object.values(actionColumnTable.columnNames);
            let largestIndex = selectedTable == "ExTable 1" ? Math.max(...values) : Math.max(...values);
            let Actioncolumnindex = selectedTable == "ExTable 1" ? largestIndex - 3 : reqEndorsementColHideBrokerId.includes(brokerId) ? largestIndex - 2 : largestIndex - 3;
            let Requestcolumnindex = selectedTable == "ExTable 1" ? largestIndex - 2 : reqEndorsementColHideBrokerId.includes(brokerId) ? largestIndex - 1 : largestIndex - 2;
            let Notescolumnindex = selectedTable == "ExTable 1" ? largestIndex - 1 : (reqEndorsementColHideBrokerId.includes(brokerId) ? (largestIndex - 4) : (largestIndex - 1));
            let r = range[0].row[0];
            let c = range[0].column[0];

            if (e?.hasData) {
                if (e.selectedOption1 != null && e.selectedOption2 != null && e.selectedOption3 != null) {
                    if (c == Actioncolumnindex) {
                        setCellValue(r, c, e.selectedOption1.text);
                        setCellValue(r, c + 1, e.selectedOption2.text);
                        setCellValue(r, c + 2, e.selectedOption3.text);
                    } else if (c == Requestcolumnindex) {
                        setCellValue(r, c - 1, e.selectedOption1.text);
                        setCellValue(r, c, e.selectedOption2.text);
                        setCellValue(r, c + 1, e.selectedOption3.text);
                    } else if (c == Notescolumnindex) {
                        setCellValue(r, c - 2, e.selectedOption1.text);
                        setCellValue(r, c - 1, e.selectedOption2.text);
                        setCellValue(r, c, e.selectedOption3.text);
                    }
                } else {
                    // Handle each option separately if not all are selected
                    if (e && e.selectedOption1 && e.selectedOption1 != null) {
                        let actionText = e.selectedOption1.text;
                        setCellValue(r, Actioncolumnindex, actionText);
                        luckysheet.exitEditMode();
                    }
                    if (e && e.selectedOption2 && e.selectedOption2 != null) {
                        let requestText = e.selectedOption2.text;
                        setCellValue(r, Requestcolumnindex, requestText);
                        luckysheet.exitEditMode();
                    }
                    if (e && e.selectedOption3 && e.selectedOption3 != null) {
                        let notesText = e.selectedOption3.text;
                        setCellValue(r, Notescolumnindex, notesText);
                        luckysheet.exitEditMode();
                    }
                }
            }
            setDropDialog(false);
        } if (flagCheck == "ProposalExclusions") {
            let selectedIndex = range[0].row[0];
            let tabledata =  proposalexTableColumnDetails;
            const excludedColumns = ["Id", "sheetPosition", "columnid"];
            const selectedTable = findTableForIndex(selectedIndex, tabledata, excludedColumns);

            let actionColumnTable = proposalexTableColumnDetails[selectedTable];
            let values = Object.values(actionColumnTable.columnNames);
            let largestIndex =  Math.max(...values);
            let Actioncolumnindex =  largestIndex - 3;
            let Requestcolumnindex =  largestIndex - 2;
            let Notescolumnindex =  largestIndex - 1;
            let r = range[0].row[0];
            let c = range[0].column[0];

            if (e?.hasData) {
                if (e.selectedOption1 != null && e.selectedOption2 != null && e.selectedOption3 != null) {
                    if (c == Actioncolumnindex) {
                        setCellValue(r, c, e.selectedOption1.text);
                        setCellValue(r, c + 1, e.selectedOption2.text);
                        setCellValue(r, c + 2, e.selectedOption3.text);
                    } else if (c == Requestcolumnindex) {
                        setCellValue(r, c - 1, e.selectedOption1.text);
                        setCellValue(r, c, e.selectedOption2.text);
                        setCellValue(r, c + 1, e.selectedOption3.text);
                    } else if (c == Notescolumnindex) {
                        setCellValue(r, c - 2, e.selectedOption1.text);
                        setCellValue(r, c - 1, e.selectedOption2.text);
                        setCellValue(r, c, e.selectedOption3.text);
                    }
                } else {
                    // Handle each option separately if not all are selected
                    if (e && e.selectedOption1 && e.selectedOption1 != null) {
                        let actionText = e.selectedOption1.text;
                        setCellValue(r, Actioncolumnindex, actionText);
                        luckysheet.exitEditMode();
                    }
                    if (e && e.selectedOption2 && e.selectedOption2 != null) {
                        let requestText = e.selectedOption2.text;
                        setCellValue(r, Requestcolumnindex, requestText);
                        luckysheet.exitEditMode();
                    }
                    if (e && e.selectedOption3 && e.selectedOption3 != null) {
                        let notesText = e.selectedOption3.text;
                        setCellValue(r, Notescolumnindex, notesText);
                        luckysheet.exitEditMode();
                    }
                }
            }
            setDropProposalExDialog(false);
        } else if (flagCheck == 'Red' || flagCheck == 'Green') {
            let r = range[0].row[0];
            let c = range[0].column[0];
            const gradiationSet = flagCheck == 'Red' ? sessionStorage.getItem('redTableRangeData') : flagCheck == 'Green' ? sessionStorage.getItem('greenTableRangeData') : null;
            let parsedSet = JSON.parse(gradiationSet);
            const excludedColumns = ["Actions on Discrepancy (from AMs)"];
            const selectedTable = findTableForIndex(r, parsedSet, excludedColumns);
            let actionColumnTable = parsedSet[selectedTable];
            let values = actionColumnTable ? Object.keys(actionColumnTable.columnNames) : [];
            let largestIndex = values.indexOf("Document Viewer") + 1;
            let Actioncolumnindex = largestIndex + 1;
            let Requestcolumnindex = largestIndex + 2;
            let Notescolumnindex = largestIndex + 3;

            if (e?.hasData) {
                if (e.selectedOption1 != null && e.selectedOption2 != null && e.selectedOption3 != null) {
                    if (c == Actioncolumnindex) {
                        setCsrCellValue(r, c, e.selectedOption1.text);
                        setCsrCellValue(r, c + 1, e.selectedOption2.text);
                        setCsrCellValue(r, c + 2, e.selectedOption3.text);
                    } else if (c == Requestcolumnindex) {
                        setCsrCellValue(r, c - 1, e.selectedOption1.text);
                        setCsrCellValue(r, c, e.selectedOption2.text);
                        setCsrCellValue(r, c + 1, e.selectedOption3.text);
                    } else if (c == Notescolumnindex) {
                        setCsrCellValue(r, c - 2, e.selectedOption1.text);
                        setCsrCellValue(r, c - 1, e.selectedOption2.text);
                        setCsrCellValue(r, c, e.selectedOption3.text);
                    }
                } else {
                    // Handle each option separately if not all are selected
                    if (e && e.selectedOption1 && e.selectedOption1 != null) {
                        let actionText = e.selectedOption1.text;
                        setCsrCellValue(r, Actioncolumnindex, actionText);
                        luckysheet.exitEditMode();
                    }
                    if (e && e.selectedOption2 && e.selectedOption2 != null) {
                        let requestText = e.selectedOption2.text;
                        setCsrCellValue(r, Requestcolumnindex, requestText);
                        luckysheet.exitEditMode();
                    }
                    if (e && e.selectedOption3 && e.selectedOption3 != null) {
                        let notesText = e.selectedOption3.text;
                        setCsrCellValue(r, Notescolumnindex, notesText);
                        luckysheet.exitEditMode();
                    }
                }
            }
            setGradiationDialog(false);
        }
    };
    luckysheet.exitEditMode();

    let isLuckysheetRendered = false;
    const csrLuckySheet = async () => {

        let garadationDataForRedSheet = {};
        let garadationDataForGreenSheet = {};
        // const qacDataSet = await getQACData(jobId, token);
        if (props?.gradtionDataSet && canRenderGradation) {
            const grData = await gradiationConverter(props?.gradtionDataSet, '', true);
            if (grData?.response1?.celldata?.length > 0) {
                garadationDataForRedSheet = grData?.response1;
            }
            if (grData?.response2?.celldata?.length > 0) {
                garadationDataForGreenSheet = grData?.response2;
            }
        }
        let dataSet = [];

        if (canRenderSummaryData && renderBrokerIdsSummary?.includes(brokerId)) {
            dataSet.push(summaryReviewChecklistDatafigdata.summaryReviewChecklist);
        }
        if (canRenderChecklist && !nonRenderBrokerIdsPolicyCheck.includes(brokerId)) {
            dataSet.push(Policy_appDataConfig.demo);
        }
        if (canRenderGradation && garadationDataForRedSheet && garadationDataForRedSheet != null && garadationDataForRedSheet != undefined && Object.keys(garadationDataForRedSheet).length > 0) {
              garadationDataForRedSheet?.celldata?.forEach(cell => {
                    let styles = cell?.v?.ct?.s;
                    if (Array.isArray(styles) && styles.length > 1) {
                        let greenMatched = styles.find(item => {
                            let value = item?.v
                                ?.replace(/\r?\n/g, "")
                                ?.trim();

                            return (
                                value === "MATCHED" &&
                                item?.fc === "rgb(0, 128, 0)"
                            );
                        });
                        if (greenMatched) {
                            cell.v.ct.s = styles.filter(item => {
                                let value = item?.v
                                    ?.replace(/\r?\n/g, "")
                                    ?.trim();
                                if (value === "MATCHED") {
                                    return item?.fc === "rgb(0, 128, 0)";
                                }
                                return true;
                            });
                        }
                    }
                });

            dataSet = [...dataSet, garadationDataForRedSheet]
        }
        if (canRenderGradation && garadationDataForGreenSheet && garadationDataForGreenSheet != null && garadationDataForGreenSheet != undefined && Object.keys(garadationDataForGreenSheet).length > 0) {
              garadationDataForGreenSheet?.celldata?.forEach(cell => {
                    let styles = cell?.v?.ct?.s;
                    if (Array.isArray(styles) && styles.length > 1) {
                        let greenMatched = styles.find(item => {
                            let value = item?.v
                                ?.replace(/\r?\n/g, "")
                                ?.trim();

                            return (
                                value === "MATCHED" &&
                                item?.fc === "rgb(0, 128, 0)"
                            );
                        });
                        if (greenMatched) {
                            cell.v.ct.s = styles.filter(item => {
                                let value = item?.v
                                    ?.replace(/\r?\n/g, "")
                                    ?.trim();
                                if (value === "MATCHED") {
                                    return item?.fc === "rgb(0, 128, 0)";
                                }
                                return true;
                            });
                        }
                    }
                });
            dataSet = [...dataSet, garadationDataForGreenSheet]
        }
        if (canRenderFormData) {
            dataSet.push(FormCompare_appconfigdata.forms);
        }
        if (canRenderExclusionData) {
            dataSet.push(Exclusion_appDataConfig.exclusions);
        }
        // if (canRenderProposalData) {
        //     dataSet.push(Proposal_appDataConfig.proposal);
        // }
        if (canRenderQac && renderBrokerIdsQac?.includes(brokerId)) {
            dataSet.push(qac_appDataConfig);
        }

        // Add SummaryReviewChecklist to the dataset
        if (!isLuckysheetRendered && luckysheet) {
            let lastRenderedSheet = null;

            isLuckysheetRendered = true;
            if (luckysheet) {
                const options = {
                    container: "luckysheet2", // Container ID
                    showinfobar: false,
                    showsheetbar: true,
                    lang: 'en',
                    data: dataSet,
                    enableAddRow: true,
                    showtoolbar: true,
                    row: 2,
                    column: 3,
                    allowUpdate: true,
                    enableAddBackTop: true,
                    sheetRightClickConfig: {
                        delete: false,
                        copy: false,
                        rename: false,
                        color: false,
                        hide: false,
                        move: false,
                        paste: false,
                        cut: false,
                    },
                    showsheetbarConfig: {
                        add: false,
                        menu: false,
                    },

                    hook: {
                        workbookCreateAfter(json) {
                            luckysheet.setSheetZoom(1);
                        },
                        cellEditBefore(range) {
                            let sheetflagCheck = luckysheet?.getSheet()?.name;
                            // if(sheetflagCheck === "CSR Pro" && range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
                            //     range[0]?.column[0] === range[0]?.column[1] && range[0]?.column[0] === 2){
                            //     const data = props.summaryReviewChecklistData;
                            //     const xrayUrl = data[range[0]?.row[0] - 1]?.DocumentViewer;
                            //     if(xrayUrl){
                            //         window.open(xrayUrl, '_blank', 'noopener');
                            //     }
                            //     setTimeout(() => {
                            //         luckysheet.exitEditMode();
                            //     }, 100);
                            //     return;
                            // } 
                            if (sheetflagCheck === "CSR Pro") {
                                if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
                                    range[0]?.column[0] === range[0]?.column[1] && possibleColumns?.includes(range[0].row[0]) &&
                                    range[0].column[0] === 4) {
                                    setTimeout(() => {
                                        luckysheet.exitEditMode();
                                        matchedOrUnMatchedFilter(range[0]?.row[0]);
                                        if (range[0].row[0] <= 7) {
                                            container.current.showSnackbar(range[0]?.row[0] === 5 ?
                                                "Matched Records Filtered" : range[0]?.row[0] === 6 ? "Variances Records Filtered" :
                                                    range[0]?.row[0] === 7 ? "Details not available Questions filtered" : "Filter Removed", "info", true);
                                        }
                                    }, 100);


                                    // checkbox setvalue for Variances columns
                                    if (range && range.length > 0 && range != undefined) {
                                        handleCellSelection(range, luckysheet?.getSheet()?.name);
                                    }
                                    return;
                                }
                            }

                            if (luckysheet?.getSheet()?.name === 'Red' || luckysheet?.getSheet()?.name === 'Green') {
                                if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
                                    range[0]?.column[0] === range[0]?.column[1] && gradiation_possibleColumns?.includes(range[0].row[0]) &&
                                    range[0].column[0] === 4) {
                                    setTimeout(() => {
                                        luckysheet.exitEditMode();
                                        matchedOrUnMatchedFilter(range[0]?.row[0]);
                                        if (range[0].row[0] <= 5) {
                                            if (luckysheet?.getSheet()?.name === 'Red') {
                                                container.current.showSnackbar(range[0]?.row[0] === 3 ? "Matched Records Filtered" : range[0]?.row[0] === 4 ? "Variances Records Filtered" :
                                                    range[0]?.row[0] === 5 ? "Details not available Questions filtered" : "Filter Removed", "info", true);
                                            }
                                            if (luckysheet?.getSheet()?.name === 'Green') {
                                                container.current.showSnackbar(range[0]?.row[0] === 3 ? "Matched Records Filtered" :
                                                    range[0]?.row[0] === 4 ? "Variances Records Filtered" :
                                                        range[0]?.row[0] === 5 ? "Details not available Questions filtered" : "Filter Removed", "info", true);
                                            }
                                        }
                                    }, 100);


                                    // checkbox setvalue for Variances columns
                                    if (range && range.length > 0 && range != undefined) {
                                        handleCellSelection(range, luckysheet?.getSheet()?.name);
                                    }
                                    return;
                                }
                            }

                            //code for variance columns options
                            if (range && range.length > 0 && range != undefined) {
                                if (luckysheet?.getSheet()?.name === 'Summary Checklist' || luckysheet?.getSheet()?.name === 'Red' || luckysheet?.getSheet()?.name === 'Green') {
                                    if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
                                        range[0]?.column[0] === range[0]?.column[1] && possibleColumns?.includes(range[0].row[0]) &&
                                        range[0].column[0] === 4) {
                                        if (luckysheet?.getSheet()?.name !== 'Red' && luckysheet?.getSheet()?.name !== 'Green') {
                                            setTimeout(() => {
                                                luckysheet.exitEditMode();
                                                matchedOrUnMatchedFilter(range[0]?.row[0]);
                                                if (range[0].row[0] <= 6) {
                                                    container.current.showSnackbar(range[0]?.row[0] === 4 ?
                                                        "Matched Records Filtered" : range[0]?.row[0] === 5 ? "Variances Records Filtered" :
                                                            range[0]?.row[0] === 6 ? "Details not available Questions filtered" : "Filter Removed", "info", true);
                                                }
                                            }, 100);


                                            // checkbox setvalue for Variances columns
                                            if (range && range.length > 0 && range != undefined) {
                                                handleCellSelection(range, luckysheet?.getSheet()?.name);
                                            }
                                        }
                                        return;
                                    }
                                    if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
                                        range[0]?.column[0] === range[0]?.column[1] && range[0].column[0] === 0) {
                                        if (!['QA Checklist', ExclusionSheetName, FormsCompareSheetName, 'CSR Pro']?.includes(luckysheet?.getSheet()?.name)) {
                                            setTimeout(() => {
                                                luckysheet.exitEditMode();
                                                dataGrouping(range[0]?.row[0]);
                                            }, 100);
                                        }
                                        return;
                                    }
                                }
                            }

                            // Denied the action of selection of all the cells
                            if (range && range.length > 0 && range != undefined) {
                                let selectedRowIndex = range[0].row[0];
                                let selectedColumnIndex = range[0].column[0];
                                const redTableData = sessionStorage.getItem('redTableRangeData');
                                const greenTableData = sessionStorage.getItem('greenTableRangeData');
                                const parsedRedTableData = redTableData ? JSON.parse(redTableData) : {};
                                const parsedGreenTableData = greenTableData ? JSON.parse(greenTableData) : {};

                                if (luckysheet?.getSheet()?.name != 'QA Checklist' && luckysheet?.getSheet()?.name != ExclusionSheetName && luckysheet?.getSheet()?.name != "ProposalExclusions" && luckysheet?.getSheet()?.name != 'CSR Pro') {
                                    const tabledata = luckysheet?.getSheet()?.name == 'Summary Checklist' ? tableColumnDetails : luckysheet?.getSheet()?.name == FormsCompareSheetName ? formTableColumnDetails : luckysheet?.getSheet()?.name == 'Red' ? parsedRedTableData : parsedGreenTableData;
                                    const excludedColumns = ["columnid"];
                                    const selectedTable = findTableForIndex(selectedRowIndex, tabledata, excludedColumns);
                                    const tblSelectedRow = tabledata[selectedTable];
                                    if (selectedTable != "ExTable 1" && selectedTable != "ProposalExTable 1" && tblSelectedRow != undefined) {
                                        for (const key in tblSelectedRow.columnNames) {
                                            if (tblSelectedRow.columnNames[key] === 0) {
                                                delete tblSelectedRow.columnNames[key];
                                            }
                                        }

                                        let values = Object.keys(tblSelectedRow.columnNames);
                                        let docViewerIndex = values.indexOf("Document Viewer") + 1;

                                        if (selectedColumnIndex < docViewerIndex) {
                                            setTimeout(() => {
                                                luckysheet.exitEditMode();
                                            }, 100);
                                            return false;
                                        }
                                    }
                                } else if (luckysheet?.getSheet()?.name == 'QA Checklist') {
                                    const sessionQacData = sessionStorage.getItem("qacTblRange");
                                    const tabledata = sessionQacData ? JSON?.parse(sessionQacData) : {};
                                    const keys = Object.keys(tabledata);

                                    if (keys?.length > 0) {
                                        keys?.forEach((key) => {
                                            const tableData = tabledata[key];
                                            const structuredTblObj = qacTblRangeStructureFun(tableData);
                                            const selectedTable = findTableForIndex(selectedRowIndex, structuredTblObj, "");
                                            const tblSelectedRow = structuredTblObj[selectedTable];
                                            if (tblSelectedRow != undefined) {
                                                const selectedValue = luckysheet?.getCellValue(selectedRowIndex, selectedColumnIndex);
                                                const lobRow = tblSelectedRow?.policyLob[0];
                                                const headerArray = Object.keys(tblSelectedRow?.columnNames);
                                                const coverageQueCol = tblSelectedRow?.range;
                                                if (selectedValue === lobRow) {
                                                    setTimeout(() => {
                                                        luckysheet.exitEditMode();
                                                    }, 100);
                                                    return false;
                                                } else if (headerArray?.includes(selectedValue)) {
                                                    setTimeout(() => {
                                                        luckysheet.exitEditMode();
                                                    }, 100);
                                                    return false;
                                                } else if ((selectedRowIndex <= coverageQueCol?.end && coverageQueCol?.start + 2 <= selectedRowIndex) && selectedColumnIndex === 0) {
                                                    setTimeout(() => {
                                                        luckysheet.exitEditMode();
                                                    }, 100);
                                                    return false;
                                                }
                                            }
                                        })
                                    }
                                } else if (luckysheet?.getSheet()?.name == ExclusionSheetName) {
                                     if(selectedColumnIndex !== (isSelectedEnabled ? 5 : 4) ) {
                                        if (selectedColumnIndex < (isSelectedEnabled ? 5 : 4)) {
                                            setTimeout(() => {
                                                luckysheet.exitEditMode();
                                            }, 100);
                                            return false;
                                        }
                                     }
                                } else if (luckysheet?.getSheet()?.name == "ProposalExclusions") {
                                    if (selectedColumnIndex < 5) {
                                        setTimeout(() => {
                                            luckysheet.exitEditMode();
                                        }, 100);
                                        return false;
                                    }
                                } else if (luckysheet?.getSheet()?.name == "CSR Pro") {
                                    const tableDetails = summaryTableColumnDetails;
                                    const table = tableDetails['Table 1'].range.end

                                    if (selectedColumnIndex <= 3) {
                                        setTimeout(() => {
                                            luckysheet.exitEditMode();
                                        }, 100);
                                    }
                                    if (selectedColumnIndex == 2 && range[0]?.row[0] == table) {
                                        tbl1HyperFun(range, luckysheet?.getSheet()?.name);
                                    }

                                    const selectedTable = findTblRowAllIndex(selectedRowIndex, tableDetails);
                                    if (selectedTable != 'Table 1') {
                                        XRayRoute(range, luckysheet?.getSheet()?.name);
                                    }

                                    return false;
                                }
                            }

                            // code for trigger X-Ray
                            if ((luckysheet?.getSheet()?.name === "Summary Checklist" || luckysheet?.getSheet()?.name === FormsCompareSheetName || luckysheet?.getSheet()?.name === ExclusionSheetName || luckysheet?.getSheet()?.name === "ProposalExclusions" || luckysheet?.getSheet()?.name === "Red" || luckysheet?.getSheet()?.name === "Green") && range[0].row[0] === range[0].row[1] && range[0].column[0] === range[0].column[1]) {
                                XRayRoute(range, luckysheet?.getSheet()?.name);
                            }

                            //table1 hyperlink 
                            if ((luckysheet?.getSheet()?.name && ["Summary Checklist", FormsCompareSheetName]?.includes(luckysheet?.getSheet()?.name)) && range[0].row[0] === range[0].row[1] && range[0].column[0] === range[0].column[1]) {
                                tbl1HyperFun(range, luckysheet?.getSheet()?.name);
                            }

                            // code to pop-Up the endorsement dialog
                            if (range && range.length > 0 && range != undefined) {
                                if (luckysheet?.getSheet()?.name != 'QA Checklist' && luckysheet?.getSheet()?.name != 'Red' && luckysheet?.getSheet()?.name != 'Green') {
                                    let selectedRowIndex = range[0].row[0];
                                    let nullcolumncheck = luckysheet.getSheetData()[selectedRowIndex];
                                    const isAllNull = nullcolumncheck && Array.isArray(nullcolumncheck) ? nullcolumncheck.every(element => element === null) : true;
                                    if (!isAllNull) {
                                        let selectedRowIndex = range[0].row[0];
                                        let tabledata = luckysheet?.getSheet()?.name === "Summary Checklist" ? tableColumnDetails : luckysheet?.getSheet()?.name === FormsCompareSheetName ? formTableColumnDetails : luckysheet?.getSheet()?.name === "ProposalExclusions" ? proposalexTableColumnDetails : exTableColumnDetails;
                                        const excludedColumns = ["Id", "sheetPosition", "columnid"];
                                        const selectedTable = findTableForIndex(selectedRowIndex, tabledata, excludedColumns);
                                        let ranges = luckysheet.getRange();
                                        let selectedcolumnindex = ranges[0].column[0];
                                        let actionColumnTable = luckysheet?.getSheet()?.name === "Summary Checklist" ? tableColumnDetails[selectedTable] : luckysheet?.getSheet()?.name === FormsCompareSheetName ? formTableColumnDetails[selectedTable] : luckysheet?.getSheet()?.name === "ProposalExclusions" ? proposalexTableColumnDetails[selectedTable] : exTableColumnDetails[selectedTable];
                                        let values = actionColumnTable ? Object.values(actionColumnTable.columnNames) : [];
                                        let largestIndex = selectedTable == "ExTable 1" ? Math.max(...values) : Math.max(...values);
                                        let Actioncolumnindex = selectedTable == "ExTable 1" ? (largestIndex - 3) : selectedTable == "ProposalExTable 1" ? (largestIndex - 3) : (reqEndorsementColHideBrokerId.includes(brokerId) ? (largestIndex - 2) : (largestIndex - 3));
                                        let Requestcolumnindex = selectedTable == "ExTable 1" ? (largestIndex - 2) : selectedTable == "ProposalExTable 1" ? (largestIndex - 2) : (reqEndorsementColHideBrokerId.includes(brokerId) ? (largestIndex - 1) : (largestIndex - 2));
                                        let Notescolumnindex = selectedTable == "ExTable 1" ? (largestIndex - 1) : selectedTable == "ProposalExTable 1" ? (largestIndex - 1) : (reqEndorsementColHideBrokerId.includes(brokerId) ? (largestIndex - 4) : (largestIndex - 1))
                                        if (actionColumnTable !== undefined) {
                                            if (luckysheet?.getSheet()?.name === "Summary Checklist") {
                                                if (selectedTable != 'Table 3' && selectedRowIndex >= actionColumnTable.range.start + 2 || selectedTable == 'Table 3' && selectedRowIndex >= actionColumnTable.range.start + 3) {
                                                    // if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex || Notescolumnindex == selectedcolumnindex)) {
                                                    if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex)) {
                                                        toggleDropDialog()
                                                        return false;
                                                    }
                                                }
                                                // } else if ( brokerId != "1003" && luckysheet?.getSheet()?.name === ExclusionSheetName){
                                            } else if (AODDBrokerIds.includes(brokerId) && luckysheet?.getSheet()?.name === ExclusionSheetName) {
                                                if (selectedTable == "ExTable 1" && selectedRowIndex >= actionColumnTable.range.start + 2) {
                                                    // if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex || Notescolumnindex == selectedcolumnindex)) {
                                                    if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex)) {
                                                        toggleDropDialog()
                                                        return false;
                                                    }
                                                }
                                                // } else if ( brokerId != "1003" && luckysheet?.getSheet()?.name === FormsCompareSheetName){
                                            } else if (AODDBrokerIds.includes(brokerId) && luckysheet?.getSheet()?.name === "ProposalExclusions") {
                                                if (selectedTable == "ProposalExTable 1" && selectedRowIndex >= actionColumnTable.range.start + 2) {
                                                    // if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex || Notescolumnindex == selectedcolumnindex)) {
                                                    if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex)) {
                                                        toggleProposalExDropDialog()
                                                        return false;
                                                    }
                                                }
                                                // } else if ( brokerId != "1003" && luckysheet?.getSheet()?.name === FormsCompareSheetName){
                                            } else if (AODDBrokerIds.includes(brokerId) && luckysheet?.getSheet()?.name === FormsCompareSheetName) {
                                                // if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex || Notescolumnindex == selectedcolumnindex)) {
                                                if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex)) {
                                                    toggleDropDialog()
                                                    return false;
                                                }
                                            }
                                        } else {
                                            return false;
                                        }
                                    }
                                } else if (luckysheet?.getSheet()?.name == 'Red' || luckysheet?.getSheet()?.name == 'Green') {
                                    let selectedRowIndex = range[0].row[0];
                                    let selectedcolumnindex = range[0].column[0];
                                    let nullcolumncheck = luckysheet.getSheetData()[selectedRowIndex];
                                    const isAllNull = nullcolumncheck && Array.isArray(nullcolumncheck) ? nullcolumncheck.every(element => element === null) : true;
                                    if (!isAllNull) {
                                        if (luckysheet?.getSheet()?.name == 'Red') {
                                            const gradiationSet = sessionStorage.getItem('redTableRangeData');
                                            let parsedSet = gradiationSet ? JSON.parse(gradiationSet) : {};
                                            const excludedColumns = ["Actions on Discrepancy (from AMs)"];
                                            const selectedTable = findTableForIndex(selectedRowIndex, parsedSet, excludedColumns);
                                            let actionColumnTable = parsedSet[selectedTable];
                                            let values = actionColumnTable ? Object.keys(actionColumnTable.columnNames) : [];
                                            let largestIndex = values.indexOf("Document Viewer") + 1;
                                            let Actioncolumnindex = largestIndex + 1;
                                            let Requestcolumnindex = largestIndex + 2;
                                            let Notescolumnindex = largestIndex + 3;
                                            if (actionColumnTable !== undefined) {
                                                if (Actioncolumnindex != undefined && Requestcolumnindex != undefined && Notescolumnindex != undefined && nullcolumncheck[Actioncolumnindex].bg != 'rgb(139,173,212)') {
                                                    if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex || Notescolumnindex == selectedcolumnindex)) {
                                                        toggleDropDialog();
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        if (luckysheet?.getSheet()?.name == 'Green') {
                                            const gradiationSet = sessionStorage.getItem('greenTableRangeData');
                                            let parsedSet = gradiationSet ? JSON.parse(gradiationSet) : {};
                                            const excludedColumns = ["Actions on Discrepancy (from AMs)"];
                                            const selectedTable = findTableForIndex(selectedRowIndex, parsedSet, excludedColumns);
                                            let actionColumnTable = parsedSet[selectedTable];
                                            let values = actionColumnTable ? Object.keys(actionColumnTable.columnNames) : [];
                                            let largestIndex = values.indexOf("Document Viewer") + 1;
                                            let Actioncolumnindex = largestIndex + 1;
                                            let Requestcolumnindex = largestIndex + 2;
                                            let Notescolumnindex = largestIndex + 3;
                                            if (actionColumnTable !== undefined) {
                                                if (Actioncolumnindex != undefined && Requestcolumnindex != undefined && Notescolumnindex != undefined && nullcolumncheck[Actioncolumnindex].bg != 'rgb(139,173,212)') {
                                                    if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex || Notescolumnindex == selectedcolumnindex)) {
                                                        toggleDropDialog();
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        cellUpdated: function (r, c, oldValue, newValue, isRefresh) {
                            // Setting each cell rowlength as per the largest characters in a row 
                            let range = luckysheet.getRange();

                            if (r && c && r != undefined && c != undefined) {
                                let rowData = luckysheet.getcellvalue(r);
                                if (rowData && rowData.length > 0) {
                                    rowData = rowData.filter((f) => f != null);
                                    let length = [];
                                    let maxLength = 0;
                                    rowData.forEach((f) => {
                                        if (f?.ct?.s) {
                                            if (f?.ct?.s?.length > 1) {
                                                var text = '';
                                                f?.ct?.s?.forEach((e) => { text += e?.v })
                                                length.push(text?.length);
                                            } else { length.push(f?.ct?.s[0]?.v?.length) }
                                        }
                                    });
                                    length = Array.from(new Set(length));
                                    // let minLength = Math.min(...length) + 15;

                                    length.forEach((f) => {
                                        if (f > maxLength) {
                                            maxLength = f;
                                        }
                                    });

                                    let config = luckysheet.getConfig();
                                    config.rowlen[r] = maxLength && maxLength > 5 ? maxLength / 2 + 20 : 30;
                                    luckysheet.setConfig(config);
                                }
                            }

                            // Always revert the cell value to oldValue except the endorsement columns
                            if (range && range.length > 0 && range != undefined) {
                                let selectedColumnIndex = range[0].column[0];
                                let selectedRowIndex = range[0].row[0];
                                const redTableData = sessionStorage.getItem('redTableRangeData');
                                const greenTableData = sessionStorage.getItem('greenTableRangeData');
                                const parsedRedTableData = redTableData ? JSON.parse(redTableData) : {};
                                const parsedGreenTableData = greenTableData ? JSON.parse(greenTableData) : {};

                                let sheetflag = luckysheet?.getSheet()?.name;
                                if (luckysheet?.getSheet()?.name != 'QA Checklist' && luckysheet?.getSheet()?.name != ExclusionSheetName && luckysheet?.getSheet()?.name != "ProposalExclusions" && luckysheet?.getSheet()?.name !== 'CSR Pro') {
                                    const tabledata = luckysheet?.getSheet()?.name == 'Summary Checklist' ? tableColumnDetails : luckysheet?.getSheet()?.name == FormsCompareSheetName ? formTableColumnDetails : luckysheet?.getSheet()?.name == ExclusionSheetName ? exTableColumnDetails : luckysheet?.getSheet()?.name == 'Red' ? parsedRedTableData : luckysheet?.getSheet()?.name === "ProposalExclusions" ? proposalexTableColumnDetails : parsedGreenTableData;
                                    const excludedColumns = ["columnid"];
                                    const selectedTable = findTableForIndex(r, tabledata, excludedColumns);
                                    const tblSelectedRow = tabledata[selectedTable];
                                    if (tblSelectedRow != undefined) {
                                        if (selectedTable != 'Table 1' && selectedTable != "ExTable 1" && selectedTable != 'FormTable 1' && selectedTable != "ProposalExTable 1" ) {
                                            for (const key in tblSelectedRow.columnNames) {
                                                if (tblSelectedRow.columnNames[key] === 0) {
                                                    delete tblSelectedRow.columnNames[key];
                                                }
                                            }
                                            let values = tblSelectedRow ? Object.keys(tblSelectedRow.columnNames) : [];
                                            let docViewerIndex = values.indexOf("Document Viewer") + 2;
                                            if (oldValue && oldValue.ct && oldValue.ct.s && oldValue.ct.s[0] && oldValue != undefined) {
                                                if (selectedColumnIndex <= docViewerIndex) {
                                                    setCellValue(r, c, oldValue);
                                                }
                                            } else if (oldValue && oldValue.m && oldValue.v && oldValue != undefined) {
                                                if (selectedColumnIndex <= docViewerIndex) {
                                                    setCellValue(r, c, oldValue);
                                                }
                                            }
                                            luckysheet.exitEditMode();
                                            return false;
                                        } else if ((luckysheet?.getSheet()?.name != 'Red' && luckysheet?.getSheet()?.name != 'Green' && luckysheet?.getSheet()?.name != ExclusionSheetName && luckysheet?.getSheet()?.name != "ProposalExclusions") && (selectedTable == 'Table 1' || selectedTable == 'FormTable 1')) {
                                            let values = tblSelectedRow.columnNames && tblSelectedRow.columnNames[0] ? Object.values(tblSelectedRow.columnNames[0]) : [];
                                            let pageNumberColIndex = values.indexOf("PageNumber");
                                            let colCheck = luckysheet.find("Named Insured");
                                            if (luckysheet?.getSheet()?.name == 'Summary Checklist' && brokerId == "1167") {
                                                if (colCheck) {
                                                    if (colCheck[0]?.v == "Named Insured" && colCheck[0]?.column == 1) {
                                                        if (colCheck[0]?.row == r)
                                                            return true;
                                                    }
                                                    else if (oldValue && oldValue.m && oldValue.v && oldValue != undefined) {
                                                        setCellValue(r, c, oldValue);
                                                    }
                                                }
                                            }
                                            if (oldValue && oldValue.m && oldValue.v && oldValue != undefined) {
                                                setCellValue(r, c, oldValue);
                                            } else if (oldValue && oldValue.ct && oldValue.ct.s && oldValue.ct.s[0] && oldValue != undefined) {
                                                if (selectedColumnIndex <= pageNumberColIndex) {
                                                    setCellValue(r, c, oldValue);
                                                }
                                            }
                                            else {
                                                if (luckysheet?.getSheet()?.name != ExclusionSheetName) {
                                                    setCellValue(r, c, '');
                                                }

                                            }
                                        } else {
                                            if (luckysheet?.getSheet()?.name != ExclusionSheetName) {
                                                setCellValue(r, c, oldValue || '');
                                            }
                                        }
                                    }
                                } else if (luckysheet?.getSheet()?.name == ExclusionSheetName) {
                                    if (oldValue && oldValue?.ct && oldValue?.ct?.s && oldValue?.ct?.s[0] && oldValue != undefined) {
                                        if (selectedColumnIndex <= 4) {
                                            setCellValue(r, c, oldValue);
                                        }
                                    } else if (oldValue && oldValue.m && oldValue.v && oldValue != undefined) {
                                        if ((selectedColumnIndex <= 4) || (["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]?.includes(oldValue?.m))) {
                                            setCellValue(r, c, oldValue);
                                        }
                                    }
                                    luckysheet.exitEditMode();
                                    return false;
                                } else if (luckysheet?.getSheet()?.name == "ProposalExclusions") {
                                    if (oldValue && oldValue?.ct && oldValue?.ct?.s && oldValue?.ct?.s[0] && oldValue != undefined) {
                                        if (selectedColumnIndex <= 4) {
                                            setCellValue(r, c, oldValue);
                                        }
                                    } else if (oldValue && oldValue.m && oldValue.v && oldValue != undefined) {
                                        if ((selectedColumnIndex <= 4) || (["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]?.includes(oldValue?.m))) {
                                            setCellValue(r, c, oldValue);
                                        }
                                    }
                                    luckysheet.exitEditMode();
                                    return false;
                                } else if (luckysheet?.getSheet()?.name === 'CSR Pro') {
                                    if (oldValue && oldValue?.ct && oldValue?.ct?.s && oldValue?.ct?.s[0] && oldValue != undefined) {
                                        if (selectedColumnIndex <= 3) {
                                            setCellValue(r, c, oldValue);
                                        }
                                    } else if (oldValue && oldValue.m && oldValue.v && oldValue != undefined) {
                                        if ((selectedColumnIndex <= 3)) {
                                            setCellValue(r, c, oldValue);
                                        }
                                    }
                                    luckysheet.exitEditMode();
                                    return false;
                                }
                                // else if (sheetflag == 'QA Checklist') {
                                //     const tabledata = qacTableColumnDetails;
                                //     const keys = Object.keys(tabledata);

                                //     if (keys?.length > 0) {
                                //         keys?.forEach((key) => {
                                //             const tableData = qacTableColumnDetails[key];
                                //             const structuredTblObj = qacTblRangeStructureFun(tableData);
                                //             console.log(structuredTblObj)
                                //         })
                                //     }
                                // }
                            }
                        },
                        rangePasteBefore: function (range, data) {
                            // Denied the action of Copy/Paste for all the cells 
                            if (range && range.length > 0 && range != undefined) {
                                let selectedRowIndex = range[0].row[0];
                                let selectedColumnIndex = range[0].column[0];
                                const redTableData = sessionStorage.getItem('redTableRangeData');
                                const greenTableData = sessionStorage.getItem('greenTableRangeData');
                                const parsedRedTableData = redTableData ? JSON.parse(redTableData) : {};
                                const parsedGreenTableData = greenTableData ? JSON.parse(greenTableData) : {};

                                let flagName = luckysheet?.getSheet()?.name;
                                if (flagName === "CSR Pro") {
                                    return false;
                                }

                                if (luckysheet?.getSheet()?.name != 'QA Checklist' && luckysheet?.getSheet()?.name != ExclusionSheetName && luckysheet?.getSheet()?.name != "ProposalExclusions" && luckysheet?.getSheet()?.name != 'CSR Pro') {
                                    let tabledata = luckysheet?.getSheet()?.name == 'Summary Checklist' ? tableColumnDetails : luckysheet?.getSheet()?.name == FormsCompareSheetName ? formTableColumnDetails : luckysheet?.getSheet()?.name == ExclusionSheetName ? exTableColumnDetails : luckysheet?.getSheet()?.name == 'Red' ? parsedRedTableData : luckysheet?.getSheet()?.name == "ProposalExclusions" ? proposalexTableColumnDetails : parsedGreenTableData;
                                    const selectedTable = findTblRowAllIndex(selectedRowIndex, tabledata);
                                    const tblSelectedRow = tabledata[selectedTable];
                                    const bgColorIndexes = selectedTable == 'Table 3' ? tblSelectedRow?.range?.start + 1 : selectedTable == "ExTable 1" ? (tblSelectedRow?.range?.start || tblSelectedRow?.range?.start + 1) : selectedTable == "ProposalExTable 1" ? (tblSelectedRow?.range?.start || tblSelectedRow?.range?.start + 1) : tblSelectedRow?.range?.start;
                                    const filteredIndex = filterSelectedRowIndexForCopyPaste(tblSelectedRow, selectedRowIndex);
                                    let values = tblSelectedRow ? Object.values(tblSelectedRow.columnNames) : [];
                                    let largestIndex = selectedTable == "ExTable 1" ? Math.max(...Object.keys(values[0])) : selectedTable == "ProposalExTable 1" ? Math.max(...Object.keys(values[0])) : Math.max(...values);
                                    let Actioncolumnindex = selectedTable == "ExTable 1" ? largestIndex - 5 : selectedTable == "ProposalExTable 1" ? largestIndex - 5 : largestIndex - 3;
                                    let Requestcolumnindex = selectedTable == "ExTable 1" ? largestIndex - 4 : selectedTable == "ProposalExTable 1" ? largestIndex - 4 : largestIndex - 2;
                                    let Notescolumnindex = selectedTable == "ExTable 1" ? largestIndex - 3 : selectedTable == "ProposalExTable 1" ? largestIndex - 3 : largestIndex - 1;
                                    let NotesFreeFillcolumnindex = selectedTable == "ExTable 1" ? largestIndex - 2 : selectedTable == "ProposalExTable 1" ? largestIndex - 2 : largestIndex;

                                    if (tblSelectedRow !== undefined) {
                                        if (luckysheet?.getSheet()?.name != ExclusionSheetName && luckysheet?.getSheet()?.name != "ProposalExclusions") {
                                            if ((selectedTable != 'Table 3' && selectedRowIndex >= tblSelectedRow.range.start + 2 || selectedTable == 'Table 3' && selectedRowIndex >= tblSelectedRow.range.start + 3) || selectedRowIndex == bgColorIndexes) {
                                                if ((Actioncolumnindex != selectedColumnIndex && Requestcolumnindex != selectedColumnIndex && Notescolumnindex != selectedColumnIndex && NotesFreeFillcolumnindex != selectedColumnIndex) || selectedRowIndex == bgColorIndexes) {
                                                    let isAction = false;
                                                    range.forEach(item => {
                                                        const targetRow = item.row[0];
                                                        if (targetRow === filteredIndex) {
                                                            isAction = true;
                                                        }
                                                    });

                                                    if (isAction == true) {
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                } else if (luckysheet?.getSheet()?.name == ExclusionSheetName) {
                                    let tabledata = exTableColumnDetails;
                                    const selectedTable = "ExTable 1";
                                    const tblSelectedRow = tabledata[selectedTable];
                                    const filteredIndex = filterSelectedRowIndexForCopyPaste(tblSelectedRow, selectedRowIndex);
                                    let values = tblSelectedRow ? Object.values(tblSelectedRow.columnNames) : [];
                                    let largestIndex = Math.max(...values);
                                    let Actioncolumnindex = largestIndex - 3;
                                    let Requestcolumnindex = largestIndex - 2;
                                    let Notescolumnindex = largestIndex - 1;
                                    let NotesFreeFillcolumnindex = largestIndex;
                                    if ((selectedTable == "ExTable 1" && selectedRowIndex >= tblSelectedRow?.range.start + 2)) {
                                        if ((Actioncolumnindex != selectedColumnIndex && Requestcolumnindex != selectedColumnIndex && Notescolumnindex != selectedColumnIndex && NotesFreeFillcolumnindex != selectedColumnIndex)) {
                                            let isAction = false;
                                            range.forEach(item => {
                                                const targetRow = item.row[0];
                                                if (targetRow === filteredIndex) {
                                                    isAction = true;
                                                }
                                            });

                                            if (isAction == true) {
                                                return false;
                                            }
                                        }
                                    } else if (selectedRowIndex == tblSelectedRow?.range.start + 1) {
                                        let isHeader = false;
                                        range.forEach(item => {
                                            const targetRow = item.row[0];
                                            if (targetRow === tblSelectedRow?.range.start + 1) {
                                                isHeader = true;
                                                if (isHeader == true) {
                                                    return false;
                                                }
                                            }
                                        });
                                        if (isHeader == true) {
                                            return false;
                                        }
                                    }
                                }  else if (luckysheet?.getSheet()?.name == "ProposalExclusions") {
                                    let tabledata = exTableColumnDetails;
                                    const selectedTable = "ProposalExTable 1";
                                    const tblSelectedRow = tabledata[selectedTable];
                                    const filteredIndex = filterSelectedRowIndexForCopyPaste(tblSelectedRow, selectedRowIndex);
                                    let values = tblSelectedRow ? Object.values(tblSelectedRow.columnNames) : [];
                                    let largestIndex = Math.max(...values);
                                    let Actioncolumnindex = largestIndex - 3;
                                    let Requestcolumnindex = largestIndex - 2;
                                    let Notescolumnindex = largestIndex - 1;
                                    let NotesFreeFillcolumnindex = largestIndex;
                                    if ((selectedTable == "ProposalExTable 1" && selectedRowIndex >= tblSelectedRow?.range.start + 2)) {
                                        if ((Actioncolumnindex != selectedColumnIndex && Requestcolumnindex != selectedColumnIndex && Notescolumnindex != selectedColumnIndex && NotesFreeFillcolumnindex != selectedColumnIndex)) {
                                            let isAction = false;
                                            range.forEach(item => {
                                                const targetRow = item.row[0];
                                                if (targetRow === filteredIndex) {
                                                    isAction = true;
                                                }
                                            });

                                            if (isAction == true) {
                                                return false;
                                            }
                                        }
                                    } else if (selectedRowIndex == tblSelectedRow?.range.start + 1) {
                                        let isHeader = false;
                                        range.forEach(item => {
                                            const targetRow = item.row[0];
                                            if (targetRow === tblSelectedRow?.range.start + 1) {
                                                isHeader = true;
                                                if (isHeader == true) {
                                                    return false;
                                                }
                                            }
                                        });
                                        if (isHeader == true) {
                                            return false;
                                        }
                                    }
                                } else if (luckysheet?.getSheet()?.name == 'CSR Pro') {
                                    return false;
                                }
                            }
                        },
                        rangeSelect: function (index, sheet) {
                            //Handled the functionality for Del key operation and CTrl+ d shortcut options
                            let range = luckysheet?.getRange();
                            let currentFlag = luckysheet?.getSheet()?.name;

                            if (range && range.length > 0 && range != undefined) {
                                // if ( e.which != 40 ) {
                                let selectedRowIndex = range[0].row[0];
                                let selectedColumnIndex = range[0].column[0];
                                const targetrow = range[0].row[0];
                                const targetcolumn = range[0].column;
                                const sheetdatas = luckysheet.getSheetData();
                                const getrowdata = sheetdatas[targetrow - 1];
                                const redTableData = sessionStorage.getItem('redTableRangeData');
                                const greenTableData = sessionStorage.getItem('greenTableRangeData');
                                const parsedRedTableData = redTableData ? JSON.parse(redTableData) : {};
                                const parsedGreenTableData = greenTableData ? JSON.parse(greenTableData) : {};

                                if (luckysheet?.getSheet()?.name == 'CSR Pro') {
                                    const tabledata = summaryTableColumnDetails;
                                    if (tabledata != null) {
                                        const excludedColumns = ["Id", "Checklist Questions", "OBSERVATION", "Policy LOB", "Page Number", "IsMatched", "columnid", "Attached Forms"];
                                        const selectedTable = findTableForIndex(selectedRowIndex, tabledata, excludedColumns);

                                        if (index && sheet && sheet.length > 0) {
                                            document.onkeyup = function (e) {
                                                if (e.which != 40) {
                                                    if ((e.which == 46 || e.which == 8)) {
                                                        if ((selectedTable != "Table 1")) {
                                                            if ((selectedColumnIndex <= 3)) {
                                                                luckysheet.undo()
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                                if (luckysheet?.getSheet()?.name != 'QA Checklist' && luckysheet?.getSheet()?.name != 'CSR Pro') {
                                    const tabledata = luckysheet?.getSheet()?.name == 'Summary Checklist' ? tableColumnDetails : luckysheet?.getSheet()?.name == FormsCompareSheetName ? formTableColumnDetails : luckysheet?.getSheet()?.name == 'Red' ? parsedRedTableData : luckysheet?.getSheet()?.name == ExclusionSheetName ? exTableColumnDetails : luckysheet?.getSheet()?.name == "ProposalExclusions" ? proposalexTableColumnDetails : parsedGreenTableData;
                                    if (tabledata != null) {
                                        const excludedColumns = luckysheet?.getSheet()?.name == 'Summary Checklist' ? ["columnid"] : luckysheet?.getSheet()?.name == 'Red' ? ["columnid"]
                                            : luckysheet?.getSheet()?.name == 'Green' ? ["columnid"] : ["Id", "Checklist Questions", "OBSERVATION", "Policy LOB", "Page Number", "IsMatched", "columnid", "Attached Forms"];
                                        const selectedTable = findTableForIndex(selectedRowIndex, tabledata, excludedColumns);
                                        const tblSelectedRow = tabledata[selectedTable];
                                        if (luckysheet?.getSheet()?.name == FormsCompareSheetName && selectedTable != null) {
                                            for (const key in tblSelectedRow.columnNames) {
                                                if (tblSelectedRow.columnNames[key] === 0) {
                                                    delete tblSelectedRow.columnNames[key];
                                                }
                                            }
                                        }
                                        let values = tblSelectedRow ? Object.keys(tblSelectedRow.columnNames) : [];
                                        let docViewerIndex = values.indexOf("Document Viewer") + 2;
                                        let ctrlDDocViewerIndex = values.indexOf("Document Viewer") + 1;
                                        let Actioncolumnindex = ctrlDDocViewerIndex + 1;
                                        let Requestcolumnindex = ctrlDDocViewerIndex + 2;
                                        let Notescolumnindex = ctrlDDocViewerIndex + 3;
                                        let NotesFreeFillcolumnindex = ctrlDDocViewerIndex + 4;
                                        if (index && sheet && sheet.length > 0) {
                                            document.onkeyup = function (e) {
                                                if (e.which != 40 && luckysheet?.getSheet()?.name != "QA Checklist") {
                                                    if ((e.which == 46 || e.which == 8) && luckysheet?.getSheet()?.name != "QA Checklist") {
                                                        if ((selectedTable != "Table 1" && selectedTable != "FormTable 1" && selectedTable != "ExTable 1" && selectedTable != "ProposalExTable 1")) {
                                                            if ((selectedColumnIndex < docViewerIndex)) {
                                                                luckysheet.undo()
                                                            }
                                                        } else if (selectedTable == "Table 1" || selectedTable == "FormTable 1") {
                                                            const getRange = tableColumnDetails || formTableColumnDetails
                                                            const rangeEnd = getRange["Table 1"].range.end
                                                            const range = luckysheet.getRange();
                                                            const sheetrange = range[0].row[1];
                                                            if ((rangeEnd >= sheetrange || rangeEnd <= sheetrange)) {
                                                                luckysheet.undo()
                                                            }
                                                        } else if (selectedTable == "ExTable 1") {
                                                            // if (tblSelectedRow?.columnNames["PageNumber"] < selectedColumnIndex && tblSelectedRow?.columnNames["ActionOnDiscrepancy"] > selectedColumnIndex) {
                                                            if ((selectedColumnIndex <= 4) || selectedRowIndex == tblSelectedRow?.range?.start + 1) {
                                                                luckysheet.undo()
                                                            }
                                                        } else if (selectedTable == "ProposalExTable 1") {
                                                            // if (tblSelectedRow?.columnNames["PageNumber"] < selectedColumnIndex && tblSelectedRow?.columnNames["ActionOnDiscrepancy"] > selectedColumnIndex) {
                                                            if ((selectedColumnIndex <= 4) || selectedRowIndex == tblSelectedRow?.range?.start + 1) {
                                                                luckysheet.undo()
                                                            }
                                                        }
                                                    } else if (e.ctrlKey && e.which == 68) {
                                                        if (range[0].column[0] == range[0].column[1]) {
                                                            const getrowdata = sheetdatas[targetrow - 1];
                                                            const endorsementColumns = [1, 2, 3, 4];
                                                            endorsementColumns.forEach((aod) => {
                                                                if (getrowdata[targetcolumn[0]]) {
                                                                    if (Actioncolumnindex != undefined && Requestcolumnindex != undefined && Notescolumnindex != undefined && NotesFreeFillcolumnindex != undefined) {
                                                                        if ((Actioncolumnindex == selectedColumnIndex || Requestcolumnindex == selectedColumnIndex || Notescolumnindex == selectedColumnIndex || NotesFreeFillcolumnindex == selectedColumnIndex)) {
                                                                            setTimeout(() => {
                                                                                setCellValue(targetrow, (ctrlDDocViewerIndex + aod), getrowdata[ctrlDDocViewerIndex + aod]);
                                                                            }, 100);
                                                                        }
                                                                    }
                                                                }
                                                            });
                                                        } else {
                                                            const startColumn = ctrlDDocViewerIndex + 1;
                                                            const endColumn = Math.max(range[0].column[0], range[0].column[1]);
                                                            for (let idx = startColumn; idx <= endColumn; idx++) {
                                                                if (getrowdata[idx]) {
                                                                    if (Actioncolumnindex != undefined && Requestcolumnindex != undefined && Notescolumnindex != undefined && NotesFreeFillcolumnindex != undefined) {
                                                                        if ((Actioncolumnindex == selectedColumnIndex || Requestcolumnindex == selectedColumnIndex || Notescolumnindex == selectedColumnIndex || NotesFreeFillcolumnindex == selectedColumnIndex)) {
                                                                            setCellValue(targetrow, idx, getrowdata[idx]);
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                //  else if (luckysheet?.getSheet()?.name == ExclusionSheetName) {
                                //     const tabledata = exTableColumnDetails;
                                //     const tblSelectedRow = tabledata["ExTable 1"];
                                //     let values = Object.values(tblSelectedRow)[0];
                                //     let pageNoIndex = values.indexOf("PageNumber");
                                //     document.onkeyup = function (e) {
                                //         if (e.which != 40 && luckysheet?.getSheet()?.name != "QA Checklist") {
                                //             if ((e.which == 46 || e.which == 8) && luckysheet?.getSheet()?.name != "QA Checklist") {
                                //                 if ((selectedColumnIndex < pageNoIndex)) {
                                //                     luckysheet.undo();
                                //                 } else if (selectedRowIndex == tblSelectedRow?.range?.start + 1) {
                                //                     luckysheet.undo();
                                //                 }
                                //             }
                                //         }
                                //     }
                                // }
                            }
                        },
                        cellAllRenderBefore: function (data, sheetFile, ctx) {
                            let current = luckysheet.getSheet().name;
                            let endorsementColflag = sheetFile?.name;

                            if (sheetFile && sheetFile != undefined) {
                                setEndorsementColflag(endorsementColflag);
                            }

                            if (current === endorsementColflag && lastRenderedSheet !== current) {
                                lastRenderedSheet = current;
                                dataGrouping();
                            }
                        }
                    },
                    cellRightClickConfig: {
                        copy: false, // copy
                        copyAs: false, // copy as
                        paste: false, // paste
                        insertRow: false, // insert row
                        insertColumn: false, // insert column
                        deleteRow: false, // delete the selected row
                        deleteColumn: false, // delete the selected column
                        deleteCell: false, // delete cell
                        hideRow: false, // hide the selected row and display the selected row
                        hideColumn: false, // hide the selected column and display the selected column
                        rowHeight: false, // row height
                        columnWidth: false, // column width
                        clear: false, // clear content
                        matrix: false, // matrix operation selection
                        sort: false, // sort selection
                        filter: false, // filter selection
                        chart: false, // chart generation
                        image: false, // insert picture
                        link: false, // insert link
                        data: false, // data verification
                        cellFormat: false // Set cell format
                    },
                    showtoolbarConfig: {
                        moreFormats: false,
                        sortAndFilter: false,
                        link: false,
                        chart: false,
                        print: false,
                        textRotateMode: false,
                        image: false,
                        postil: false,
                        dataVerification: false,
                        splitColumn: false,
                        screenshot: false,
                        findAndReplace: false,
                    }
                };
                
                if (brokerId == '1178') {
                    const containsCSRLink = state.find(e => e.Tablename == 'Table 1').TemplateData.includes("Exdion CSRDigi");
                    const SummaryChecklistConfig = options.data.find(e => e.name == 'Summary Checklist');
                    const id = "img_" + new Date().getTime();
                    if (!SummaryChecklistConfig.images) {
                        SummaryChecklistConfig.images = {};
                    }
                    SummaryChecklistConfig.images[id] = {
                        src: window.location.origin + '/MCGILL_LOGO_GREEN_RGB.jpg',
                        type: "1",
                        originWidth: 120,
                        originHeight: 80,
                        default: {
                            left: 620,
                            top: containsCSRLink ? 260 : 200,
                            width: 200,
                            height: 70
                        },
                        "crop": {
                            "width": 200,
                            "height": 70,
                            "offsetLeft": 0,
                            "offsetTop": 0
                        },
                        "isFixedPos": false,
                        "fixedLeft": 620,
                        "fixedTop": containsCSRLink ? 260 : 200,
                        "border": {
                            "width": 0,
                            "radius": 0,
                            "style": "solid",
                            "color": "#000"
                        }
                    };
                }
                luckysheet.create(options);
            }
        }
    }

    // Function to handle cell selection and update values
    let previousCell = { row: null, col: null, text: 'string' };
    const handleCellSelection = async (range, flagCheck) => {
        if (flagCheck === 'Summary Checklist' || flagCheck === 'CSR Pro') {
            if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
                range[0]?.column[0] === range[0]?.column[1] && possibleColumns?.includes(range[0]?.row[0]) &&
                range[0]?.column[0] === 4) {

                const currentRow = range[0]?.row[0];
                const currentCol = 4;

                let getRowValue = luckysheet.getcellvalue(currentRow);
                const objectAtIndex4 = getRowValue[4];
                // console.log(objectAtIndex4);
                if (objectAtIndex4?.ct?.s && Array.isArray(objectAtIndex4?.ct?.s)) {
                    let varianceText = objectAtIndex4?.ct?.s[1]?.v;
                    const possibleVarianceText = ['Matched', 'All Variances', 'Full Variances', 'Variances', 'Mismatched', 'Mismatch', 'Details not available in the document', '“Add On” Forms Compare', '“Add On” Exclusion'];
                    if (possibleVarianceText?.includes(varianceText)) {
                        const revertBoxCode = {
                            "ct": {
                                "fa": "General",
                                "t": "inlineStr",
                                "s": [
                                    {
                                        "fs": "16",
                                        "v": "■ "
                                    },
                                    {
                                        "vt": "0",
                                        "ht": "1",
                                        "fs": "9",
                                        "un": 0,
                                        "bl": 1,
                                        "fc": "#0000ff",
                                        "ff": "\"Tahoma\"",
                                        "m": varianceText,
                                        "v": varianceText
                                    }
                                ]
                            },
                            "merge": null,
                            "w": 55,
                            "tb": "2",
                            "fc": "#0000ff",
                            "fs": "16"
                        }

                        // Update the current cell with revertBoxCode
                        setCellValue(currentRow, currentCol, revertBoxCode);

                        // Restore the previous cell with previouscode if there was a previous selection
                        if (previousCell.row !== null && previousCell.col !== null && previousCell.text !== undefined) {
                            const previousBoxcode = {
                                "ct": {
                                    "fa": "General",
                                    "t": "inlineStr",
                                    "s": [
                                        {
                                            "fs": "16",
                                            "v": "□ "
                                        },
                                        {
                                            "vt": "0",
                                            "ht": "1",
                                            "fs": "9",
                                            "un": 0,
                                            "bl": 1,
                                            "fc": "#0000ff",
                                            "ff": "\"Tahoma\"",
                                            "m": previousCell.text,
                                            "v": previousCell.text
                                        }
                                    ]
                                },
                                "merge": null,
                                "w": 55,
                                "tb": "2",
                                "fc": "#0000ff",
                                "fs": "16"
                            }
                            setCellValue(previousCell.row, previousCell.col, previousBoxcode);
                        }

                        // Update the previousCell to the current cell
                        previousCell.row = currentRow;
                        previousCell.col = currentCol;
                        previousCell.text = varianceText

                        if (['“Add On” Forms Compare', '“Add On” Exclusion']?.includes(varianceText)) {
                            const sheets = luckysheet.getluckysheetfile();
                            const sheetIndex = sheets.findIndex(sheet => sheet?.name === varianceText);
                            if (sheetIndex && sheetIndex > 0) {
                                setTimeout(() => {
                                    luckysheet.setSheetActive(sheetIndex);
                                }, 500);
                            }
                        }
                    }
                }
            }
        } else if (flagCheck === 'Red' || flagCheck === 'Green') {
            if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
                range[0]?.column[0] === range[0]?.column[1] && gradiation_possibleColumns?.includes(range[0]?.row[0]) &&
                range[0]?.column[0] === 4) {

                const currentRow = range[0]?.row[0];
                const currentCol = 4;

                let getRowValue = luckysheet.getcellvalue(currentRow);
                const objectAtIndex4 = getRowValue[4];
                // console.log(objectAtIndex4);
                if (objectAtIndex4?.ct?.s && Array.isArray(objectAtIndex4?.ct?.s)) {
                    let varianceText = objectAtIndex4?.ct?.s[1]?.v;
                    const possibleVarianceText = ['Matched', 'All Variances', 'Full Variances', 'Variances', 'Mismatched', 'Mismatch', 'Details not available in the document', '“Add On” Forms Compare', '“Add On” Exclusion'];
                    if (possibleVarianceText?.includes(varianceText)) {
                        const revertBoxCode = {
                            "ct": {
                                "fa": "General",
                                "t": "inlineStr",
                                "s": [
                                    {
                                        "fs": "16",
                                        "v": "■ "
                                    },
                                    {
                                        "vt": "0",
                                        "ht": "1",
                                        "fs": "9",
                                        "un": 0,
                                        "bl": 1,
                                        "fc": "#0000ff",
                                        "ff": "\"Tahoma\"",
                                        "m": varianceText,
                                        "v": varianceText
                                    }
                                ]
                            },
                            "merge": null,
                            "w": 55,
                            "tb": "2",
                            "fc": "#0000ff",
                            "fs": "16"
                        }

                        // Update the current cell with revertBoxCode
                        setCellValue(currentRow, currentCol, revertBoxCode);

                        // Restore the previous cell with previouscode if there was a previous selection
                        if (previousCell.row !== null && previousCell.col !== null && previousCell.text !== undefined) {
                            const previousBoxcode = {
                                "ct": {
                                    "fa": "General",
                                    "t": "inlineStr",
                                    "s": [
                                        {
                                            "fs": "16",
                                            "v": "□ "
                                        },
                                        {
                                            "vt": "0",
                                            "ht": "1",
                                            "fs": "9",
                                            "un": 0,
                                            "bl": 1,
                                            "fc": "#0000ff",
                                            "ff": "\"Tahoma\"",
                                            "m": previousCell.text,
                                            "v": previousCell.text
                                        }
                                    ]
                                },
                                "merge": null,
                                "w": 55,
                                "tb": "2",
                                "fc": "#0000ff",
                                "fs": "16"
                            }
                            setCellValue(previousCell.row, previousCell.col, previousBoxcode);
                        }

                        // Update the previousCell to the current cell
                        previousCell.row = currentRow;
                        previousCell.col = currentCol;
                        previousCell.text = varianceText

                        if (['“Add On” Forms Compare', '“Add On” Exclusion']?.includes(varianceText)) {
                            const sheets = luckysheet.getluckysheetfile();
                            const sheetIndex = sheets.findIndex(sheet => sheet?.name === varianceText);
                            if (sheetIndex && sheetIndex > 0) {
                                setTimeout(() => {
                                    luckysheet.setSheetActive(sheetIndex);
                                }, 500);
                            }
                        }
                    }
                }
            }
        }
    }

    const ExportClick = async (hasExport) => {
        //Broker configuration for exporting to Excel: If anything changes in this function keep an eye on the broker configuration
        const mergedData = [];
        let sheetnames = [];

        const lobSplit = props?.isLobSplitJob;
        const checklistypeState = props?.checklistypeState;
        const isCsrPro = checklistypeState?.MacroFile === "CSR Pro";

        let flagcheck = luckysheet.getAllSheets();

        if (isCsrPro) {
            flagcheck = flagcheck?.filter(e => e?.name == "CSR Pro")
        }

        for (let i = 0; i < flagcheck.length; i++) {
            sheetnames.push(flagcheck[i].name);
        }

        if (sheetnames?.includes("CSR Pro")) {
            generateExcelData(true, "CSR Pro", (dataFromOnUpdateClick) => {
                const SummaryData = dataFromOnUpdateClick;
                mergedData.push(...SummaryData);
            });
        }
        if (sheetnames?.includes("Summary Checklist")) {
            generateExcelData(true, "Summary Checklist", (dataFromOnUpdateClick) => {
                const Tabledata1 = dataFromOnUpdateClick;
                mergedData.push(...Tabledata1);
            });
        }
        if (sheetnames?.includes(FormsCompareSheetName)) {
            generateExcelData(true, FormsCompareSheetName, (dataFromOnUpdateClick) => {
                const Tabledata2 = dataFromOnUpdateClick;
                mergedData.push(...Tabledata2);
            });
        }
        const ApplicablebrokerIds = ["1003","1150","1005","1176","1132","1178","1162", "1190"];
        // let parseData =ApplicablebrokerIds

        if (ApplicablebrokerIds?.includes(brokerId)) {
            if (sheetnames?.includes(ExclusionSheetName)) {
                generateExcelData(true, ExclusionSheetName, (dataFromOnUpdateClick) => {
                    const Tabledata3 = dataFromOnUpdateClick;
                    mergedData.push(...Tabledata3);
                });
            }
        }

        if (brokerId == "1003") {
            if (sheetnames?.includes("ProposalExclusions")) {
                generateExcelData(true, "ProposalExclusions", (dataFromOnUpdateClick) => {
                    const Tabledata6 = dataFromOnUpdateClick;
                    mergedData.push(...Tabledata6);
                });
            }
        }

        if (sheetnames?.includes("Red")) {
            generateExcelData(true, "Red", (dataFromOnUpdateClick) => {
                const Tabledata4 = dataFromOnUpdateClick;
                mergedData.push(...Tabledata4);
            });
        }
        if (sheetnames?.includes("Green")) {
            generateExcelData(true, "Green", (dataFromOnUpdateClick) => {
                const Tabledata4 = dataFromOnUpdateClick;
                mergedData.push(...Tabledata4);
            });
        }
        if (sheetnames?.includes("QA Checklist")) {
            if (brokerId == '1162') {
                generateExcelData(true, "QA Checklist", (dataFromOnUpdateClick) => {
                    let Tabledata5 = dataFromOnUpdateClick;
                    if (Tabledata5?.length > 0) {
                        mergedData.push(...Tabledata5);
                    } else {
                        let mergedStaticData = staticDataforQacExport();
                        Tabledata5 = mergedStaticData;
                        mergedData.push(...Tabledata5);
                    }
                });
            }
        }
        const uniqueMergedData = mergedData.reduce((acc, curr) => {
            if (!acc.find(item => item?.TableName === curr?.TableName)) {
                acc.push(curr);
            }
            return acc;
        }, []);

        const filteredData = uniqueMergedData?.filter(item => {
            const data = JSON.parse(item.Data);
            return !Array.isArray(data) || data.length > 0;
        });

        let formTableData = [];
        filteredData?.forEach(item => {
            if (item?.TableName === "CsrTable 1" || item?.TableName === "ExclusionTable" || item?.TableName === "ProposalExclusionTable" || item?.TableName === "CsrFormTable 1" || item?.TableName === "RedTable 1" || item?.TableName === "GreenTable 1" || item?.TableName === "HighVolumeTable1" || item?.TableName === "summaryTable 1") {
                let k = item?.TableName == "CsrTable 1" ? "Table 1" : item?.TableName == "summaryTable 1" ? "SummarySheetTbl 1" : item?.TableName === "RedTable 1" ? "RedTbl 1" : item?.TableName === "GreenTable 1" ? "GreenTbl 1" : item?.TableName === "CsrFormTable 1" ? "CsrFormTbl 1" :  item.TableName;;
                formTableData.push(k);
            }
        });
        if (brokerId == '1162') {
            if (!formTableData.includes("HighVolumeTable1") ? true : false) {
                // if (luckysheet?.getSheet()?.name == 'QA Checklist'){
                formTableData.push("LowVolumeTable1")
                // }
            }
        }

        formTableData.push("csrflag");
        // Convert formTableData to JSON string and wrap it in double quotes
        const formTableDataJson = '"' + JSON.stringify(formTableData) + '"';

        const updatedFilteredData = filteredData.map(item => {
            if (item?.TableName === "ExclusionTable") {
                const parsedData = JSON.parse(item.Data);
                const updatedData = parsedData.map(row => {
                    if (row.hasOwnProperty("Exclusions")) {
                        row["Exclusion"] = row["Exclusions"];
                        delete row["Exclusions"];
                    }
                    return row;
                });

                return {
                    ...item,
                    Data: JSON.stringify(updatedData)
                };
            }

            return item;
        });

        const response = await exportExcelData(updatedFilteredData, formTableDataJson, lobSplit);

        const getLocalStgRowDatas = sessionStorage.getItem('endorsementRowData');
        await CsrPendingReport(props?.selectedJob, sessionStorage.getItem("csrAuthUserName") || sessionStorage.getItem("userName"), getLocalStgRowDatas, 'CSrExport-Save');
        // }
        return response;
    }

    const exportExcelData = async (Tabledata, TableNames, lobSplit) => {
        document.body.classList.add('loading-indicator');
        const Token = await processAndUpdateToken(token);
        updateGridAuditLog(jobId, "CSR-ExportData", "CSR-ExportExcel", (sessionStorage.getItem("csrAuthUserName") || sessionStorage.getItem("userName")));
        const headers = {
            'Authorization': `Bearer ${Token}`,
            "Content-Type": "application/json",
        };
        const apiUrl = `${baseUrl}/api/Excel/ExportExcel`;

        try {
            const response = await axios({
                method: "POST",
                url: apiUrl,
                headers: headers,
                data: {
                    Data: TableNames,
                    Tabledata: Tabledata,
                    LobSplitFlag: lobSplit
                },
                responseType: 'blob'
            });
            if (response.status !== 200) {
                return "error";
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${Tabledata[0].Id}GridExcel.xlsx`);
            document.body.appendChild(link);
            link.click();

            return "success";
        } catch (error) {
            // console.error('Error:', error);
            return "error";
        } finally {
            updateGridAuditLog(jobId, "CSR-ExportData-Success", "CSR-ExportExcel-Success1", (sessionStorage.getItem("csrAuthUserName") || sessionStorage.getItem("userName")));
            document.body.classList.remove('loading-indicator');
            return "success";
        }
    };

    const generateExcelData = (isExport, sheetName, callback) => {
        let flagCheck = sheetName;
        const propsData = luckysheet.getAllSheets()?.filter(f => f.name.includes(flagCheck))[0].data;
        setsheetState(propsData);
        const gradiationSet = flagCheck == 'Red' ? sessionStorage.getItem('redTableRangeData')
            : flagCheck == 'Green' ? sessionStorage.getItem('greenTableRangeData') : null;

        let parsedSet = JSON.parse(gradiationSet);
        const keys = flagCheck == "Summary Checklist" ? Object.keys(tableColumnDetails)
            : flagCheck == FormsCompareSheetName ? Object.keys(formTableColumnDetails) : flagCheck == 'Red' ? Object.keys(parsedSet) : flagCheck == 'Green' ? Object.keys(parsedSet)
                : flagCheck == "CSR Pro" ? Object.keys(summaryTableColumnDetails)
                    : flagCheck == ExclusionSheetName ? "" : "";

        const findTable = [];

        let summarySheetData = [];
        let policySheetData = [];
        let formCompareSheetData = [];
        let exclusionSheetData = [];
        let proposalexclusionSheetData = [];
        let qacSheetDataSet = [];
        let redSheetData = [];
        let greenSheetData = [];
        let exclusionSetArray;
        let lobResultAry = [];
        let proposalexclusionSetArray;

        if (flagCheck == "Summary Checklist") {
            if (keys?.length > 0 && propsData && propsData != undefined) {
                keys?.forEach((f) => {
                    const tableData = tableColumnDetails[f];
                    if (tableData && tableData?.range && tableData?.range?.start != undefined && tableData?.range?.end != undefined && tableData?.columnNames && tableData?.range?.end != '') {
                        let slicedData = propsData?.slice(tableData?.range?.start, tableData?.range?.end + 1);
                        if (f == 'Table 1') {
                            slicedData = slicedData?.slice(3);
                            slicedData = slicedData?.map(sublist => sublist?.filter(item => item !== null));
                        }
                        findTable.push(slicedData);
                    }
                });
            }

            let headerSpilttedArray = [];
            let tableDataSetArray = [];
            findTable?.map((e, index) => {
                if (index > 0) {
                    let tblIndex = [];
                    let tblColumnName = [];
                    let hasReachedLimit = false;

                    const lobMap = props?.data?.map(r => r.AvailableLobs)[0];
                    const indexMap = e[0][1].m;
                    const isTextInLobMap = lobMap?.includes(indexMap);
                    if (isTextInLobMap) {
                        index = 2;
                    }
                    const data = index == 2 ? e[1] : e[0];
                    data?.map((e1, index1) => {
                        if (index1 > 0 && !hasReachedLimit && e1?.m?.toLowerCase() != "document viewer") {
                            tblIndex.push(index1);
                            tblColumnName.push(e1?.m || e1?.v);
                        }
                        if (index1 > 0 && e1?.m?.toLowerCase() == "document viewer") {
                            hasReachedLimit = true;
                            let largeIndex = Math.max(...tblIndex);
                            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                                tblColumnName = [...tblColumnName, "Document Viewer", "ActionOnDiscrepancy", "Notes", "NotesFreeFill"]
                                tblIndex = [...tblIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3, largeIndex + 4];
                            } else {
                                tblColumnName = [...tblColumnName, "Document Viewer", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]
                                tblIndex = [...tblIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3, largeIndex + 4, largeIndex + 5];
                            }
                            headerSpilttedArray.push({ "Table": `Table ${index + 1}`, index: tblIndex, tblColumnName });
                        }

                        headerSpilttedArray?.forEach(table => {
                            const tableNumber = parseInt(table?.Table?.split(" ")[1]);
                            if (tableNumber === 2 || tableNumber === 4) {
                                table.tblColumnName[0] = "COVERAGE_SPECIFICATIONS_MASTER";
                            } else if (tableNumber >= 5 && tableNumber <= 70) {
                                table.tblColumnName[0] = "Coverage_Specifications_Master";
                            }
                        });
                    });
                }
            });
            headerSpilttedArray.forEach((item, index) => {
                item.Table = `Table ${index + 2}`;
            });
            // console.log(headerSpilttedArray)

            findTable?.map((f, index) => {
                if (index > 0) {
                    let keyValuePair = [];
                    f?.map((e, index1) => {
                        if (headerSpilttedArray[index - 1]?.Table == "Table 3" ? index1 > 2 : index1 > 1) {
                            let tableValueMap = headerSpilttedArray[index - 1];
                            if (tableValueMap) {
                                let object = {};
                                tableValueMap.index.map((i, index2) => {
                                    if (e[i]?.ct?.s && Array.isArray(e[i]?.ct?.s)) {
                                        let arrayS = e[i]?.ct?.s.filter((f) => f != null);
                                        let concatenatedValues = arrayS?.map(item => item?.v)?.join('');
                                        concatenatedValues = concatenatedValues?.replace(/\r\n/g, '~~');
                                        // if (concatenatedValues.endsWith('~~')) {
                                        //     concatenatedValues = concatenatedValues.slice(0, -2);
                                        // }
                                        // concatenatedValues = concatenatedValues.trimEnd();
                                        const finalValue = e[i]?.m || e[i]?.v || concatenatedValues;
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = finalValue;
                                    } else {
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = e[i]?.m || e[i]?.v || e[i]?.ct?.s;
                                    }
                                    if (tableValueMap.index?.length == index2 + 1) {
                                        keyValuePair.push(object);
                                    }
                                })
                            }
                        }
                        if (f?.length == index1 + 1) {
                            tableDataSetArray.push({ "Table": `CsrTable ${index + 1}`, DiscrepancyData: keyValuePair });
                        }
                    });
                }
            });
            // console.log(tableDataSetArray);

            let cellDatas = csrPolicyData;
            cellDatas?.forEach((t, index) => { t.Tablename = `CsrTable ${index + 1}` })
            let lobResult = [];
            let uniqueLobSet = new Set();

            if (tableDataSetArray && cellDatas && cellDatas?.length > 0 && tableDataSetArray?.length > 0) {
                cellDatas.forEach(table => {
                    if ((table?.Tablename !== 'CsrTable 1') && !uniqueLobSet.has(table?.Tablename)) {
                        let policyLOB = table?.TemplateData[0]["POLICY LOB"] || table?.TemplateData[0]["Policy LOB"];
                        lobResult.push({
                            Table: table.Tablename,
                            "POLICY LOB": policyLOB
                        });
                        uniqueLobSet.add(table.Tablename);
                    }
                });
                setLobResult(lobResult);

                // Create a mapping from Table to POLICY LOB
                let lobMapping = {};
                lobResult.forEach(item => {
                    lobMapping[item.Table] = item["POLICY LOB"];
                });

                // Assign the POLICY LOB value to the corresponding Table in tableDataSetArray
                tableDataSetArray?.forEach(table => {
                    if (lobMapping[table.Table]) {
                        table["POLICY_LOB"] = lobMapping[table.Table];
                        delete table.Table;
                    }
                });
                
                const documentViewerMap = {};

                cellDatas?.forEach(tbl => {
                    const tableName = tbl.Tablename;
                    if (tableName != 'CsrTable 1') {
                        if (tbl?.TemplateData && tbl?.TemplateData?.length > 0) {
                            documentViewerMap[tableName] = tbl?.TemplateData?.map(row => row["Document Viewer"]);
                        }
                    }
                });

                tableDataSetArray.forEach((f, index) => {
                    const TableName = "CsrTable " + (index + 2)
                    const updatedName = TableName?.replace('Csr', '').trim();
                    const columns = Object.keys(tableColumnDetails[updatedName]?.columnNames);
                    const startIndex = columns.indexOf("COVERAGE_SPECIFICATIONS_MASTER") + 1;
                    const endIndex = columns.indexOf("Document Viewer") + 1;
                    const filteredColumns = columns.slice(startIndex, endIndex - 1);

                    console.log(props)   
                    const filterRec = Array.isArray(
                            props?.data?.find(e => e?.Tablename === updatedName)?.TemplateData
                        )
                            ? props.data.find(e => e?.Tablename === updatedName).TemplateData
                            : [];
                    console.log(filterRec, "filterRec")

                    let data = f?.DiscrepancyData;
                    if (data && data?.length > 0) {
                        data = (data?.map((item, index) => {
                            item["policyLob"] = f?.POLICY_LOB;
                             const matchedRec = filterRec?.find(rec => {
                                return filteredColumns.every(col => {
                                    return rec[col]?.replace(/\s*~~Page/g, 'Page')?.replace(/\s*~~Current policy attached/g, 'Current policy attached')?.replace(/\s*~~Current policy listed/g, 'Current policy listed')?.replace(/~~/g, '')?.trim() 
                                    === 
                                    item[col]?.replace(/\s*~~Page/g, 'Page')?.replace(/\s*~~Current policy attached/g, 'Current policy attached')?.replace(/\s*~~Current policy listed/g, 'Current policy listed')?.replace(/~~/g, '')?.trim();
                                });

                            });

                            console.log(matchedRec, "matchedRec")
                        
                            // Replace Document Viewer value if mapping exists
                            if (documentViewerMap[TableName] && Array.isArray(documentViewerMap[TableName])) {
                                if (matchedRec) {
                                    let docItem = item["Document Viewer"] == " " ? item["Document Viewer"].trim() : item["Document Viewer"];
                                    if (docItem != "") {
                                        item["Document Viewer"] = matchedRec["Document Viewer"];
                                    }
                                }
                            }

                            // Replace 'Click here' msg to an empty string
                            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                                if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["Notes"] === "~~Click here" && item["NotesFreeFill"] === "~~Click here"
                                ) || (item["ActionOnDiscrepancy"] === "Click here" && item["Notes"] === "Click here" && item["NotesFreeFill"] === "Click here"
                                    ) ||
                                    (item["ActionOnDiscrepancy"] === " Click here" && item["Notes"] === " Click here" && item["NotesFreeFill"] === " Click here"
                                    )) {
                                    item["ActionOnDiscrepancy"] = "";
                                    item["Notes"] = "";
                                    item["NotesFreeFill"] = "";
                                }
                            } else if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["RequestEndorsement"] == "~~Click here"
                                && item["Notes"] == "~~Click here" && item["NotesFreeFill"] == "~~Click here"
                            ) || (item["ActionOnDiscrepancy"] === "Click here" && item["RequestEndorsement"] == "Click here"
                                && item["Notes"] == "Click here" && item["NotesFreeFill"] == "Click here"
                                ) || (item["ActionOnDiscrepancy"] === " Click here" && item["RequestEndorsement"] == " Click here"
                                    && item["Notes"] == " Click here" && item["NotesFreeFill"] == " Click here"
                                )) {
                                item["ActionOnDiscrepancy"] = "";
                                item["RequestEndorsement"] = "";
                                item["Notes"] = "";
                                item["NotesFreeFill"] = "";
                            } else {
                                ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"].forEach(key => {
                                    if ((item[key] === "~~Click here") || (item[key] === "Click here") || (item[key] === " Click here")) {
                                        item[key] = "";
                                    }
                                })
                            }
                            return item;
                        }));
                    }


                    const cleanedData = data?.filter(entry =>
                        !Object.values(entry).includes(undefined)
                    );

                    policySheetData.push({ TableName, Data: JSON.stringify(cleanedData) });
                });
            }
        }
        else if (flagCheck == "CSR Pro") {
            if (keys?.length > 0 && propsData && propsData != undefined) {
                keys?.forEach((f) => {
                    const tableData = summaryTableColumnDetails[f];
                    if (tableData && tableData?.range && tableData?.range?.start != undefined && tableData?.range?.end != undefined && tableData?.columnNames && tableData?.range?.end != '') {
                        let slicedData = propsData?.slice(tableData?.range?.start, tableData?.range?.end + 1);
                        if (f == 'Table 1') {
                            slicedData = slicedData?.slice(4);
                            slicedData = slicedData?.map(sublist => sublist?.filter(item => item !== null));
                        }
                        findTable.push(slicedData);
                    }
                });
            }

            let headerSpilttedArray = [];
            let tableDataSetArray = [];
            findTable?.map((e, index) => {
                if (index > 0  && index < findTable?.length - 1) {
                    let tblIndex = [];
                    let tblColumnName = [];
                    let hasReachedLimit = false;

                    const data =  e[0];
                    data?.map((e1, index1) => {
                        if (index1 > 0 && !hasReachedLimit && e1?.m?.toLowerCase() !== "document viewer") {
                            tblIndex.push(index1);
                            tblColumnName.push(e1?.m || e1?.v);
                        }
                        if (index1 > 0 && e1?.m?.toLowerCase() === "document viewer") {
                            hasReachedLimit = true;
                            let largeIndex = Math.max(...tblIndex);
                            tblColumnName = [...tblColumnName, "Document Viewer"]
                            tblIndex = [...tblIndex, largeIndex + 1];
                            lobResultAry?.push({
                                Table: `summaryTable ${index + 1}`,
                                "POLICY LOB": tblColumnName[0]
                            });
                            headerSpilttedArray.push({ "Table": `Table ${index + 1}`, index: tblIndex, tblColumnName });
                        }

                        headerSpilttedArray?.forEach(table => {
                            const tableNumber = parseInt(table?.Table?.split(" ")[1]);
                            if (tableNumber === 2 || tableNumber === 4 || tableNumber === 3) {
                                table.tblColumnName[0] = "CoverageSpecificationMaster";
                            } else if (tableNumber >= 5 && tableNumber <= 70) {
                                table.tblColumnName[0] = "CoverageSpecificationMaster";
                            }
                        });
                    });
                }
            });
            headerSpilttedArray.forEach((item, index) => {
                item.Table = `Table ${index + 2}`;
            });

            findTable?.map((f, index) => {
                if (index > 0  && index < findTable.length - 1) {
                    let keyValuePair = [];
                    f?.map((e, index1) => {
                        if (index1 > 1) {
                            let tableValueMap = headerSpilttedArray[index - 1];
                            if (tableValueMap) {
                                let object = {};
                                tableValueMap.index.map((i, index2) => {
                                    if (e[i]?.ct?.s && Array.isArray(e[i]?.ct?.s)) {
                                        let arrayS = e[i]?.ct?.s.filter((f) => f != null);
                                        let concatenatedValues = arrayS?.map(item => item?.v)?.join('');
                                        concatenatedValues = concatenatedValues?.replace(/\r\n/g, '~~');
                                        const finalValue = e[i]?.m || e[i]?.v || concatenatedValues;
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = finalValue;
                                    } else {
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = e[i]?.m || e[i]?.v || e[i]?.ct?.s;
                                    }
                                    if (tableValueMap.index?.length == index2 + 1) {
                                        keyValuePair.push(object);
                                    }
                                })
                            }
                        }
                        if (f?.length == index1 + 1) {
                            tableDataSetArray.push({ "Table": `summaryTable ${index + 1}`, DiscrepancyData: keyValuePair });
                        }
                    });
                }
            });

            let cellDatas = JSON.parse(sessionStorage.getItem('summarryData'));
            cellDatas?.forEach((t, index) => { t.Tablename = `summaryTable ${index + 1}` })
            let lobResult = [];
            let uniqueLobSet = new Set();

            if (tableDataSetArray && cellDatas && cellDatas?.length > 0 && tableDataSetArray?.length > 0) {
                cellDatas.forEach(table => {
                    if ((table?.Tablename !== 'summaryTable 1') && !uniqueLobSet.has(table?.Tablename)) {
                        let policyLOB = table?.Tablename == 'summaryTable 2' ? "Common Declarations" : table?.Tablename == 'summaryTable 3' ? JSON.parse(sessionStorage.getItem('lob'))
                            : table?.Tablename == 'summaryTable 4' ? table?.TemplateData[0]?.PolicyLob
                                : table?.Tablename == 'summaryTable 5' ? table?.TemplateData[0]?.PolicyLob
                                    : table?.Tablename == 'summaryTable 6' ? table?.TemplateData[0]?.PolicyLob
                                        : table?.Tablename == 'summaryTable 7' ? table?.TemplateData[0]?.PolicyLob : ''

                        lobResult.push({
                            Table: table.Tablename,
                            "POLICY LOB": policyLOB
                        });
                        uniqueLobSet.add(table.Tablename);
                    }
                });
                setLobResult(lobResult);

                // Create a mapping from Table to POLICY LOB
                let lobMapping = {};
                if(props.isLobSplitJob) {
                    lobResultAry?.forEach(item => {
                        lobMapping[item.Table] = item["POLICY LOB"];
                    });
                } else {
                    lobResult.forEach(item => {
                        lobMapping[item.Table] = item["POLICY LOB"];
                    });
                }

                // Assign the POLICY LOB value to the corresponding Table in tableDataSetArray
                tableDataSetArray?.forEach(table => {
                    if (lobMapping[table.Table]) {
                        table["POLICY_LOB"] = lobMapping[table.Table];
                        delete table.Table;
                    }
                });

                let filteredCellDatas = lobResultAry?.map(lob => {
                    const matchedRecords = [];
                    cellDatas?.forEach(table => {
                        const filteredTemplateData =
                            table?.TemplateData?.filter(
                                item =>
                                    item?.PolicyLob === lob["POLICY LOB"]
                            );

                        if (filteredTemplateData?.length > 0) {

                            matchedRecords.push({
                                ...table,
                                TemplateData: filteredTemplateData
                            });
                        }
                    });

                    return {
                        Tablename: lob.Table,
                        "POLICY LOB": lob["POLICY LOB"],
                        TemplateData: matchedRecords
                    };
                })?.filter(x => x?.TemplateData?.length > 0);

                const documentViewerMap = {};

                if(props.isLobSplitJob) {
                    filteredCellDatas?.forEach(tbl => {
                        const tableName = tbl.Tablename;
                        if (tableName != 'summaryTable 1') {
                            if (tbl?.TemplateData && tbl?.TemplateData?.length > 0) {
                                documentViewerMap[tableName] = tbl?.TemplateData[0]?.TemplateData?.map(row => row["DocumentViewer"]);
                            }
                        }
                    });
                } else {
                    cellDatas?.forEach(tbl => {
                        const tableName = tbl.Tablename;
                        if (tableName != 'summaryTable 1') {
                            if (tbl?.TemplateData && tbl?.TemplateData?.length > 0) {
                                documentViewerMap[tableName] = tbl?.TemplateData?.map(row => row["DocumentViewer"]);
                            }
                        }
                    });
                }

                tableDataSetArray.forEach((f, index) => {
                    const TableName = "summaryTable " + (index + 2)
                    let data = f?.DiscrepancyData;
                    if (data && data?.length > 0) {
                        data = (data?.map((item, index) => {
                            item["policyLob"] = f?.POLICY_LOB;

                            // Replace Document Viewer value if mapping exists
                            if (documentViewerMap[TableName] && Array.isArray(documentViewerMap[TableName])) {
                                if (index < documentViewerMap[TableName].length) {
                                    let docItem = item["Document Viewer"] == " " ? item["Document Viewer"].trim() : item["Document Viewer"];
                                    if (docItem != "") {
                                        item["Document Viewer"] = documentViewerMap[TableName][index];
                                    }
                                }
                            }


                            return item;
                        }));
                    }


                    const cleanedData = data?.filter(entry =>
                        !Object.values(entry).includes(undefined)
                    );

                    summarySheetData.push({ TableName, Data: JSON.stringify(cleanedData) });
                });
            }
        }
        else if (flagCheck == FormsCompareSheetName) {
            keys?.forEach((f) => {
                const tableData = formTableColumnDetails[f];
                if (tableData && tableData?.range && tableData?.range?.start != undefined && tableData?.range?.end != undefined && tableData?.columnNames && tableData?.range?.end != '') {
                    let slicedData = propsData.slice(tableData?.range?.start, tableData?.range?.end + 1);
                    if (f == 'FormTable 1') {
                        slicedData = slicedData?.slice(3);
                        slicedData = slicedData?.map(sublist => sublist?.filter(item => item !== null));
                    }
                    findTable.push(slicedData);
                }
            });

            let headerSpilttedArray = [];
            let tableDataSetArray = [];

            let limitReached = false;
            findTable?.map((e, index) => {
                if (index >= 1 && !limitReached) {
                    let tblIndex = [];
                    let tblColumnName = [];
                    let hasReachedLimit = false;
                    let tabledata = formTableColumnDetails;
                    for (let tableName in tabledata) {
                        if (tableName != "FormTable 1") {
                            let tableInfo = tabledata[tableName];
                            for (let columnName in tableInfo.columnNames) {
                                let columnValue = tableInfo.columnNames[columnName];
                                if (columnValue === 0) {
                                    delete tableInfo.columnNames[columnName];
                                    if (tableInfo.columnNames.hasOwnProperty("Attached Forms")) {
                                        delete tableInfo.columnNames["Attached Forms"];
                                    }
                                }
                            }
                        }
                    }

                    const data = index == 1 ? e[1] : e[1];
                    const filteredData = data?.filter(item => item !== null);
                    filteredData?.forEach((e1, index1) => {
                        if (e1 && e1?.m) {
                            if (index1 >= 0 && !hasReachedLimit && e1?.m?.toLowerCase() != "document viewer" && e1?.m != "Actions on Discrepancy (from AMs)") {
                                tblIndex.push(index1);
                                tblColumnName.push(e1?.m || e1?.v);
                            }
                        }
                        if (index == 1 && e1?.m?.toLowerCase() == "document viewer" && keys[1] == 'FormTable 2') {
                            tblColumnName = tblColumnName.filter(column => column !== undefined);
                            let largeIndex = Math.max(...tblIndex);
                            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                                tblColumnName = [...tblColumnName, "Document Viewer", "ActionOnDiscrepancy", "Notes", "NotesFreeFill"]
                                tblIndex = [...tblIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3, largeIndex + 4];
                            } else {
                                tblColumnName = [...tblColumnName, "Document Viewer", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]
                                tblIndex = [...tblIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3, largeIndex + 4, largeIndex + 5];
                            }
                            headerSpilttedArray.push({ "Table": `FormTable ${index + 1}`, index: tblIndex, tblColumnName });
                        }
                    });
                    if (index == 2 && keys[2] == 'FormTable 3') {
                        tblColumnName = tblColumnName.filter(column => column !== undefined);
                        let largeIndex = Math.max(...tblIndex);
                        if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                            tblColumnName = [...tblColumnName, "ActionOnDiscrepancy", "Notes", "NotesFreeFill"]
                            tblIndex = [...tblIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3];
                        } else {
                            tblColumnName = [...tblColumnName, "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]
                            tblIndex = [...tblIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3, largeIndex + 4];
                        }
                        headerSpilttedArray.push({ "Table": `FormTable ${index + 1}`, index: tblIndex, tblColumnName });
                    }
                }
                headerSpilttedArray?.forEach(table => {
                    if (table.Table === "FormTable 2" || table.Table === "FormTable 3") {
                        table.tblColumnName[0] = "COVERAGE_SPECIFICATIONS_MASTER";
                    }
                });
                headerSpilttedArray?.forEach(item => {
                    const tableDetails = formTableColumnDetails[item.Table];
                    if (tableDetails && tableDetails.columnNames) {
                        const validColumns = Object.keys(tableDetails.columnNames);
                        item.tblColumnName = item?.tblColumnName?.filter(column => validColumns?.includes(column));
                        item.index = Array.from({ length: item.tblColumnName.length }, (_, i) => i);
                    }
                });
            });

            findTable?.map((f, index) => {
                if (index >= 1) {
                    let keyValuePair = [];
                    f?.map((e, index1) => {
                        if (index1 > 0) {
                            let tableValueMap = headerSpilttedArray[index - 1];
                            if (tableValueMap) {
                                let object = {};
                                tableValueMap.index.map((i, index2) => {
                                    i = i + 1;
                                    if (e[i]?.ct?.s && Array.isArray(e[i]?.ct?.s)) {
                                        let filteredS = e[i]?.ct?.s.filter((f) => f != null);
                                        let concatenatedValues = filteredS?.map(item => item?.v)?.join('');
                                        concatenatedValues = concatenatedValues?.replace(/\r\n/g, '~~');
                                        // if (concatenatedValues.endsWith('~~')) {
                                        //     concatenatedValues = concatenatedValues.slice(0, -2);
                                        // }
                                        // concatenatedValues = concatenatedValues.trimEnd();
                                        const finalValue = e[i]?.m || e[i]?.v || concatenatedValues;
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = finalValue;
                                    } else {
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = e[i]?.m || e[i]?.v || e[i]?.ct?.s;
                                    }
                                    if (tableValueMap.index?.length == index2 + 1) {
                                        keyValuePair.push(object);
                                    }
                                })
                            }
                        }
                    });
                    let slicedKeyValuePair = keyValuePair.slice(2);
                    tableDataSetArray.push({ Table: `FormTable ${index + 1}`, DiscrepancyData: slicedKeyValuePair });
                }
            });

            let cellDatas = formsComparedata;
            let lobResult = [];
            let uniqueLobSet = new Set();

            if (tableDataSetArray && cellDatas && cellDatas?.length > 0 && tableDataSetArray?.length > 0) {
                cellDatas?.forEach(table => {
                    if ((table.Tablename !== 'FormTable 1') && !uniqueLobSet.has(table.Tablename)) {
                        let policyLOB = table?.TemplateData[0]["POLICY LOB"] || table?.TemplateData[0]["Policy LOB"];
                        lobResult.push({
                            Table: table.Tablename,
                            "POLICY LOB": policyLOB
                        });
                        uniqueLobSet.add(table.Tablename);
                    }
                });
                setLobResult(lobResult);

                // Create a mapping from Table to POLICY LOB
                let lobMapping = {};
                lobResult?.forEach(item => {
                    lobMapping[item.Table] = item["POLICY LOB"];
                });

                // Assign the POLICY LOB value to the corresponding Table in tableDataSetArray
                tableDataSetArray?.forEach(table => {
                    if (lobMapping[table.Table]) {
                        table["POLICY_LOB"] = lobMapping[table.Table];
                        delete table.Table;
                    }
                });

                const documentViewerMap = {};
                formsComparedata?.forEach(tbl => {
                    let tableName = tbl.Tablename;
                    // Adjust tableName from 'FormTable' to 'CsrFormTable'
                    if (tableName.startsWith('FormTable ')) {
                        const numberPart = tableName.split(' ')[1];
                        tableName = `CsrFormTable ${numberPart}`;
                    }
                    if (tableName != 'CsrFormTable 1' && tableName != 'CsrFormTable 3') {
                        if (tbl?.TemplateData && tbl?.TemplateData?.length > 0) {
                            documentViewerMap[tableName] = tbl?.TemplateData?.map(row => row["Document Viewer"]);
                        }
                    }
                });

                tableDataSetArray?.forEach((f, index) => {
                    const TableName = "CsrFormTable " + (index + 2);
                    let data = f?.DiscrepancyData;
                    if (data && data?.length > 0) {
                        data = (data.map((item, index) => {
                            item["policyLob"] = f?.POLICY_LOB;

                            // Replace Document Viewer value if mapping exists
                            if (documentViewerMap[TableName] && Array.isArray(documentViewerMap[TableName])) {
                                if (index < documentViewerMap[TableName].length) {
                                    let docItem = item["Document Viewer"] == " " ? item["Document Viewer"].trim() : item["Document Viewer"];
                                    if (docItem != "") {
                                        item["Document Viewer"] = documentViewerMap[TableName][index];
                                    }
                                }
                            }

                            // Replace 'Click here' msg to an empty string
                            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                                if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["Notes"] === "~~Click here" && item["NotesFreeFill"] === "~~Click here"
                                ) || (item["ActionOnDiscrepancy"] === "Click here" && item["Notes"] === "Click here" && item["NotesFreeFill"] === "Click here"
                                    ) ||
                                    (item["ActionOnDiscrepancy"] === " Click here" && item["Notes"] === " Click here" && item["NotesFreeFill"] === " Click here"
                                    )) {
                                    item["ActionOnDiscrepancy"] = "";
                                    item["Notes"] = "";
                                    item["NotesFreeFill"] = "";
                                }
                            } else if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["RequestEndorsement"] == "~~Click here"
                                && item["Notes"] == "~~Click here" && item["NotesFreeFill"] == "~~Click here"
                            ) || (item["ActionOnDiscrepancy"] === "Click here" && item["RequestEndorsement"] == "Click here"
                                && item["Notes"] == "Click here" && item["NotesFreeFill"] == "Click here"
                                ) || (item["ActionOnDiscrepancy"] === " Click here" && item["RequestEndorsement"] == " Click here"
                                    && item["Notes"] == " Click here" && item["NotesFreeFill"] == " Click here"
                                )) {
                                item["ActionOnDiscrepancy"] = "";
                                item["RequestEndorsement"] = "";
                                item["Notes"] = "";
                                item["NotesFreeFill"] = "";
                            } else {
                                ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"].forEach(key => {
                                    if ((item[key] === "~~Click here") || (item[key] === "Click here") || (item[key] === " Click here")) {
                                        item[key] = "";
                                    }
                                })
                            }
                            return item;
                        }));
                    }

                    const cleanedData = data.filter(entry =>
                        !Object.values(entry).includes(undefined)
                    );
                    formCompareSheetData.push({ TableName, Data: JSON.stringify(cleanedData) });
                });
            }
        } else if (flagCheck == 'Red' || flagCheck == 'Green') {
            keys?.forEach((f) => {
                const tableData = parsedSet[f];
                if (tableData && tableData?.range && tableData?.range?.start != undefined && tableData?.range?.end != undefined && tableData?.range?.end != '') {
                    let slicedData = propsData?.slice(tableData?.range?.start, tableData?.range?.end + 1);
                    if (f == 'Table 1') {
                        slicedData = slicedData?.map(sublist => sublist.filter(item => item !== null));
                    }
                    findTable.push(slicedData);
                }
            });

            let headerSpilttedArray = [];
            let tableDataSetArray = [];

            findTable?.map((e, index) => {
                if (index > 0) {
                    let tblIndex = [];
                    let tblColumnName = [];
                    let hasReachedLimit = false;
                    let data;

                    data = index == 2 ? e[1] : e[0];
                    if (flagCheck == 'Green') {
                        if (data[0] === null && data[1] !== null && data[1]?.m !== 'Are the forms and endorsements attached, listed in current term policy?') {
                            if (e[1]) {
                                data = e[1];
                            }
                        } else if (data[0] === null) {
                            data = e[0];
                        } else if (data[1]?.m === 'Are the forms and endorsements attached, listed in current term policy?') {
                            data = e[0];
                        }
                    } else {
                        data = index == 2 ? e[1] : e[0];
                    }

                    const containsActionsOnDiscrepancy = e[1]?.some(obj => obj && obj.m === "Actions on Discrepancy");
                    data = containsActionsOnDiscrepancy ? e[0] : e[1];

                    data?.map((e1, index1) => {
                        if (index1 > 0 && !hasReachedLimit && e1?.m?.toLowerCase() != "document viewer") {
                            tblIndex.push(index1);
                            tblColumnName.push(e1?.m || e1?.v);
                        }
                        if (index1 > 0 && e1?.m?.toLowerCase() == "document viewer") {
                            hasReachedLimit = true;
                            let largeIndex = Math.max(...tblIndex);
                            if (reqEndorsementColHideBrokerId.includes(brokerId)) {
                                tblColumnName = [...tblColumnName, "Document Viewer", "ActionOnDiscrepancy", "Notes", "NotesFreeFill"]
                                tblIndex = [...tblIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3, largeIndex + 4];
                            } else {
                                tblColumnName = [...tblColumnName, "Document Viewer", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]
                                tblIndex = [...tblIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3, largeIndex + 4, largeIndex + 5];
                            }
                            headerSpilttedArray.push({ "Table": `Table ${index + 1}`, index: tblIndex, tblColumnName });
                        }
                        headerSpilttedArray.forEach((table, idx) => {
                            if (table.Table.startsWith('Table ')) {
                                const tableNumber = parseInt(table.Table.replace('Table ', ''), 10);

                                if (!isNaN(tableNumber)) {
                                    if (tableNumber <= 4) {
                                        // For tables up to Table 4
                                        table.tblColumnName[0] = "COVERAGE_SPECIFICATIONS_MASTER";
                                    } else {
                                        // For tables after Table 4
                                        table.tblColumnName[0] = "Coverage_Specifications_Master";
                                    }
                                }
                            }
                        });
                    });
                }
            });

            findTable.map((f, index) => {
                if (index > 0) {
                    let keyValuePair = [];
                    f?.map((e, index1) => {
                        if (index1 > 1) {
                            let tableValueMap = headerSpilttedArray[index - 1];
                            if (tableValueMap) {
                                let object = {};
                                tableValueMap.index.map((i, index2) => {
                                    if (e[i]?.ct?.s && Array.isArray(e[i]?.ct?.s)) {
                                        let arrayS = e[i]?.ct?.s.filter((f) => f != null);
                                        let concatenatedValues = arrayS?.map(item => item?.v)?.join('');
                                        concatenatedValues = concatenatedValues?.replace(/\r\n/g, '~~');
                                        // if (concatenatedValues.endsWith('~~')) {
                                        //     concatenatedValues = concatenatedValues.slice(0, -2);
                                        // }
                                        // concatenatedValues = concatenatedValues.trimEnd();
                                        const finalValue = e[i]?.m || e[i]?.v || concatenatedValues;
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = finalValue;
                                    } else {
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = e[i]?.m || e[i]?.v || e[i]?.ct?.s;
                                    }
                                    if (tableValueMap.index?.length == index2 + 1) {
                                        keyValuePair.push(object);
                                    }
                                })
                            }
                        }
                        if (f?.length == index1 + 1) {
                            tableDataSetArray.push({ "Table": `Table ${index + 1}`, DiscrepancyData: keyValuePair });
                        }
                    });
                }
            });
            let cellDatas = gradtionData;
            let gradtionSheetData = flagCheck == "Red" ? sessionStorage.getItem('redSheetData') : sessionStorage.getItem('greenSheetData');
            let gradiationPropsData = JSON.parse(gradtionSheetData);
            let lobResult = [];
            let uniqueLobSet = new Set();

            if (tableDataSetArray && cellDatas && cellDatas?.length > 0 && tableDataSetArray?.length > 0) {

                gradiationPropsData?.forEach((table) => {
                    if (table?.data && Object.keys(table?.data)?.length > 0) {
                        const policy_Lob = table?.data[0]["POLICY LOB"] || table?.data[0]["Policy LOB"];
                        lobResult.push({
                            Table: table?.TableName,
                            "POLICY LOB": policy_Lob
                        });
                        uniqueLobSet.add(table?.TableName);
                    }
                });
                lobResult = lobResult?.map((item, index) => {
                    return {
                        ...item,
                        Table: `Table ${index + 2}`
                    };
                });

                setLobResult(lobResult);

                let lobMapping = {};
                lobResult.forEach(item => {
                    lobMapping[item.Table] = item["POLICY LOB"];
                });

                // Assign the POLICY LOB value to the corresponding Table in tableDataSetArray
                tableDataSetArray?.forEach(table => {
                    if (lobMapping[table.Table]) {
                        table["POLICY_LOB"] = lobMapping[table.Table];
                        delete table.Table;
                    }
                });

                let documentViewerMap = {};
                let tblStructuredDocumentViewerMap = {};
                gradiationPropsData?.forEach(tbl => {
                    let tableName = tbl?.TableName;
                    if (flagCheck == 'Red') {
                        // Adjust tableName from 'Table' to 'RedTable'
                        if (tableName.startsWith('Table ')) {
                            const numberPart = tableName.split(' ')[1];
                            tableName = `RedTable ${numberPart}`;
                        }
                    }
                    if (flagCheck == 'Green') {
                        // Adjust tableName from 'Table' to 'GreenTable'
                        if (tableName.startsWith('Table ')) {
                            const numberPart = tableName.split(' ')[1];
                            tableName = `GreenTable ${numberPart}`;
                        }
                    }
                    if (tableName != 'RedTable 1' && tableName != 'GreenTable 1') {
                        if (tbl.data && tbl.data.length > 0) {
                            documentViewerMap[tableName] = tbl?.data.map(row => row["Document Viewer"]);
                        }
                    }
                    Object.keys(documentViewerMap).forEach((item, index) => {
                        const tbl = flagCheck == "Red" ? `RedTable ${index + 2}` : `GreenTable ${index + 2}`;;
                        tblStructuredDocumentViewerMap[tbl] = documentViewerMap[item];
                    });
                });

                tableDataSetArray?.forEach((f, index) => {
                    const TableName = flagCheck == 'Red' ? "RedTable " + (index + 2) : "GreenTable " + (index + 2);
                    let data = f?.DiscrepancyData;
                    if (Array.isArray(data)) {
                        data = data.filter(obj =>
                            Object.values(obj).every(value => value !== undefined)
                        );
                        f.DiscrepancyData = data;
                    }

                    if (data && data?.length > 0) {
                        data = (data.map((item, index) => {
                            item["policyLob"] = f?.POLICY_LOB;

                            // Replace Document Viewer value if mapping exists
                            if (tblStructuredDocumentViewerMap[TableName] && Array.isArray(tblStructuredDocumentViewerMap[TableName])) {
                                if (index < tblStructuredDocumentViewerMap[TableName].length) {
                                    let docItem = item["Document Viewer"] == " " ? item["Document Viewer"].trim() : item["Document Viewer"];
                                    if (docItem != "") {
                                        item["Document Viewer"] = tblStructuredDocumentViewerMap[TableName][index];
                                    }
                                }
                            }

                            // Replace 'Click here' msg to an empty string
                            if (reqEndorsementColHideBrokerId?.includes(brokerId)) {
                                if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["Notes"] === "~~Click here" && item["NotesFreeFill"] === "~~Click here"
                                ) || (item["ActionOnDiscrepancy"] === "Click here" && item["Notes"] === "Click here" && item["NotesFreeFill"] === "Click here"
                                    ) ||
                                    (item["ActionOnDiscrepancy"] === " Click here" && item["Notes"] === " Click here" && item["NotesFreeFill"] === " Click here"
                                    )) {
                                    item["ActionOnDiscrepancy"] = "";
                                    item["Notes"] = "";
                                    item["NotesFreeFill"] = "";
                                }
                            } else if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["RequestEndorsement"] == "~~Click here"
                                && item["Notes"] == "~~Click here" && item["NotesFreeFill"] == "~~Click here"
                            ) || (item["ActionOnDiscrepancy"] === "Click here" && item["RequestEndorsement"] == "Click here"
                                && item["Notes"] == "Click here" && item["NotesFreeFill"] == "Click here"
                                ) || (item["ActionOnDiscrepancy"] === " Click here" && item["RequestEndorsement"] == " Click here"
                                    && item["Notes"] == " Click here" && item["NotesFreeFill"] == " Click here"
                                )) {
                                item["ActionOnDiscrepancy"] = "";
                                item["RequestEndorsement"] = "";
                                item["Notes"] = "";
                                item["NotesFreeFill"] = "";
                            } else {
                                ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"].forEach(key => {
                                    if ((item[key] === "~~Click here") || (item[key] === "Click here") || (item[key] === " Click here")) {
                                        item[key] = "";
                                    }
                                })
                            }
                            return item;
                        }));
                    }

                    const cleanedData = data?.filter(entry =>
                        !Object.values(entry)?.includes(undefined)
                    );

                    if (flagCheck == 'Red') {
                        redSheetData.push({ TableName, Data: JSON.stringify(cleanedData) });
                    } else if (flagCheck == 'Green') {
                        greenSheetData.push({ TableName, Data: JSON.stringify(cleanedData) });
                    }
                });
            }
        } else if (flagCheck == ExclusionSheetName) {
            let headerSpilttedArray = [];
            let mergingArrayData = [];
            let alldatas = luckysheet.getAllSheets();
            let filterdatasheet = alldatas?.filter(f => f.name?.includes(ExclusionSheetName));
            if (filterdatasheet.length != undefined && filterdatasheet.length > 0) {
                let sheetData = filterdatasheet[0].data;
                let limitReached = false;
                sheetData && sheetData?.length > 0 && sheetData.map((e, index) => {
                    if (index == 0 && !limitReached) {
                        let tblIndex = [];
                        let tblColumnName = [];
                        let hasReachedLimit = false;
                        const filteredData = e.filter(item => item !== null);
                        filteredData?.forEach((e1, index1) => {
                            if (index1 >= 0 && !hasReachedLimit && e1?.m != "Actions on Discrepancy (from AMs)") {
                                tblIndex.push(index1);
                                tblColumnName.push(e1?.m || e1?.v);
                            }
                        });

                        tblColumnName = tblColumnName.filter(column => column !== undefined);
                        let slicedIndex = tblIndex.slice(0, tblColumnName.length)
                        let largeIndex = Math.max(...slicedIndex);
                        if (reqEndorsementColHideBrokerId?.includes(brokerId)) {
                            tblColumnName = [...tblColumnName, "ActionOnDiscrepancy", "Notes", "NotesFreeFill"]
                            slicedIndex = [...slicedIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3];
                        } else {
                            tblColumnName = [...tblColumnName, "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]
                            slicedIndex = [...slicedIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3, largeIndex + 4];
                        }
                        slicedIndex.slice(0, tblColumnName.length);
                        headerSpilttedArray.push({ "Table": `ExTable ${index + 1}`, index: slicedIndex, tblColumnName });
                        hasReachedLimit = true;
                    }
                });

                sheetData && sheetData?.length > 0 && sheetData.forEach((e, index) => {
                    let keyValuePair = [];
                    if (index > 1) {
                        let tableValueMap = headerSpilttedArray[0];
                        if (tableValueMap) {
                            let object = {};
                            tableValueMap?.index?.forEach((i, index2) => {
                                if (e[i]?.ct?.s && Array.isArray(e[i]?.ct?.s)) {
                                    let filteredS = e[i]?.ct?.s.filter((f) => f != null);
                                    let concatenatedValues = filteredS?.map(item => item?.v)?.join('');
                                    concatenatedValues = concatenatedValues?.replace(/\r\n/g, ' ');
                                    concatenatedValues = concatenatedValues?.trim();
                                    const finalValue = e[i]?.m || e[i]?.v || concatenatedValues;
                                    object[`${tableValueMap?.tblColumnName[index2]}`] = finalValue;
                                } else {
                                    object[`${tableValueMap?.tblColumnName[index2]}`] = e[i]?.m || e[i]?.v || e[i]?.ct?.s;
                                }
                            })
                            keyValuePair.push(object);
                        }
                        mergingArrayData.push({ DiscrepancyData: keyValuePair });
                    }
                });
                let combineDiscrepancyTempData = [];

                mergingArrayData?.forEach(item => {
                    const newTemplateData = item?.DiscrepancyData?.filter(data => {
                        return Object.values(data).some(value => value !== undefined);
                    });
                    if (newTemplateData?.length > 0) {
                        combineDiscrepancyTempData = combineDiscrepancyTempData.concat(newTemplateData);
                    }
                });

                if (combineDiscrepancyTempData?.length > 0) {
                    exclusionSetArray = {
                        "DiscrepancyData": combineDiscrepancyTempData
                    };
                }

                let documentViewerMap = {};
                if (exclusionstate && exclusionstate?.length > 0) {
                    documentViewerMap = exclusionstate?.map(row => row["Document Viewer"]);
                }
                let data = exclusionSetArray?.DiscrepancyData;

                if (data && data?.length > 0) {
                    data = (data.map((item, index) => {

                        if (documentViewerMap && Array.isArray(documentViewerMap)) {
                            if (index < documentViewerMap.length) {
                                let docItem = item["Document Viewer"] == " " ? item["Document Viewer"].trim() : item["Document Viewer"];
                                if (docItem != "") {
                                    item["Document Viewer"] = documentViewerMap[index];
                                }
                            }
                        }
                        // Replace 'Click here' msg to an empty string
                        if (reqEndorsementColHideBrokerId?.includes(brokerId)) {
                            if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["Notes"] === "~~Click here" && item["NotesFreeFill"] === "~~Click here"
                            ) || (item["ActionOnDiscrepancy"] === "Click here" && item["Notes"] === "Click here" && item["NotesFreeFill"] === "Click here"
                                ) ||
                                (item["ActionOnDiscrepancy"] === " Click here" && item["Notes"] === " Click here" && item["NotesFreeFill"] === " Click here"
                                )) {
                                item["ActionOnDiscrepancy"] = "";
                                item["Notes"] = "";
                                item["NotesFreeFill"] = "";
                            }
                        } else if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["RequestEndorsement"] == "~~Click here"
                            && item["Notes"] == "~~Click here" && item["NotesFreeFill"] == "~~Click here"
                        ) || (item["ActionOnDiscrepancy"] === "Click here" && item["RequestEndorsement"] == "Click here"
                            && item["Notes"] == "Click here" && item["NotesFreeFill"] == "Click here"
                            ) || (item["ActionOnDiscrepancy"] === " Click here" && item["RequestEndorsement"] == " Click here"
                                && item["Notes"] == " Click here" && item["NotesFreeFill"] == " Click here"
                            )) {
                            item["ActionOnDiscrepancy"] = "";
                            item["RequestEndorsement"] = "";
                            item["Notes"] = "";
                            item["NotesFreeFill"] = "";
                        } else {
                            ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"].forEach(key => {
                                if ((item[key] === "~~Click here") || (item[key] === "Click here") || (item[key] === " Click here")) {
                                    item[key] = "";
                                }
                            })
                        }
                        return item;
                    }));
                }
                if (flagCheck === ExclusionSheetName) {
                    exclusionSheetData.push({
                        TableName: "ExclusionTable",
                        Data: JSON.stringify(exclusionSetArray["DiscrepancyData"])
                    });
                }
            }
        } else if (flagCheck == "QA Checklist") {
            const keys = Object.keys(qacTableColumnDetails);
            const tableDataSetArray = [];
            if (keys?.length > 0) {
                keys?.forEach((key) => {
                    const slicedTables = [];
                    const tableData = qacTableColumnDetails[key];
                    const structuredTblObj = qacTblRangeStructureFun(tableData);

                    Object.keys(structuredTblObj)?.forEach((tableKey) => {
                        const table = structuredTblObj[tableKey];
                        if (table?.range?.start !== undefined && table?.range?.end !== undefined) {
                            const slicedData = propsData?.slice(table?.range?.start, table?.range?.end + 1);
                            slicedTables.push(slicedData);
                        }
                    });


                    const headerSpilttedArray = slicedTables?.map((tableData, index) => {
                        if (tableData[1]) {
                            const tblIndex = [];
                            const tblColumnName = [];
                            tableData[1]?.forEach((cell, cellIndex) => {
                                if (cell) {
                                    tblIndex.push(cellIndex);
                                    tblColumnName.push(cell?.m || cell?.v);
                                }
                            });

                            return {
                                index: tblIndex?.slice(0, tblColumnName.length),
                                tblColumnName: tblColumnName?.filter(Boolean),
                            };
                        }
                        return null;
                    }).filter(Boolean);

                    slicedTables?.forEach((tableData, index) => {
                        const keyValuePair = [];
                        tableData?.forEach((row, rowIndex) => {
                            if (rowIndex > 1) {
                                const tableValueMap = headerSpilttedArray[index];
                                if (tableValueMap) {
                                    const rowObject = {};
                                    tableValueMap?.index?.forEach((i, colIndex) => {
                                        const cell = row[i];
                                        const finalValue = cell?.m || cell?.v || cell?.ct?.s?.map((s) => s.v)?.join('') || "";
                                        rowObject[tableValueMap.tblColumnName[colIndex]] = finalValue;
                                    });
                                    keyValuePair.push(rowObject);
                                }
                            }
                            if (rowIndex === 0) {
                                const policyLobValue = row?.[0]?.m || "";
                                keyValuePair.push({
                                    policyLob: policyLobValue,
                                    IsHighVolume: key?.toLowerCase()?.includes("high") ? true : false
                                });
                            }
                        });

                        tableDataSetArray.push({
                            Data: keyValuePair,
                            TableName: key?.toLowerCase()?.includes("high") ? `HighVolumeTable${index + 1}` : `LowVolumeTable${index + 1}`
                        });
                    });
                });

                let updatedTableDataSetArray = tableDataSetArray?.map(({ Data, TableName }) => {
                    const { policyLob, IsHighVolume } = Data[0];
                    return {
                        TableName,
                        Data: Data?.slice(1).map((item) => ({
                            ...item,
                            policyLob,
                            IsHighVolume,
                        })),
                    };
                });

                if (flagCheck == 'QA Checklist') {
                    const filteredData = updatedTableDataSetArray?.filter(item =>
                        item?.Data?.some(
                            entry =>
                                entry["Discrepancies to note on Intranet Form:"] !== "" ||
                                entry["Checked By (Initials):"] !== ""
                        )
                    );

                    let highVolumeCount = 1;
                    let lowVolumeCount = 1;

                    const reseededTblData = filteredData?.map((table) => {
                        if (table.Data[0].IsHighVolume) {
                            table.TableName = `HighVolumeTable${highVolumeCount}`;
                            highVolumeCount++;
                        } else {
                            table.TableName = `LowVolumeTable${lowVolumeCount}`;
                            lowVolumeCount++;
                        }
                        return table;
                    });

                    reseededTblData?.forEach(({ TableName, Data }) => {
                        qacSheetDataSet.push({
                            TableName,
                            Data: JSON.stringify(Data),
                        });
                    });
                }
            }
        } else if (flagCheck == "ProposalExclusions") {
            let headerSpilttedArray = [];
            let mergingArrayData = [];
            let alldatas = luckysheet.getAllSheets();
            let filterdatasheet = alldatas?.filter(f => f.name?.includes("ProposalExclusions"));
            if (filterdatasheet.length != undefined && filterdatasheet.length > 0) {
                let sheetData = filterdatasheet[0].data;
                let limitReached = false;
                sheetData && sheetData?.length > 0 && sheetData.map((e, index) => {
                    if (index == 0 && !limitReached) {
                        let tblIndex = [];
                        let tblColumnName = [];
                        let hasReachedLimit = false;
                        const filteredData = e.filter(item => item !== null);
                        filteredData?.forEach((e1, index1) => {
                            if (index1 >= 0 && !hasReachedLimit && e1?.m != "Actions on Discrepancy (from AMs)") {
                                tblIndex.push(index1);
                                tblColumnName.push(e1?.m || e1?.v);
                            }
                        });

                        tblColumnName = tblColumnName.filter(column => column !== undefined);
                        let slicedIndex = tblIndex.slice(0, tblColumnName.length)
                        let largeIndex = Math.max(...slicedIndex);
                        if (reqEndorsementColHideBrokerId?.includes(brokerId)) {
                            tblColumnName = [...tblColumnName, "ActionOnDiscrepancy", "Notes", "NotesFreeFill"]
                            slicedIndex = [...slicedIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3];
                        } else {
                            tblColumnName = [...tblColumnName, "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]
                            slicedIndex = [...slicedIndex, largeIndex + 1, largeIndex + 2, largeIndex + 3, largeIndex + 4];
                        }
                        slicedIndex.slice(0, tblColumnName.length);
                        headerSpilttedArray.push({ "Table": `ProposalExTable ${index + 1}`, index: slicedIndex, tblColumnName });
                        hasReachedLimit = true;
                    }
                });

                sheetData && sheetData?.length > 0 && sheetData.forEach((e, index) => {
                    let keyValuePair = [];
                    if (index > 1) {
                        let tableValueMap = headerSpilttedArray[0];
                        if (tableValueMap) {
                            let object = {};
                            tableValueMap?.index?.forEach((i, index2) => {
                                if (e[i]?.ct?.s && Array.isArray(e[i]?.ct?.s)) {
                                    let filteredS = e[i]?.ct?.s.filter((f) => f != null);
                                    let concatenatedValues = filteredS?.map(item => item?.v)?.join('');
                                    concatenatedValues = concatenatedValues?.replace(/\r\n/g, ' ');
                                    concatenatedValues = concatenatedValues?.trim();
                                    const finalValue = e[i]?.m || e[i]?.v || concatenatedValues;
                                    object[`${tableValueMap?.tblColumnName[index2]}`] = finalValue;
                                } else {
                                    object[`${tableValueMap?.tblColumnName[index2]}`] = e[i]?.m || e[i]?.v || e[i]?.ct?.s;
                                }
                            })
                            keyValuePair.push(object);
                        }
                        mergingArrayData.push({ DiscrepancyData: keyValuePair });
                    }
                });
                let combineDiscrepancyTempData = [];

                mergingArrayData?.forEach(item => {
                    const newTemplateData = item?.DiscrepancyData?.filter(data => {
                        return Object.values(data).some(value => value !== undefined);
                    });
                    if (newTemplateData?.length > 0) {
                        combineDiscrepancyTempData = combineDiscrepancyTempData.concat(newTemplateData);
                    }
                });

                if (combineDiscrepancyTempData?.length > 0) {
                    proposalexclusionSetArray = {
                        "DiscrepancyData": combineDiscrepancyTempData
                    };
                }

                let documentViewerMap = {};
                if (proposalstate && proposalstate?.length > 0) {
                    documentViewerMap = proposalstate?.map(row => row["Document Viewer"]);
                }
                let data = proposalexclusionSetArray?.DiscrepancyData;

                if (data && data?.length > 0) {
                    data = (data.map((item, index) => {

                        if (documentViewerMap && Array.isArray(documentViewerMap)) {
                            if (index < documentViewerMap.length) {
                                let docItem = item["Document Viewer"] == " " ? item["Document Viewer"].trim() : item["Document Viewer"];
                                if (docItem != "") {
                                    item["Document Viewer"] = documentViewerMap[index];
                                }
                            }
                        }
                        // Replace 'Click here' msg to an empty string
                        if (reqEndorsementColHideBrokerId?.includes(brokerId)) {
                            if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["Notes"] === "~~Click here" && item["NotesFreeFill"] === "~~Click here"
                            ) || (item["ActionOnDiscrepancy"] === "Click here" && item["Notes"] === "Click here" && item["NotesFreeFill"] === "Click here"
                                ) ||
                                (item["ActionOnDiscrepancy"] === " Click here" && item["Notes"] === " Click here" && item["NotesFreeFill"] === " Click here"
                                )) {
                                item["ActionOnDiscrepancy"] = "";
                                item["Notes"] = "";
                                item["NotesFreeFill"] = "";
                            }
                        } else if ((item["ActionOnDiscrepancy"] === "~~Click here" && item["RequestEndorsement"] == "~~Click here"
                            && item["Notes"] == "~~Click here" && item["NotesFreeFill"] == "~~Click here"
                        ) || (item["ActionOnDiscrepancy"] === "Click here" && item["RequestEndorsement"] == "Click here"
                            && item["Notes"] == "Click here" && item["NotesFreeFill"] == "Click here"
                            ) || (item["ActionOnDiscrepancy"] === " Click here" && item["RequestEndorsement"] == " Click here"
                                && item["Notes"] == " Click here" && item["NotesFreeFill"] == " Click here"
                            )) {
                            item["ActionOnDiscrepancy"] = "";
                            item["RequestEndorsement"] = "";
                            item["Notes"] = "";
                            item["NotesFreeFill"] = "";
                        } else {
                            ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"].forEach(key => {
                                if ((item[key] === "~~Click here") || (item[key] === "Click here") || (item[key] === " Click here")) {
                                    item[key] = "";
                                }
                            })
                        }
                        return item;
                    }));
                }
                if (flagCheck === "ProposalExclusions") {
                    proposalexclusionSheetData.push({
                        TableName: "ProposalExclusionTable",
                        Data: JSON.stringify(proposalexclusionSetArray["DiscrepancyData"])
                    });
                }
            }
        }

        if (flagCheck != ExclusionSheetName && flagCheck != "ProposalExclusions" && flagCheck != 'QA Checklist') {
            if (findTable && findTable?.length > 0) {
                const csrTable1Data = [];
                const Table2Data = [];
                if (findTable[0]) {
                    const result = findTable[0]?.map(([index1, index2]) => ({
                        index1,
                        index2,
                    }));
                    for (let row in result) {
                        let jobid = props?.selectedJob;
                        const cellData = result[row];
                        const inputData = flagCheck == 'Summary Checklist' ? csrPolicyData : flagCheck == FormsCompareSheetName ? formstate : flagCheck == "CSR Pro" ?
                            JSON.parse(sessionStorage.getItem('summarryData')) : gradtionData;
                        const csrTable1data = flagCheck == 'Summary Checklist' ? inputData.find((data) => data.Tablename === "CsrTable 1")
                            : flagCheck == FormsCompareSheetName ? inputData.find((data) => data.Tablename === "FormTable 1")
                                : inputData.find((data) => data.Tablename === "Table 1");

                        if (csrTable1data && csrTable1data?.TemplateData?.length > 0) {
                            const csrTable1json = flagCheck == 'Summary Checklist' ? csrTable1data.TemplateData
                                : flagCheck == FormsCompareSheetName ? JSON.parse(csrTable1data.TemplateData) : csrTable1data.TemplateData;

                            const lobValue = csrTable1json[0]?.hasOwnProperty("Policy LOB")
                                ? csrTable1json.map(item => item["Policy LOB"])
                                : csrTable1json.map(item => item["PolicyLob"]);
                            const cell1Text = cellData.index1?.v || cellData.index1?.ct || '';
                            const cell2Text = cellData.index2?.v !== undefined ? (cellData.index2.v || cellData.index2?.ct) : (cellData.index2?.ct?.fa === "@" ? "" : cellData.index2?.ct?.fa);

                            if (cell1Text && cell1Text.s && cell1Text.s.length > 0 && cell2Text || cell1Text) {
                                const headerValue = Array.isArray(cell1Text.s) ? cell1Text.s.map(item => item.v || '').join(',') : cell1Text;
                                const concatenatedValues = Array.isArray(cell2Text.s) ? cell2Text.s.map(item => item.v).join('') : cell2Text;

                                const objStructure = {
                                    HeaderID: row,
                                    JOBID: jobid,
                                    'Policy LOB': lobValue[0],
                                    Headers: headerValue,
                                    '(No column name)': concatenatedValues,
                                }

                                const handleNonwhitespaceCharacter = (value) => {
                                    if (typeof value === 'string') {
                                        return value.replace(/\n/g, '~~').replace(/"/g, '\\"');
                                    }
                                    return value;
                                };

                                const jsonString = `{${Object.entries(objStructure).map(([key, value]) => {
                                    if (key === 'HeaderID') {
                                        const updatedValue = Number(value).toString();
                                        return `"${key}":${updatedValue}`;
                                    } else if (key === '(No column name)') {
                                        return `"${key}":"${handleNonwhitespaceCharacter(value)}"`;
                                    } else if (key === 'Headers') {
                                        const sValue = Array.isArray(value) ? `"${handleNonwhitespaceCharacter(value.join(', '))}"` : `"${handleNonwhitespaceCharacter(value)}"`;
                                        return `"${key}":${sValue}`;
                                    }
                                    return `"${key}":"${handleNonwhitespaceCharacter(value)}"`;
                                }).join(',')}}`;
                                csrTable1Data.push(jsonString);
                            }
                        }
                    }
                }
                if (findTable.length - 1 && flagCheck == 'CSR Pro') {
                    let index = findTable.length - 1;
                    const cleaned = findTable[index]?.map(row => row.filter(cell => cell !== null));
                    const result = cleaned?.map(([index1, index2]) => ({
                        index1,
                        index2,
                    }));
                    for (let row in result) {
                        let jobid = props?.selectedJob;
                        const cellData = result[row];
                        const inputData = JSON.parse(sessionStorage.getItem('summarryData'));
                        const csrTable1data = inputData.find((data) => data.Tablename === "Table lst");

                        if (csrTable1data && csrTable1data?.TemplateData?.length > 0) {
                            const csrTable1json = csrTable1data.TemplateData;

                            const lobValue = csrTable1json[0]?.hasOwnProperty("Policy LOB")
                                ? csrTable1json.map(item => item["Policy LOB"])
                                : csrTable1json.map(item => item["PolicyLob"]);
                            const cell1Text = cellData.index1?.v || cellData.index1?.ct || '';
                            const cell2Text = cellData.index2?.v !== undefined ? (cellData.index2.v || cellData.index2?.ct) : (cellData.index2?.ct?.fa === "@" ? "" : cellData.index2?.ct?.fa);

                            if (cell1Text && cell1Text.s && cell1Text.s.length > 0 && cell2Text || cell1Text) {
                                const headerValue = Array.isArray(cell1Text.s) ? cell1Text.s.map(item => item.v || '').join(',') : cell1Text;
                                const concatenatedValues = Array.isArray(cell2Text.s) ? cell2Text.s.map(item => item.v).join('') : cell2Text;

                                const objStructure = {
                                    HeaderID: row,
                                    JOBID: jobid,
                                    'Policy LOB': lobValue[0],
                                    Headers: headerValue,
                                    '(No column name)': concatenatedValues,
                                }

                                const handleNonwhitespaceCharacter = (value) => {
                                    if (typeof value === 'string') {
                                        return value.replace(/\n/g, '~~').replace(/"/g, '\\"');
                                    }
                                    return value;
                                };

                                const jsonString = `{${Object.entries(objStructure).map(([key, value]) => {
                                    if (key === 'HeaderID') {
                                        const updatedValue = Number(value).toString();
                                        return `"${key}":${updatedValue}`;
                                    } else if (key === '(No column name)') {
                                        return `"${key}":"${handleNonwhitespaceCharacter(value)}"`;
                                    } else if (key === 'Headers') {
                                        const sValue = Array.isArray(value) ? `"${handleNonwhitespaceCharacter(value.join(', '))}"` : `"${handleNonwhitespaceCharacter(value)}"`;
                                        return `"${key}":${sValue}`;
                                    }
                                    return `"${key}":"${handleNonwhitespaceCharacter(value)}"`;
                                }).join(',')}}`;
                                Table2Data.push(jsonString);
                            }
                        }
                    }
                }
                const Json = `[${csrTable1Data.join(',')}]`;
                const Json1 = `[${Table2Data.join(',')}]`;
                const sanitizejson = Json?.replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
                const sanitizejson1 = Json1?.replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
                const parsedTable1Data = JSON.parse(sanitizejson);
                const parsedTable2Data = JSON.parse(sanitizejson1);
                if (flagCheck == 'Summary Checklist' || flagCheck == 'Red' || flagCheck == 'Green' || flagCheck == 'CSR Pro') {
                    const tablestring = flagCheck == 'Summary Checklist' ? "CsrTable 1" : flagCheck == 'CSR Pro' ? "summaryTable 1" : flagCheck == 'Red' ? "RedTable 1" : "GreenTable 1";
                    const transformedJson = [
                        {
                            "TableName": tablestring,
                            "Data": JSON.stringify(parsedTable1Data)
                        }
                    ];
                    const transformed2Json = [
                        {
                            "TableName": "summary_Table lst",
                            "Data": JSON.stringify(parsedTable2Data)
                        }
                    ];
                    const findingTable2Index = flagCheck == 'CSR Pro' ? summarySheetData?.findIndex(table => table.TableName === "summaryTable 2")
                        : flagCheck == 'Summary Checklist' ? policySheetData?.findIndex(table => table.TableName === "CsrTable 2")
                            : flagCheck == 'Red' ? redSheetData?.findIndex(table => table.TableName === "RedTable 2")
                                : flagCheck == 'Green' ? greenSheetData?.findIndex(table => table.TableName === "GreenTable 2") : "";

                    if (flagCheck == 'CSR Pro' && findingTable2Index !== -1) {
                        summarySheetData.splice(findingTable2Index, 0, transformedJson[0]);
                        const lastIndex = summarySheetData.length;
                        summarySheetData.splice(lastIndex, 0, transformed2Json[0]);
                        console.log(summarySheetData);
                    }
                    if (flagCheck == 'Summary Checklist' && findingTable2Index !== -1) {
                        policySheetData.splice(findingTable2Index, 0, transformedJson[0]);
                        // console.log(policySheetData);
                    }
                    if (flagCheck == 'Red') {
                        if (findingTable2Index !== -1) {
                            redSheetData.splice(findingTable2Index, 0, transformedJson[0]);
                            // console.log(redSheetData);
                        } else {
                            redSheetData.push(transformedJson[0]);
                        }
                    }
                    if (flagCheck == 'Green') {
                        if (findingTable2Index !== -1) {
                            greenSheetData.splice(findingTable2Index, 0, transformedJson[0]);
                            // console.log(greenSheetData);
                        } else {
                            greenSheetData.push(transformedJson[0]);
                        }
                    }
                } else if (flagCheck == FormsCompareSheetName) {
                    const transformedJson = [
                        {
                            "TableName": "CsrFormTable 1",
                            "Data": JSON.stringify(parsedTable1Data)
                        }
                    ];
                    const findingTable2Index = formCompareSheetData?.findIndex(table => table.TableName === "CsrFormTable 2");
                    if (findingTable2Index !== -1) {
                        formCompareSheetData.splice(findingTable2Index, 0, transformedJson[0]);
                        // console.log(formCompareSheetData);
                    }
                }
            }
        }

        if (isExport == true) {
            const sheetDatas = flagCheck == "Summary Checklist" ? policySheetData : flagCheck == 'CSR Pro' ? summarySheetData : flagCheck == FormsCompareSheetName ? formCompareSheetData : flagCheck == ExclusionSheetName ? exclusionSheetData : flagCheck == "ProposalExclusions" ? proposalexclusionSheetData : flagCheck == "Red" ? redSheetData : flagCheck == "Green" ? greenSheetData : qacSheetDataSet;

            sheetDatas.forEach(item => {
                const sanitizedData = item?.Data  //sanitize the JSON string by removing any problematic control characters before parsing it.  so dont remove this
                let parsedData;
                try {
                    parsedData = sanitizedData;
                } catch (error) {
                    // console.error("parsing json error catch:", error);
                    return;
                }
                // parsedData.forEach(obj => {
                //     if (obj[""] !== undefined) {
                //         obj["NoColumnName"] = obj[""];
                //         delete obj[""];
                //     }
                // });
                // item.Data = JSON.stringify(parsedData);
            });

            const modifiedTabledata = sheetDatas?.map(item => ({
                Id: props?.selectedJob,
                TableName: item?.TableName,
                Data: item.Data
            }));

            const dataFromOnUpdateClick = modifiedTabledata;

            if (typeof callback === "function") {
                callback(dataFromOnUpdateClick);
            }
        } else {
            // const response = csrSheetPolicyGradiationDataSaveApi(id, jobid, CheckListType, wholeData);
            // return response;
        }
    };

    const staticDataforQacExport = () => {
        const qacSheetDataSet = [];
        const staticSheetData = luckysheet.getAllSheets()?.filter(f => f.name.includes("QA Checklist"))[0]?.data;
        const keys = Object.keys(qacTableColumnDetails);

        const tableDataSetArray = [];
        if (keys?.length > 0) {
            keys?.forEach((key) => {
                const slicedTables = [];

                const tableData = qacTableColumnDetails[key];
                const structuredTblObj = qacTblRangeStructureFun(tableData);

                Object.keys(structuredTblObj)?.forEach((tableKey) => {
                    const table = structuredTblObj[tableKey];
                    if (table?.range?.start !== undefined && table?.range?.end !== undefined) {
                        const slicedData = staticSheetData?.slice(table?.range?.start, table?.range?.end + 1);
                        slicedTables.push(slicedData);
                    }
                });


                const headerSpilttedArray = slicedTables?.map((tableData, index) => {
                    if (tableData[1]) {
                        const tblIndex = [];
                        const tblColumnName = [];
                        tableData[1]?.forEach((cell, cellIndex) => {
                            if (cell) {
                                tblIndex.push(cellIndex);
                                tblColumnName.push(cell?.m || cell?.v);
                            }
                        });

                        return {
                            index: tblIndex?.slice(0, tblColumnName.length),
                            tblColumnName: tblColumnName?.filter(Boolean),
                        };
                    }
                    return null;
                }).filter(Boolean);

                slicedTables?.forEach((tableData, index) => {
                    const keyValuePair = [];
                    tableData?.forEach((row, rowIndex) => {
                        if (rowIndex > 1) {
                            const tableValueMap = headerSpilttedArray[index];
                            if (tableValueMap) {
                                const rowObject = {};
                                tableValueMap?.index?.forEach((i, colIndex) => {
                                    const cell = row[i];
                                    const finalValue = cell?.m || cell?.v || cell?.ct?.s?.map((s) => s.v)?.join('') || "";
                                    rowObject[tableValueMap.tblColumnName[colIndex]] = finalValue;
                                });
                                keyValuePair.push(rowObject);
                            }
                        }
                        if (rowIndex === 0) {
                            const policyLobValue = row?.[0]?.m || "";
                            keyValuePair.push({
                                policyLob: policyLobValue,
                                IsHighVolume: key?.toLowerCase()?.includes("high") ? true : false
                            });
                        }
                    });

                    tableDataSetArray.push({
                        Data: keyValuePair,
                        TableName: key?.toLowerCase()?.includes("high") ? `HighVolumeTable${index + 1}` : `LowVolumeTable${index + 1}`
                    });
                });
            });

            let updatedTableDataSetArray = tableDataSetArray?.map(({ Data, TableName }) => {
                const { policyLob, IsHighVolume } = Data[0];
                return {
                    TableName,
                    Data: Data?.slice(1).map((item) => ({
                        ...item,
                        policyLob,
                        IsHighVolume,
                    })),
                };
            });

            updatedTableDataSetArray?.forEach(({ TableName, Data }) => {
                qacSheetDataSet.push({
                    Id: props?.selectedJob,
                    TableName,
                    Data: JSON.stringify(Data),
                });
            });

        }
        return qacSheetDataSet;
    };

    const csrSheetPolicyGradiationDataSaveApi = async (id, jobId, CheckListType, dataForSaveApi, isAutoUpdate) => {
        if (!isAutoUpdate) {
            document.body.classList.add('loading-indicator');
        }
        const Token = await processAndUpdateToken(token);

        let message;
        let log;
        if (CheckListType === "PreviewCheckList") {
            message = isAutoUpdate ? "CSR-AOD-AutoUpdate-PolicyCheck-initiated" : "CSR-AOD-Update-PolicyCheck-initiated";
            log = isAutoUpdate ? "CSR-AutoSave-PolicyCheck" : "CSR-Save-PolicyCheck";
        } else if (CheckListType === "GradiationSheet") {
            message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Gradiation-initiated" : "CSR-AOD-Update-Gradiation-initiated";
            log = isAutoUpdate ? "CSR-AutoSave-Gradiation" : "CSR-Save-Gradiation";
        }

        updateGridAuditLog(jobId, message, log, (userName || sessionUserName));
        const headers = {
            'Authorization': `Bearer ${Token}`,
            "Content-Type": "application/json",
        };
        const apiUrl = `${baseUrl}/api/ProcedureData/AddGridAoddMapping`;
        try {
            const response = await axios({
                method: "POST",
                url: apiUrl,
                headers: headers,
                data: {
                    Id: id,
                    JobId: jobId,
                    CheckListType: CheckListType,
                    Data: dataForSaveApi,
                }
            });
            if (response.status !== 200) {
                if (CheckListType === "PreviewCheckList") {
                    message = isAutoUpdate ? "CSR-AOD-AutoUpdate-PolicyCheck-failed" : "CSR-AOD-Update-PolicyCheck-failed";
                } else if (CheckListType === "GradiationSheet") {
                    message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Gradiation-failed" : "CSR-AOD-Update-Gradiation-failed";
                }
                updateGridAuditLog(jobId, message, typeof response === 'object' ? JSON.stringify(response) : response, (userName || sessionUserName));
                return "error";
            }

            if (response !== "error") {
                setMsgVisible(true);
                setMsgClass('alert success');
                setMsgText('AMSData Updated');
                setTimeout(() => { setMsgVisible(false); setMsgText(''); }, 3000);
            } 

            return response.data;
        } catch (error) {
            if (CheckListType === "PreviewCheckList") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-PolicyCheck-failed" : "CSR-AOD-Update-PolicyCheck-failed";
            } else if (CheckListType === "GradiationSheet") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Gradiation-failed" : "CSR-AOD-Update-Gradiation-failed";
            }
            updateGridAuditLog(jobId, message, typeof error === 'object' ? JSON.stringify(error) : error, (userName || sessionUserName));
            return "error";
        } finally {
            if (CheckListType === "PreviewCheckList") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-PolicyCheck-completed" : "CSR-AOD-Update-PolicyCheck-completed";
                log = isAutoUpdate ? "CSR-AutoSave-PolicyCheck-Success" : "CSR-Save-PolicyCheck-Success";
            } else if (CheckListType === "GradiationSheet") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Gradiation-completed" : "CSR-AOD-Update-Gradiation-completed";
                log = isAutoUpdate ? "CSR-AutoSave-Gradiation-Success" : "CSR-Save-Gradiation-Success";
            }
            updateGridAuditLog(jobId, message, log, (userName || sessionUserName));
            if (!isAutoUpdate) {
                document.body.classList.remove('loading-indicator');
            }
            document.body.classList.remove('loading-indicator');
            return "success";
        }
    };

    const qacSheetSaveCall = async (jobId, dataForSaveApi, isAutoUpdate) => {
        if (!isAutoUpdate) {
            document.body.classList.add('loading-indicator');
        }
        document.body.classList.add('loading-indicator');
        const Token = await processAndUpdateToken(token);
        const message = isAutoUpdate ? "CSR-QacChecklistData-AutoUpdate-initiated" : "CSR-QacChecklistData-Update-initiated";
        const log = isAutoUpdate ? "CSR-QacChecklistData-AutoSave" : "CSR-QacChecklistData-Save";
        updateGridAuditLog(jobId, message, log, (userName || sessionUserName));
        const headers = {
            'Authorization': `Bearer ${Token}`,
            "Content-Type": "application/json",
        };
        const apiUrl = `${baseUrl}/api/Defaultdatum/AddOrUpdateQacChecklistData`;
        try {
            const response = await axios({
                method: "POST",
                url: apiUrl,
                headers: headers,
                data: {
                    JobId: jobId,
                    JsonData: dataForSaveApi,
                    UpdatedBy: sessionStorage.getItem("csrAuthUserName")
                }
            });
            if (response.status !== 200) {
                const message = isAutoUpdate ? "CSR-QacChecklistData-AutoUpdate-failed" : "CSR-QacChecklistData-Update-failed";
                updateGridAuditLog(jobId, message, typeof response === 'object' ? JSON.stringify(response) : response, (userName || sessionUserName));
                return "error";
            }

            return response.data;
        } catch (error) {
            const message = isAutoUpdate ? "CSR-QacChecklistData-AutoUpdate-failed" : "CSR-QacChecklistData-Update-failed";
            updateGridAuditLog(jobId, message, typeof error === 'object' ? JSON.stringify(error) : error, (userName || sessionUserName));
            return "error";
        } finally {
            const message = isAutoUpdate ? "CSR-QacChecklistData-AutoUpdate-completed" : "CSR-QacChecklistData-Update-completed";
            const log = isAutoUpdate ? "CSR-AutoSave-QacChecklistData-Success" : "CSR-Save-QacChecklistData-Success";
            container.current.showSnackbar('QacChecklistData updated successfully', "success", true);
            updateGridAuditLog(jobId, message, log, (userName || sessionUserName));
            if (!isAutoUpdate) {
                document.body.classList.remove('loading-indicator');
            }
            document.body.classList.remove('loading-indicator');
            return "success";
        }
    };

    const csrSheetCommonSaveApi = async (jobId, tableName, dataForSaveApi, isAutoUpdate) => {
        if (!isAutoUpdate) {
            document.body.classList.add('loading-indicator');
        }
        document.body.classList.add('loading-indicator');
        const Token = await processAndUpdateToken(token);

        let message;
        let log;
        if (tableName === "FormTable") {
            message = isAutoUpdate ? "CSR-AOD-AutoUpdate-FormsCompare-initiated" : "CSR-AOD-Update-FormsCompare-initiated";
            log = isAutoUpdate ? "CSR-AutoSave-FormsCompare" : "CSR-Save-FormsCompare";
        } else if (tableName === "ExclusionTable") {
            message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Exclusion-initiated" : "CSR-AOD-Update-Exclusion-initiated";
            log = isAutoUpdate ? "CSR-AutoSave-Exclusion" : "CSR-Save-Exclusion";
        } else if (tableName === "ProposalExclusionTable") {
                message = isAutoUpdate
                    ? "CSR-AOD-AutoUpdate-Proposal-initiated"
                    : "CSR-AOD-Update-Proposal-initiated";

                log = isAutoUpdate
                    ? "CSR-AutoSave-Proposal"
                    : "CSR-Save-Proposal";
            }
        updateGridAuditLog(jobId, message, log, (userName || sessionUserName));
        const headers = {
            'Authorization': `Bearer ${Token}`,
            "Content-Type": "application/json",
        };
        const apiUrl = `${baseUrl}/api/ProcedureData/UpdatecsrFormTable`;
        try {
            const response = await axios({
                method: "POST",
                url: apiUrl,
                headers: headers,
                data: {
                    JobId: jobId,
                    TableName: tableName,
                    // CheckListType: CheckListType,
                    NewTemplateData: dataForSaveApi,
                }
            });
            if (response.status !== 200) {
                if (tableName === "FormTable") {
                    message = isAutoUpdate ? "CSR-AOD-AutoUpdate-FormsCompare-failed" : "CSR-AOD-Update-FormsCompare-failed";
                } else if (tableName === "ExclusionTable") {
                    message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Exclusion-failed" : "CSR-AOD-Update-Exclusion-failed";
                } else if (tableName === "ProposalExclusionTable") {
                    message = isAutoUpdate
                        ? "CSR-AOD-AutoUpdate-Proposal-failed"
                        : "CSR-AOD-Update-Proposal-failed";
                }
                updateGridAuditLog(jobId, message, typeof response === 'object' ? JSON.stringify(response) : response, (userName || sessionUserName));
                return "error";
            }

            return response.data;
        } catch (error) {
            if (tableName === "FormTable") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-FormsCompare-failed" : "CSR-AOD-Update-FormsCompare-failed";
            } else if (tableName === "ExclusionTable") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Exclusion-failed" : "CSR-AOD-Update-Exclusion-failed";
            } else if (tableName === "ProposalExclusionTable") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Proposal-failed" : "CSR-AOD-Update-Proposal-failed";
            }
            updateGridAuditLog(jobId, message, typeof error === 'object' ? JSON.stringify(error) : error, (userName || sessionUserName));
            return "error";
        } finally {
            if (tableName === "FormTable") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-FormsCompare-completed" : "CSR-AOD-Update-FormsCompare-completed";
                log = isAutoUpdate ? "CSR-AutoSave-FormsCompare-Success" : "CSR-Save-FormsCompare-Success";
            } else if (tableName === "ExclusionTable") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Exclusion-completed" : "CSR-AOD-Update-Exclusion-completed";
                log = isAutoUpdate ? "CSR-AutoSave-Exclusion-Success" : "CSR-Save-Exclusion-Success";
            } else if (tableName === "ProposalExclusionTable") {
                message = isAutoUpdate ? "CSR-AOD-AutoUpdate-Proposal-completed" : "CSR-AOD-Update-Proposal-completed";
                log = isAutoUpdate ? "CSR-AutoSave-Proposal-Success" : "CSR-Save-Proposal-Success";
            }
            updateGridAuditLog(jobId, message, log, (userName || sessionUserName));
            document.body.classList.remove('loading-indicator');
            return "success";
        }
    };

    const handleYesDailog = () => {
        setYesDialog(false);
    }

    const toggleYesDialog = async () => {
        setYesDialog(!yesDialog);
        const filterAllSheets = luckysheet.getAllSheets().filter(f => f.name);
        const policySheet = filterAllSheets.find(sheet => sheet.name === "Summary Checklist");
        const formSheet = filterAllSheets.find(sheet => sheet.name === FormsCompareSheetName);
        const exclusionSheet = filterAllSheets.find(sheet => sheet.name === ExclusionSheetName);
        const redSheet = filterAllSheets.find(sheet => sheet.name === "Red");
        const greenSheet = filterAllSheets.find(sheet => sheet.name === "Green");

        const policyData = policySheet ? policySheet.data : null;
        const formData = formSheet ? formSheet.data : null;
        const exclusionData = exclusionSheet ? exclusionSheet.data : null;
        const redData = redSheet ? redSheet.data : null;
        const greenData = greenSheet ? greenSheet.data : null;

        let sheetCheck = luckysheet?.getSheet().name;
        if (policyData?.length > 0 && sheetCheck == "Summary Checklist") {
            setsheetState(policyData);
        } else if (formData?.length > 0 && sheetCheck == FormsCompareSheetName) {
            setsheetState(formData);
        } else if (exclusionData?.length > 0 && sheetCheck == ExclusionSheetName) {
            setsheetState(exclusionData);
        } else if (redData?.length > 0 && greenData?.length > 0) {
            const combinedData = {
                redData,
                greenData
            };
            setsheetState(combinedData);
        }
    };

    const matchedOrUnMatchedFilter = (rowIndex) => {
        const sheetName = luckysheet?.getSheet()?.name;
        if (rowIndex === 4 && sheetName === 'CSR Pro') {
            showOrHideRecords([]); // <-- Show all rows
            $("#luckysheet-scrollbar-y").scrollTop(400);
            return;
        } else if (rowIndex === 3 && sheetName === 'Summary Checklist') {
            dataGrouping(0);
            // showOrHideRecords([]); // <-- Show all rows
            $("#luckysheet-scrollbar-y").scrollTop(400);
            return;
        } else if (rowIndex === 2 && (sheetName === 'Red' || sheetName === 'Green')) {
            dataGrouping(0);
            // showOrHideRecords([]); // <-- Show all rows
            $("#luckysheet-scrollbar-y").scrollTop(400);
            return;
        }
        if (sheetName === 'Summary Checklist') {
            if (rowIndex === 6 || rowIndex === 4 || rowIndex === 5) {
                let checklistData = [...props?.data];
                if (checklistData && checklistData?.length > 0) {
                    checklistData = checklistData.map((e) => {
                        if (e?.TemplateData && typeof e?.TemplateData != 'object' && typeof e?.TemplateData === 'string') {
                            let templateData = JSON.parse(e.TemplateData);
                            e["TemplateData"] = templateData;
                        }
                        return e;
                    })
                }
                const tableDetails = tableColumnDetails;
                let keys = Object.keys(tableDetails)?.filter((f) => f !== "Table 1");
                let recordsToHide = [];
                keys.forEach((f) => {
                    const tableConfigData = tableDetails[f];
                    const columnKeys = tableConfigData?.columnNames;
                    const recordRange = tableConfigData?.range;
                    const sourceColumns = Object.keys(columnKeys).filter((key) => columnKeys[key] > columnKeys["COVERAGE_SPECIFICATIONS_MASTER"] &&
                        columnKeys[key] < columnKeys["Document Viewer"]);
                    if (sourceColumns && sourceColumns?.length > 0) {
                        const findData = checklistData.find((fi) => fi?.Tablename == f);
                        if (findData?.TemplateData && findData?.TemplateData?.length > 0) {
                            findData?.TemplateData.forEach((item, itemIndex) => {
                                if (rowIndex === 5) { //for unmatched(variance)
                                    let needToHide = false;
                                    let needToHideInCount = 0;
                                    sourceColumns.forEach((srItem) => {
                                        const srCData = item[srItem];
                                        if (!needToHide && srCData && srCData?.trim()?.toLowerCase() == "matched") {
                                            needToHide = true;
                                        } else {
                                            if (srCData && srCData?.trim()?.toLowerCase() == "details not available in the document") {
                                                needToHideInCount = (needToHideInCount + 1);
                                            }
                                        }
                                    });
                                    if (needToHide || (needToHideInCount === sourceColumns?.length)) {
                                        recordsToHide.push(recordRange?.start + itemIndex + (f === "Table 3" ? 4 : 3));
                                    }
                                } else if (rowIndex === 4) {
                                    let needToHide = true;
                                    sourceColumns.forEach((srItem) => {
                                        const srCData = item[srItem];
                                        if (needToHide && srCData && srCData?.trim()?.toLowerCase() == "matched") {
                                            needToHide = false;
                                        }
                                    });
                                    if (needToHide) {
                                        recordsToHide.push(recordRange?.start + itemIndex + (f === "Table 3" ? 4 : 3));
                                    }
                                } else if (rowIndex === 6) {
                                    let needToHide = 0;
                                    sourceColumns.forEach((srItem) => {
                                        const srCData = item[srItem];
                                        if (srCData && srCData?.trim()?.toLowerCase() == "details not available in the document") {
                                            needToHide = (needToHide + 1);
                                        }
                                    });
                                    if (needToHide != sourceColumns?.length) {
                                        recordsToHide.push(recordRange?.start + itemIndex + (f === "Table 3" ? 4 : 3));
                                    }
                                }
                            });
                        }
                    }
                });
                if (recordsToHide?.length > 0) {
                    recordsToHide = groupNumbers(recordsToHide);
                }
                showOrHideRecords(recordsToHide);
                let topConfig = 0;
                $("#luckysheet-scrollbar-y").scrollTop(topConfig + 400);
            }
        }
        else if (sheetName === 'Red' || sheetName === 'Green') {
            if (rowIndex === 3 || rowIndex === 4 || rowIndex === 5) {
                let policyLob_Value = luckysheet.getcellvalue(4, 2);
                let checklistData = sheetName === 'Red' ? JSON.parse(sessionStorage.getItem("redSheetData")) || [] : JSON.parse(sessionStorage.getItem("greenSheetData")) || [];
                const avilableLobs = props?.gradtionDataSet[0]?.AvailableLobs;
                if (sheetName === "Red" || sheetName === "Green") {
                    checklistData = checklistData = checklistData?.filter(e => e?.data?.length > 0)?.map((e, i) => ({
                        ...e,
                        TableName: `Table ${2 + i}`
                    }));
                }

                let tableDetails = sheetName === "Red" ? JSON.parse(sessionStorage.getItem('redTableRangeData')) || {} : sheetName === "Green" ? JSON.parse(sessionStorage.getItem('greenTableRangeData')) || {} : tableColumnDetails || {};

                if (sheetName === "Red" || sheetName === "Green") {
                    tableDetails = Object.fromEntries(
                        Object.entries(tableDetails).filter(([key]) => key !== "Table 1")
                    );
                }
                let keys = Object.keys(tableDetails)?.filter((f) => f !== "Table 1");
                let recordsToHide = [];
                keys.forEach((f) => {
                    const tableConfigData = tableDetails[f];
                    const columnKeys = tableConfigData?.columnNames;
                    const recordRange = tableConfigData?.range;
                    const sourceColumns = Object.keys(columnKeys).filter((key) => columnKeys[key] > (columnKeys["COVERAGE_SPECIFICATIONS_MASTER"] || columnKeys["Coverage_Specifications_Master"]) &&
                        columnKeys[key] < columnKeys["Document Viewer"]);
                    if (sourceColumns && sourceColumns?.length > 0) {
                        const findData = checklistData.find((fi) => fi?.TableName == f);
                        if (findData?.data && findData?.data?.length > 0) {
                            findData?.data?.forEach((item, itemIndex) => {
                                if (rowIndex === 4) { //for unmatched(variance)
                                    let needToHide = false;
                                    let needToHideInCount = 0;
                                    sourceColumns.forEach((srItem) => {
                                        const srCData = item[srItem];
                                        if (!needToHide && srCData && srCData?.trim()?.toLowerCase() == "matched") {
                                            needToHide = true;
                                        } else {
                                            if (srCData && srCData?.trim()?.toLowerCase() == "details not available in the document") {
                                                needToHideInCount = (needToHideInCount + 1);
                                            }
                                        }
                                    });
                                    if (needToHide || (needToHideInCount === sourceColumns?.length)) {
                                        recordsToHide.push(recordRange?.start + itemIndex + ((avilableLobs?.includes(item['POLICY LOB'] || item['Policy LOB']) ? 4 : 3)));
                                    }
                                } else if (rowIndex === 3) {
                                    let needToHide = true;
                                    sourceColumns.forEach((srItem) => {
                                        const srCData = item[srItem];
                                        if (needToHide && srCData && srCData?.trim()?.toLowerCase() == "matched") {
                                            needToHide = false;
                                        }
                                    });
                                    if (needToHide) {
                                        recordsToHide.push(recordRange?.start + itemIndex + ((avilableLobs?.includes(item['POLICY LOB'] || item['Policy LOB']) ? 4 : 3)));
                                    }
                                } else if (rowIndex === 5) {
                                    let needToHide = 0;
                                    sourceColumns.forEach((srItem) => {
                                        const srCData = item[srItem];
                                        if (srCData && srCData?.trim()?.toLowerCase() == "details not available in the document") {
                                            needToHide = (needToHide + 1);
                                        }
                                    });
                                    if (needToHide != sourceColumns?.length) {
                                        recordsToHide.push(recordRange?.start + itemIndex + ((avilableLobs?.includes(item['POLICY LOB'] || item['Policy LOB']) ? 4 : 3)));
                                    }
                                }
                            });
                        }
                    }
                });
                if (recordsToHide?.length > 0) {
                    recordsToHide = groupNumbers(recordsToHide);
                }
                showOrHideRecords(recordsToHide);
                let topConfig = 0;
                $("#luckysheet-scrollbar-y").scrollTop(topConfig + 400);
            }
        }
        else if (sheetName === 'CSR Pro') {
            if (rowIndex === 7 || rowIndex === 5 || rowIndex === 6) {
                let checklistData = props?.summaryReviewChecklistData
                    ? props.summaryReviewChecklistData
                    : [];
                if (checklistData && checklistData?.length > 0) {
                    checklistData = checklistData.map((e) => {
                        if (e?.TemplateData && typeof e?.TemplateData != 'object' && typeof e?.TemplateData === 'string') {
                            let templateData = JSON.parse(e.TemplateData);
                            e["TemplateData"] = templateData;
                        }
                        return e;
                    })
                }

                const tableDetails = summaryTableColumnDetails;
                let keys = [
                    "JobHeader",
                    "JobCommonDeclaration",
                    "JobCoverage",
                    "JobForm1",
                    "JobForm2",
                    "JobForm3",
                    "JobForm4"
                ];

                let recordsToHide = [];

                keys.forEach((f) => {
                    const tableConfigData =
                        tableDetails[
                        f == "JobHeader" ? "Table 1" :
                            f == "JobCommonDeclaration" ? "Table 2" :
                                f == "JobCoverage" ? "Table 3" :
                                    f == "JobForm1" ? "Table 4" :
                                        f == "JobForm2" ? "Table 5" :
                                            f == "JobForm3" ? "Table 6" :
                                                f == "JobForm4" ? "Table 7" : ""
                        ];

                    const columnKeys = tableConfigData?.columnNames;
                    const recordRange = tableConfigData?.range;

                    const sourceColumns = Object.keys(columnKeys).filter(
                        (key) => columnKeys[key] > 1 && columnKeys[key] < 3
                    );

                    if (sourceColumns && sourceColumns?.length > 0) {
                        const findData = checklistData[f];
                        if (findData && findData.length > 0) {
                            findData.forEach((item, itemIndex) => {
                                if (rowIndex === 6) { // mismatched || Mismatch
                                    let isMismatched = false;
                                    sourceColumns.forEach((srItem) => {
                                        let columnKey = (srItem === "Comparison Summary" ? "Status" : srItem);
                                        const value = item[columnKey]?.trim()?.toLowerCase();
                                        if (value === "mismatch") {
                                            isMismatched = true;
                                        }
                                    });
                                    if (!isMismatched) {
                                        recordsToHide.push(recordRange.start + itemIndex + (f === "JobCoverage" ? 4 : 3));
                                    }
                                } else if (rowIndex === 5) { // matched
                                    let needToHide = true;
                                    sourceColumns.forEach((srItem) => {
                                        let columnKey = srItem;
                                        if (columnKey === "Comparison Summary") columnKey = "Status";
                                        const srCData = item[columnKey];
                                        if (needToHide && srCData && srCData?.trim()?.toLowerCase() == "matched") {
                                            needToHide = false;
                                        }
                                    });
                                    if (needToHide) {
                                        recordsToHide.push(recordRange?.start + itemIndex + (f === "JobCoverage" ? 4 : 3));
                                    }
                                } else if (rowIndex === 7) { // details not available
                                    let needToHide = 0;
                                    sourceColumns.forEach((srItem) => {
                                        let columnKey = srItem;
                                        if (columnKey === "Comparison Summary") columnKey = "Status";
                                        const srCData = item[columnKey];
                                        if (srCData && srCData?.trim()?.toLowerCase() == "details not available in the document") {
                                            needToHide = (needToHide + 1);
                                        }
                                    });
                                    if (needToHide != sourceColumns?.length) {
                                        recordsToHide.push(recordRange?.start + itemIndex + (f === "JobCoverage" ? 4 : 3));
                                    }
                                }
                            });
                        }
                    }
                });

                if (recordsToHide?.length > 0) {
                    recordsToHide = groupNumbers(recordsToHide);
                }
                showOrHideRecords(recordsToHide);
                $("#luckysheet-scrollbar-y").scrollTop(400);
            }
        }
        else {
            showOrHideRecords([]);
            let topConfig = 0;
            // $("#luckysheet-scrollbar-y").scrollTop(topConfig + 400);
            if (!['QA Checklist', ExclusionSheetName, FormsCompareSheetName, 'CSR Pro']?.includes(luckysheet?.getSheet()?.name)) {
                dataGrouping(0);
            }
        }
    }

    const handleIconClick = () => {
        const currentSheetData = luckysheet.getSheet();
        if (currentSheetData?.name === 'Summary Checklist' || currentSheetData?.name === 'Red' || currentSheetData?.name === 'Green') {
            toggleFilterDialog();
        }
    }

    const toggleFilterDialog = () => {
        setOpenFilterDialog(!openFilterDialog);
    };

    const handleFilterDialogClose = (e) => {
        setOpenFilterDialog(false);
        if (e?.filterData?.selectedOption1 && e?.filterData?.selectedOption2) {
            setFilterSelectionData(e?.filterData);
        } else {
            setFilterSelectionData(null);
            if (!['QA Checklist', ExclusionSheetName, FormsCompareSheetName, 'CSR Pro']?.includes(luckysheet?.getSheet()?.name)) {
                dataGrouping(0);
            }
        }
    };

    function iconvaluestorage(newValue) {
        let existingValues = JSON.parse(sessionStorage.getItem('IconShownIndex')) || [];
        existingValues.push(newValue);
        sessionStorage.setItem('IconShownIndex', JSON.stringify(existingValues));
    };

    const dataGrouping = (ToBeShownIndex) => {
        const phrases = [
            "Do the Forms, Endorsements and Edition Dates match the source documents?",
            "Do the Forms, Endorsements and Edition Dates match the expiring policy?",
            "Are the forms and endorsements listed, attached in current term policy?",
            "Are the forms and endorsements attached, listed in current term policy?",
            "Common Declarations"
        ];

        const CurrentSheetName = luckysheet?.getSheet()?.name;
        if (CurrentSheetName && !['QA Checklist', ExclusionSheetName, FormsCompareSheetName, 'CSR Pro']?.includes(CurrentSheetName)) {
            sessionStorage.setItem('selectedgrouping', ToBeShownIndex);
            if (ToBeShownIndex != undefined) {
                iconvaluestorage(ToBeShownIndex);
            }
            let colRecordTect = '';
            if (ToBeShownIndex > 0) {
                const rowRecord = luckysheet.getcellvalue(ToBeShownIndex);
                const columnRecord = rowRecord[0];
                colRecordTect = getText(columnRecord, false);
                if (colRecordTect != "-" && colRecordTect != "+") {
                    return;
                }
            }
            let checklistData = [];

            if (CurrentSheetName === "Summary Checklist") {
                checklistData = props?.data || [];

                if (checklistData.length > 0) {
                    checklistData = checklistData.map(e => {
                        if (e?.TemplateData && typeof e.TemplateData === "string") {
                            try {
                                e.TemplateData = JSON.parse(e.TemplateData);
                            } catch (err) {
                                console.error("Invalid TemplateData JSON:", e.TemplateData);
                            }
                        }
                        return e;
                    });
                }
            } else if (CurrentSheetName === "Red") {
                checklistData = JSON.parse(sessionStorage.getItem("redSheetData")) || [];
            } else if (CurrentSheetName === "Green") {
                checklistData = JSON.parse(sessionStorage.getItem("greenSheetData")) || [];
            }

            if (CurrentSheetName !== "Summary Checklist") {
                checklistData = checklistData?.filter(e => e?.data?.length > 0)
            }

            if (CurrentSheetName === "Red" || CurrentSheetName === "Green") {
                checklistData = checklistData?.filter(e => e?.data?.length > 0)?.map((e, i) => ({
                    ...e,
                    TableName: `Table ${2 + i}`
                }));
            }

            let tableDetails = CurrentSheetName === "Red" ? JSON.parse(sessionStorage.getItem('redTableRangeData')) || {} : CurrentSheetName === "Green" ? JSON.parse(sessionStorage.getItem('greenTableRangeData')) || {} : tableColumnDetails || {};

            if (CurrentSheetName === "Red" || CurrentSheetName === "Green") {
                tableDetails = Object.fromEntries(
                    Object.entries(tableDetails).filter(([key]) => key !== "Table 1")
                );
            }
            let keys = Object.keys(tableDetails)?.filter((f) => f !== "Table 1");
            let recordsToHide = [];
            keys?.forEach((f) => {
                const tableConfigData = tableDetails[f];
                const recordRange = tableConfigData?.range;
                const shortQuestion = [];
                const findData = CurrentSheetName !== "Summary Checklist" ? checklistData?.find((fi) => fi?.TableName == f) : checklistData?.find((fi) => fi?.Tablename == f);
                const dataSet = CurrentSheetName !== "Summary Checklist" ? findData?.data : findData?.TemplateData;
                if (findData && dataSet?.length > 0) {
                    const backUpTemplateData = dataSet;
                    findData?.AvailableLobs?.forEach((lob) => {
                        backUpTemplateData?.forEach((item) => {
                            if (item["POLICY LOB"] && item["POLICY LOB"]?.toUpperCase()?.includes(lob.toUpperCase())) {
                                f = "Table 3";
                            }
                        });
                    });
                    let needIgnorance = false;
                    const ignoranceShortCode = [];
                    if (ToBeShownIndex > 0 && recordRange?.start < ToBeShownIndex && recordRange?.end >= ToBeShownIndex) {
                        needIgnorance = true;
                    }
                    const ignoreQCSet = [];
                    dataSet?.forEach((item, itemIndex) => {
                        let questionText = item["Checklist Questions"];
                        if (questionText) {
                            questionText = questionText?.toUpperCase()?.trim();
                            const questionCode = questionText?.substring(0, 3);

                            let isIgnorancecheck = false;
                            if (needIgnorance) {
                                if (CurrentSheetName === "Red" || CurrentSheetName === "Green") {
                                    const offset = phrases?.includes(item['POLICY LOB'] || item['Policy LOB']) ? 2 : 3;
                                    isIgnorancecheck = ((recordRange?.start + itemIndex + offset) === ToBeShownIndex) && colRecordTect == "+";
                                } else {
                                    isIgnorancecheck = ((recordRange?.start + itemIndex + (f == "Table 3" ? 3 : 2)) === ToBeShownIndex) && colRecordTect == "+";
                                }
                                // isIgnorancecheck = ((recordRange?.start + itemIndex + (f == "Table 3" ? 3 : 2)) === ToBeShownIndex) && colRecordTect == "+";
                                if (isIgnorancecheck) {
                                    ignoranceShortCode.push(questionCode);
                                }
                            } else if (ToBeShownIndex && ToBeShownIndex > 0) {
                                // ignoreQCSet, isIgnorancecheck
                                if (questionCode && !ignoreQCSet?.includes(questionCode)) {
                                    let colRecordText1 = '';
                                    if (CurrentSheetName === "Red" || CurrentSheetName === "Green") {
                                        const offset = phrases?.includes(item['POLICY LOB'] || item['Policy LOB']) ? 2 : 3;
                                        const rowRecord1 = luckysheet.getcellvalue(recordRange?.start + itemIndex + offset);
                                        const columnRecord1 = rowRecord1[0];
                                        colRecordText1 = getText(columnRecord1, false);
                                    } else {
                                        const rowRecord1 = luckysheet.getcellvalue(recordRange?.start + itemIndex + (f == "Table 3" ? 3 : 2));
                                        const columnRecord1 = rowRecord1[0];
                                        colRecordText1 = getText(columnRecord1, false);
                                    }
                                    // const rowRecord1 = luckysheet.getcellvalue(recordRange?.start + itemIndex + (f == "Table 3" ? 3 : 2));
                                    // const columnRecord1 = rowRecord1[0];
                                    // colRecordText1 = getText(columnRecord1, false);
                                    if (colRecordText1 == "-") {
                                        ignoreQCSet.push(questionCode);
                                    }
                                }
                            }
                            if (shortQuestion?.includes(questionCode)) {
                                if ((!ignoranceShortCode || (ignoranceShortCode && ignoranceShortCode?.length === 0)) && (ignoreQCSet?.length === 0)) {
                                    if (CurrentSheetName === "Red" || CurrentSheetName === "Green") {
                                        const offset = phrases?.includes(item['POLICY LOB'] || item['Policy LOB']) ? 3 : 4;
                                        recordsToHide.push(recordRange?.start + itemIndex + offset);
                                    } else {
                                        recordsToHide.push(recordRange?.start + itemIndex + (f === "Table 3" ? 4 : 3));
                                    }
                                    // recordsToHide.push(recordRange?.start + itemIndex + (f === "Table 3" ? 4 : 3));
                                }
                                else if (!ignoranceShortCode?.includes(questionCode) && !ignoreQCSet?.includes(questionCode)) {
                                    if (CurrentSheetName === "Red" || CurrentSheetName === "Green") {
                                        const offset = phrases?.includes(item['POLICY LOB'] || item['Policy LOB']) ? 3 : 4;
                                        recordsToHide.push(recordRange?.start + itemIndex + offset);
                                    } else {
                                        recordsToHide.push(recordRange?.start + itemIndex + (f === "Table 3" ? 4 : 3));
                                    }
                                    // recordsToHide.push(recordRange?.start + itemIndex + (f === "Table 3" ? 4 : 3));
                                }
                            } else {
                                const hasMoreThanOne = backUpTemplateData.filter((qcF) => {
                                    const cqTextForFilter = qcF["Checklist Questions"];
                                    if (cqTextForFilter) {
                                        const cqFormatFixText = cqTextForFilter?.toUpperCase()?.trim();
                                        if (cqFormatFixText?.substring(0, 3) == questionCode) {
                                            return qcF;
                                        }
                                    }
                                });
                                if (hasMoreThanOne && hasMoreThanOne?.length > 1) {
                                    const dataToPopulate = {
                                        "m": ignoreQCSet?.includes(questionCode) ? "-" : ToBeShownIndex && ToBeShownIndex > 0 && isIgnorancecheck ? colRecordTect == "-" ? "+" : "-" : "+",
                                        "ct": {
                                            "fa": "General",
                                            "t": "g"
                                        },
                                        "v": ignoreQCSet?.includes(questionCode) ? "-" : ToBeShownIndex && ToBeShownIndex > 0 && isIgnorancecheck ? colRecordTect == "-" ? "+" : "-" : "+",
                                        "ht": "0",
                                        "fs": "17",
                                        "fc": "#000000",
                                        "bl": 1
                                    };

                                    if (CurrentSheetName === "Red" || CurrentSheetName === "Green") {
                                        const offset = phrases?.includes(item['POLICY LOB'] || item['Policy LOB']) ? 2 : 3;
                                        setCellValue(recordRange?.start + itemIndex + offset, 0, dataToPopulate)
                                    } else {
                                        setCellValue(recordRange?.start + itemIndex + (f === "Table 3" ? 3 : 2), 0, dataToPopulate)
                                    }
                                    // luckysheet.setcellvalue( recordRange?.start + itemIndex + ( f === "Table 3" ? 3 : 2), 0, luckysheet.flowdata(), dataToPopulate );

                                    let storedvalues = JSON.parse(sessionStorage.getItem('IconShownIndex'));
                                    if (storedvalues != null) {
                                        const frequencyMap = {};
                                        storedvalues?.forEach(value => {
                                            frequencyMap[value] = (frequencyMap[value] || 0) + 1;
                                        });

                                        const finalset = storedvalues?.filter(value => frequencyMap[value] === 1);

                                        const dataPopulate = {
                                            "m": "-",
                                            "ct": {
                                                "fa": "General",
                                                "t": "g"
                                            },
                                            "v": "-",
                                            "ht": "0",
                                            "fs": "17",
                                            "fc": "#000000",
                                            "bl": 1
                                        };
                                        sessionStorage.setItem('IconShownIndex', JSON.stringify(finalset));
                                        finalset?.forEach(value => {
                                            setCellValue(value, 0, dataPopulate);
                                        });

                                    }
                                }
                                shortQuestion.push(questionCode);
                            }
                        }
                    })
                }
            });
            if (recordsToHide?.length > 0) {
                recordsToHide = groupNumbers(recordsToHide);
            }
            showOrHideRecords(recordsToHide, ToBeShownIndex);
        }
    }

    const showOrHideRecords = (rowSet, setid) => {
        var groupingData = sessionStorage.getItem('selectedgrouping');

        if (groupingData !== "undefined") {
            let beforeselectedvalue = +groupingData + 2;
            updateLocalStorage(beforeselectedvalue);
            let storedValues = JSON.parse(sessionStorage.getItem('hitedselectedValues')) || [];
            const removedArrays = [];
            rowSet = rowSet?.filter(innerArray => {
                const containsK = innerArray?.includes(beforeselectedvalue);
                const containsStoredValue = innerArray?.some(value => storedValues?.includes(value));
                if (containsK || containsStoredValue) {
                    removedArrays.push(innerArray);
                    return false;
                }
                return true;
            });

            let existingRemovedArrays = JSON.parse(sessionStorage.getItem('removedArrays')) || [];
            existingRemovedArrays.push(...removedArrays);
            sessionStorage.setItem('removedArrays', JSON.stringify(existingRemovedArrays));
            sessionStorage.removeItem('selectedgrouping');

            // Check if beforeselectedvalue is in storedValues
            //without reference don't remove any part of this code
            if (storedValues?.includes(beforeselectedvalue)) {
                const getremovearray = JSON.parse(sessionStorage.getItem('removedArrays'));
                const arrayToAddBack = getremovearray?.find(innerArray => innerArray?.includes(beforeselectedvalue));

                if (arrayToAddBack) {
                    rowSet.push(arrayToAddBack);
                    const indexInRemovedArrays = existingRemovedArrays?.findIndex(removedArray =>
                        JSON.stringify(removedArray) === JSON.stringify(arrayToAddBack)
                    );

                    if (indexInRemovedArrays !== -1) {
                        existingRemovedArrays.splice(indexInRemovedArrays, 1);
                        let iconIndexset = JSON.parse(sessionStorage.getItem('IconShownIndex'));
                        if (iconIndexset.includes(beforeselectedvalue - 2)) {
                            const shouldRemove = (arr) => {
                                return getremovearray.some(removed =>
                                    arr.length === removed.length && arr.every(value => removed.includes(value)) &&
                                    removed.includes(beforeselectedvalue)
                                );
                            };
                            const filteredRowSet = rowSet.filter(arr => !shouldRemove(arr));
                            rowSet.length = 0;
                            Array.prototype.push.apply(rowSet, filteredRowSet);
                            existingRemovedArrays.splice(indexInRemovedArrays, 1);
                        }

                        sessionStorage.setItem('removedArrays', JSON.stringify(existingRemovedArrays));
                    }
                    var hiteval = JSON.parse(sessionStorage.getItem('hitedselectedValues'))
                    const hittedvalues = hiteval.filter(value => value !== beforeselectedvalue);

                    sessionStorage.setItem('hitedselectedValues', JSON.stringify(hittedvalues));
                }
            }
        }

        const config = luckysheet.getConfig();
        let range = luckysheet.getRange();
        let zoomConfig = luckysheet.getSheet();
        let rowRange = range[0].row[0] + 1;
        let rowRangee = range[0].row[0] + 2;
        const hiddenRows = config?.rowhidden ? Object.keys(config?.rowhidden) : [];
        if (hiddenRows && hiddenRows?.length > 0) {
            const parsedSet = hiddenRows.map((f) => parseInt(f));
            const grouppedSet = groupNumbers(parsedSet);
            grouppedSet.forEach((f) => {
                luckysheet.showRow(f[0], f[f?.length - 1]);
            });
            luckysheet.scroll({
                targetRow: setid,
                targetColumn: 0
            });
        }
        if (rowSet?.length > 0) {
            rowSet.forEach((f) => {
                if (f?.length > 0) {
                    luckysheet.hideRow((f[0] - 1), (f[f?.length - 1] - 1));
                } else {
                    luckysheet.hideRow((f[0] - 1), (f[f?.length - 1] - 1));
                }
            });
            luckysheet.scroll({
                targetRow: setid,
                targetColumn: 0
            });
        }
    }

    function updateLocalStorage(beforeValue) {
        let basedatas = JSON.parse(sessionStorage.getItem('hitedselectedValues')) || [];
        if (basedatas.length === 0 || !basedatas.includes(beforeValue)) {
            basedatas.push(beforeValue);
        }
        sessionStorage.setItem('hitedselectedValues', JSON.stringify(basedatas));
    }

    const groupNumbers = (data) => {
        data = data.sort((a, b) => a - b)
        const groupedData = [];

        if (data.length === 0) {
            return;
        }

        let currentGroup = [data[0]];

        for (let i = 1; i < data.length; i++) {
            if (data[i] === data[i - 1] || data[i] === data[i - 1] + 1) {
                currentGroup.push(data[i]);
            } else {
                groupedData.push(currentGroup);
                currentGroup = [data[i]];
            }
        }
        groupedData.push(currentGroup);
        return groupedData;
    };

    const updateNameInsuredApi = async (jobId, noColumnValue) => {
        try {
            const token = sessionStorage.getItem("token");
            const Token = await processAndUpdateToken(token);
            const data = {
                JobId: jobId,
                NoColumnValue: noColumnValue,
            };
            const headers = {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json",
            };
            const response = await axios.put(
                baseUrl + "/api/ProcedureData/update-name-insured",
                data,
                { headers }
            );
            return response?.data;
        } catch (error) {
            throw error;
        }
    };

    const table1Datamap = async (jobId, noColumnValue, shouldCallApi) => {
        const tblRange = tableColumnDetails["Table 1"];
        const sliceData = noColumnValue.slice(tblRange?.range?.start, tblRange?.range?.end + 1);
        const defaultTextValue = 'Named Insured';
        const funToFindnoColumnValue = (sliceData) => {
            for (const row of sliceData) {
                for (const obj of row) {
                    if (obj && (obj.m === defaultTextValue || obj.v === defaultTextValue)) {
                        return row;
                    }
                }
            }
        }
        let rowData = funToFindnoColumnValue(sliceData);
        let filterData = rowData.filter(e => e != null);
        if (brokerId == "1162" && shouldCallApi) {
            await updateNameInsuredApi(jobId, filterData[1]?.m || filterData[1]?.v || "");
        }
    }

    const onSaveClick = async (shouldCallApi, isAutoUpdate = false) => {
        try {
            luckysheet.exitEditMode();
            const allSheets = luckysheet.getAllSheets();
            const policyData = allSheets?.filter((f) => f?.name === "Summary Checklist");
            const formData = allSheets?.filter((f) => f?.name === FormsCompareSheetName);
            const exclusonData = allSheets?.filter((f) => f?.name === ExclusionSheetName);
            const proposalexclusonData = allSheets?.filter((f) => f?.name === "ProposalExclusions");
            const redData = allSheets?.filter((f) => f?.name === "Red");
            const greenData = allSheets?.filter((f) => f?.name === "Green");
            const qacData = allSheets?.filter((f) => f?.name === "QA Checklist");

            const jobId = props?.selectedJob;
            const noColumnValue = policyData[0]?.data;
            const sessionQacData = sessionStorage.getItem("qacTblRange");
            const qacTableColumnDetails = JSON?.parse(sessionQacData);

            const processData = (sheetName, sheetData, tblRangeArray, filterData) => {
                if (sheetName != "QA Checklist") {
                    const aodDataMSet = [];
                    if (sheetData && sheetData?.length > 0 && tblRangeArray && tblRangeArray?.length > 0) {
                        tblRangeArray?.forEach((f) => {
                            // if (Array.isArray(filterData)) {
                            const tableFilterData = sheetName === ExclusionSheetName ? filterData?.data : sheetName === "ProposalExclusions" ? filterData?.data : filterData?.find((d) => d.TableName === f?.TableName);
                            if (tableFilterData) {
                                const filteredOriginalData = sheetName === ExclusionSheetName ? tableFilterData : sheetName === "ProposalExclusions" ? tableFilterData : tableFilterData?.data;
                                const start = f?.TableName == "FormTable 2" ? f?.range?.start + 3 : f?.TableName == "FormTable 3" ? f?.range?.start + 3 : f?.range?.start + 2;
                                const end = f?.range?.end + 1;
                                const splitedData = sheetData.slice(start, end);
                                if (splitedData && splitedData?.length > 0) {
                                    let aodDataSet = [];
                                    splitedData?.forEach((item, itemIndex) => {
                                        let record = filteredOriginalData?.find((fod) => fod?.sheetPosition && fod?.sheetPosition === (start + itemIndex));
                                        const aod = item[f?.columnNames["Actions on Discrepancy"]] || item[f?.columnNames["ActionOnDiscrepancy"]] || item[f?.columnNames[0]?.indexOf("ActionOnDiscrepancy") - 1];
                                        const re = item[f?.columnNames["Request Endorsement"]] || item[f?.columnNames["RequestEndorsement"]] || item[f?.columnNames[0]?.indexOf("RequestEndorsement") - 1];
                                        const ns = item[f?.columnNames["Notes for Endorsement"]] || item[f?.columnNames["Notes"]] || item[f?.columnNames[0]?.indexOf("Notes") - 1];
                                        const nff = item[f?.columnNames["Notes(Free Fill)"]] || item[f?.columnNames["NotesFreeFill"]] || item[f?.columnNames[0]?.indexOf("NotesFreeFill") - 1];

                                        let aodData = aod ? getText(aod, true) : '';
                                        let reData = re ? getText(re, true) : '';
                                        let nsData = ns ? getText(ns, true) : '';
                                        let nffData = nff ? getText(nff, true) : '';

                                        aodData = aodData != undefined && aodData != null ? aodData : '';
                                        reData = reData != undefined && reData != null ? reData : '';
                                        nsData = nsData != undefined && nsData != null ? nsData : '';
                                        nffData = nffData != undefined && nffData != null ? nffData : '';

                                        if (record && !(aodData?.trim() === '' && reData?.trim() === '' && nsData?.trim() === '' && nffData?.trim() === '')) {
                                            record["ActionOnDiscrepancy"] = aodData;
                                            record["RequestEndorsement"] = reData;
                                            record["Notes"] = nsData;
                                            record["NotesFreeFill"] = nffData;
                                            if (record["ActionOnDiscrepancy"] === "Click here" && record["RequestEndorsement"] === "Click here" &&
                                                record["Notes"] === "Click here"
                                            ) {
                                                record["ActionOnDiscrepancy"] = "";
                                                record["RequestEndorsement"] = "";
                                                record["Notes"] = "";
                                            } else {
                                                ["ActionOnDiscrepancy", "RequestEndorsement", "Notes"].forEach(key => {
                                                    if (record[key] === "Click here") {
                                                        record[key] = "";
                                                    }
                                                })
                                            }
                                            aodDataSet.push(record);
                                        }

                                        if (filteredOriginalData && splitedData?.length === (itemIndex + 1) && sheetName != ExclusionSheetName && sheetName != "ProposalExclusions") {
                                            const keys = Object.keys(filteredOriginalData[0]);
                                            const policyKey = keys?.includes("POLICY LOB") ? "POLICY LOB" : "Policy LOB";
                                            let policyLob = filteredOriginalData?.map(f => f[policyKey]);
                                            policyLob = Array.from(new Set(policyLob));
                                            aodDataMSet.push({ "TableName": f?.TableName, "Data": aodDataSet, "PolicyLob": policyLob[0] });
                                        } else if (filteredOriginalData && splitedData?.length === (itemIndex + 1) && (sheetName == ExclusionSheetName || sheetName == "ProposalExclusions")) {
                                            aodDataMSet.push({ "Data": aodDataSet });
                                        }
                                    });
                                }
                            }
                            // }    
                        });
                    }
                    return aodDataMSet;
                } else if (sheetName == "QA Checklist") {
                    const qacDataMSet = [];
                    const sheetDataRowIndex = sheetDataRowIndexRef?.current;
                    const queRowRata = Object.keys(sheetDataRowIndex);
                    queRowRata?.forEach((Key) => {
                        const lobrow = sheetDataRowIndex[Key];
                        Object.keys(lobrow)?.forEach((lob) => {
                            const filterData = lobrow[lob];
                            let tblDataSet = [];
                            if (filterData && filterData?.length > 0) {
                                filterData?.forEach((item, index) => {
                                    const findindex = luckysheet.getcellvalue(item?.RowIndex);
                                    if (findindex?.length > 0) {
                                        const mappedRow = {
                                            "Coverage Specifications": getText(findindex[0], true),
                                            "Discrepancies to note on Intranet Form:": getText(findindex[1], true),
                                            "Checked By (Initials):": getText(findindex[2], true)
                                        };
                                        tblDataSet.push(mappedRow);
                                    }
                                    if (filterData?.length === (index + 1)) {
                                        qacDataMSet.push({ "Table": `qacTable ${index + 0}`, "dataPairSet": tblDataSet, "tableType": Key, "policyLob": lob });
                                    }
                                });
                            }
                        });
                    });

                    const reseededTblDatSet = qacDataMSet?.map((item, index) => {
                        return {
                            ...item,
                            Table: `qacTable ${index + 0}`
                        };
                    });
                    const finalDataSet = {};

                    reseededTblDatSet?.forEach(dataSet => {
                        const { Table, tableType, dataPairSet, policyLob } = dataSet;
                        if (!finalDataSet[tableType]) {
                            finalDataSet[tableType] = {};
                        }
                        const tableDetail = qacTableColumnDetails[tableType]?.find(tbl => tbl[Table]);

                        if (tableDetail) {
                            const lobData = policyLob;

                            if (!finalDataSet[tableType][lobData]) {
                                finalDataSet[tableType][lobData] = [];
                            }
                            finalDataSet[tableType][lobData].push(...dataPairSet);
                        }
                    });
                    return finalDataSet;
                };
            };

            let checklistData = [];
            let formsCompareData = [];
            let exclusionData = [];
            let proposalexclusionData = [];
            let qacSheetData = [];
            let combineGradiationData = [];
            let sheetCheck = luckysheet?.getSheet()?.name;
            if (policyData && policyData?.length > 0 && sheetCheck == "Summary Checklist") {
                const policytrack = sessionStorage.getItem('policyDataTracked')
                const data = dataForSavePolicy == null || undefined || dataForSavePolicy.length == 0 ? JSON.parse(policytrack) : dataForSavePolicy;
                let reseededData = data?.map((item, index) => {
                    return {
                        ...item,
                        TableName: `Table ${index + 2}`
                    };
                });

                const positionpolicy = sessionStorage.getItem('positioningForPolicy')
                const policyPosDetails = dataForSavePolicyPosition == null || undefined || dataForSavePolicyPosition.length == 0 ? JSON.parse(positionpolicy) : dataForSavePolicyPosition;
                const reseededPolicyPosDetails = policyPosDetails?.map((item, index) => {
                    return {
                        ...item,
                        TableName: `Table ${index + 2}`
                    };
                });

                const sheetData = policyData[0]?.data;
                const keysToRemove = [
                    "OBSERVATION",
                    "Page Number",
                    "CreatedOn",
                    "Observation",
                    "Document Viewer"
                ];

               reseededData = (reseededData || []).map(table => ({
                    ...table,
                    data: Array.isArray(table?.data)
                        ? table.data.map(item => {
                            const newItem = { ...item };

                            keysToRemove.forEach(key => {
                                delete newItem[key];
                            });

                            return newItem;
                        })
                        : []
                }));
                checklistData = processData("PreviewCheckList", sheetData, reseededPolicyPosDetails, reseededData);
            }

            if (formData && formData?.length > 0 && sheetCheck == FormsCompareSheetName) {
                const formsCompare_DataTracked = sessionStorage.getItem('formsCompareDataTracked');
                const data = dataForSaveFormsCompare == null || undefined || dataForSaveFormsCompare.length == 0 ? JSON.parse(formsCompare_DataTracked) : dataForSaveFormsCompare;
                const positioningFor_FormsCompareData = sessionStorage.getItem('positioningForFormsCompareData');
                const formsComparePosDetails = dataForSaveFormsComparePosition == null || undefined || dataForSaveFormsComparePosition.length == 0 ? JSON.parse(positioningFor_FormsCompareData) : dataForSaveFormsComparePosition;

                const sheetData = formData[0]?.data;
                formsCompareData = processData("FormsCompare", sheetData, formsComparePosDetails, data);
            }

            if (exclusonData && exclusonData?.length > 0 && sheetCheck == ExclusionSheetName) {
                const exclusionDataTracked = sessionStorage.getItem('exclusionDataTracked');
                const data = dataForSaveExclusion[0] == null || undefined || dataForSaveExclusion.length == 0 ? JSON.parse(exclusionDataTracked) : dataForSaveExclusion[0];
                const positioningForexclusionData = sessionStorage.getItem('positioningForexclusionData');
                const exclusionPosDetails = dataForSaveExclusionPosition == null || undefined || dataForSaveExclusionPosition.length == 0 ? JSON.parse(positioningForexclusionData) : dataForSaveExclusionPosition;

                const sheetData = exclusonData[0]?.data;
                exclusionData = processData(ExclusionSheetName, sheetData, exclusionPosDetails, data[0]);
            }
            
            if (proposalexclusonData && proposalexclusonData?.length > 0 && sheetCheck == "ProposalExclusions") {
                const exclusionDataTracked = sessionStorage.getItem('proposalexclusionDataTracked');
                const data = dataForSaveProposalExclusion[0] == null || dataForSaveProposalExclusion[0] == undefined || dataForSaveProposalExclusion.length == 0 ? JSON.parse(exclusionDataTracked) : dataForSaveProposalExclusion[0];
                const positioningForexclusionData = sessionStorage.getItem('positioningForProposalexclusionData');
                const exclusionPosDetails = dataForSaveProposalExclusionPosition == null || undefined || dataForSaveProposalExclusionPosition.length == 0 ? JSON.parse(positioningForexclusionData) : dataForSaveProposalExclusionPosition;

                const sheetData = proposalexclusonData[0]?.data;
                proposalexclusionData = processData("ProposalExclusions", sheetData, exclusionPosDetails, data[0]);
            }

            if (qacData && qacData?.length > 0 && sheetCheck == "QA Checklist") {
                const tableRangeData = qacTableColumnDetails;
                const sheetData = qacData[0]?.data;
                qacSheetData = processData("QA Checklist", sheetData, tableRangeData, "");
            }

            if (redData && redData?.length > 0 && (sheetCheck == "Red" || sheetCheck == "Green")) {
                let redSheetData = sessionStorage.getItem('redSheetData');
                let data = JSON.parse(redSheetData);
                let filterData = data?.filter(item => Object.keys(item.data).length !== 0);
                filterData?.forEach((item, index) => {
                    item.TableName = `Table ${index + 2}`;
                });

                let redTableRange = sessionStorage.getItem('redTableRangeDataUpdate');
                const gradiationRedData = JSON.parse(redTableRange);

                const sheetData = redData[0]?.data;
                combineGradiationData = combineGradiationData.concat(processData("GradiationRedSheet", sheetData, gradiationRedData, filterData));
            }

            if (greenData && greenData?.length > 0 && (sheetCheck == "Red" || sheetCheck == "Green")) {
                let greenSheetData = sessionStorage.getItem('greenSheetData');
                let data = JSON.parse(greenSheetData);
                let filterData = data?.filter(item => Object.keys(item.data).length !== 0);
                filterData?.forEach((item, index) => {
                    item.TableName = `Table ${index + 2}`;
                });

                let greenTableRange = sessionStorage.getItem('greenTableRangeDataUpdate');
                const gradiationGreenData = JSON.parse(greenTableRange);

                const sheetData = greenData[0]?.data;
                combineGradiationData = combineGradiationData.concat(processData("GradiationGreenSheet", sheetData, gradiationGreenData, filterData));
            }

            let filteredCombinedData = combineGradiationData?.filter(f => f.Data.length !== 0);  // filter the empty array after concatination

            // Merge the data for objects with the same TableName and PolicyLob
            let mergedLobData = filteredCombinedData.reduce((acc, item) => {
                const existingItem = acc?.find(i => i.PolicyLob === item?.PolicyLob);
                if (existingItem) {
                    existingItem.Data = existingItem?.Data.concat(item.Data);
                } else {
                    acc.push(item);
                }
                return acc;
            }, []);

            let filterNullLobData = mergedLobData?.filter(f => f?.Data?.length !== 0);

            let checklistDataForUpdate = checklistData?.filter(f => f?.Data && f.Data?.length > 0);
            let formsCompareDataForUpdate = formsCompareData
                ?.filter(f => f?.Data && f.Data?.length > 0)
                ?.map(f => ({
                    ...f,
                    Data: f.Data.map(d => {
                        const { COVERAGE_SPECIFICATIONS_MASTER, OBSERVATION, sheetPosition, ...rest } = d;
                        delete rest["Checklist Questions"];
                        delete rest["Policy LOB"];
                        delete rest["Page Number"];
                        delete rest["Current Term Policy Attached"];
                        delete rest["Prior Term Policy Attached"];
                        delete rest["Document Viewer"];
                        return rest;
                    })
                }));

            let exclusionDataForUpdate = exclusionData
                ?.filter(f => f?.Data && f.Data?.length > 0)
                ?.map(f => ({
                    ...f,
                    Data: f.Data.map(d => {
                        const { FormDescription, FormName, JobId, Exclusions, PageNumber, CreatedOn, UpdatedOn, Selected, sheetPosition, ...rest } = d;
                        delete rest["Document Viewer"];
                        return rest;
                    })
                }));

             let proposalexclusionDataForUpdate = proposalexclusionData
                ?.filter(f => f?.Data && f.Data?.length > 0)
                ?.map(f => ({
                    ...f,
                    Data: f.Data.map((d, index) => {
                        const { FormDescription, FormName, JobId, Exclusion, PageNumber, CreatedOn, UpdatedOn, Selected, sheetPosition, ...rest } = d;
                        delete rest["Document Viewer"];
                       return {
                            ...rest,
                            Id: rest.Id || index + 1
                        };
                    })
                }));

            let qacDataSet = qacSheetData;

            // checklistDataForUpdate.forEach(table => {
            //     table.Data.forEach(item => {
            //         Object.keys(item).forEach(key => {
            //            if(!keysToRemovePolicyReview.includes(key)){
            //                delete item[key];
            //            }
            //         });
            //     });
            //     delete table['PolicyLob'];
            //     delete table['TableName'];
            // });

            const gradiationDataForUpdate = filterNullLobData.filter(f => f?.Data && f.Data?.length > 0);

            // logic to send the Data to api if any of one sheet data is available for a JobId
            if (checklistDataForUpdate.length > 0 && sheetCheck == "Summary Checklist") {
                // checklistDataForUpdate.forEach ( Ary => {
                //     Ary.Data = Ary?.Data.filter( obj => {
                //         let spliceObj = Object.keys(obj).filter(key => key != "Id");
                //         return spliceObj.some(keys => obj[keys] != "");  // sending to api only the objects with non-empty values
                //     })
                // })
                if (shouldCallApi) {
                    await csrSheetPolicyGradiationDataSaveApi(0, props?.selectedJob, "PreviewCheckList", JSON.stringify(checklistDataForUpdate), isAutoUpdate);
                }
                await csrSaveJobidExportFun("PreviewCheckList", checklistDataForUpdate, shouldCallApi, isAutoUpdate);   // function to call the export for csrSave history Jobid in the xlpage Report Screen
            } else if (sheetCheck == FormsCompareSheetName) {
                let mappingData = formsCompareDataForUpdate.map(e => e.Data);
                let arry = mappingData.flat();  // used to flatten the nested array into array of objects
                let splicedArry = arry.filter(obj => {
                    let spliceObj = Object.keys(obj).filter(key => key != "Id");
                    return spliceObj.some(keys => obj[keys] != "");   // sending to api only the objects with non-empty values
                })
                if (shouldCallApi) {
                    await csrSheetCommonSaveApi(props?.selectedJob, "FormTable", JSON.stringify(splicedArry), isAutoUpdate);
                }
                // await CsrSaveHistoryApiCall(props?.selectedJob, sessionStorage.getItem("csrAuthUserName"), JSON.stringify(splicedArry), brokerId, isAutoUpdate);
            } else if (sheetCheck == ExclusionSheetName) {
                let mappingData = exclusionDataForUpdate.map(e => e.Data);
                let arry = mappingData.flat();  // used to flatten the nested array into array of objects
                let splicedArry = arry.filter(obj => {
                    let spliceObj = Object.keys(obj).filter(key => key != "Id");
                    return spliceObj.some(keys => obj[keys] != "");   // sending to api only the objects with non-empty values
                })
                if (shouldCallApi) {
                    csrSheetCommonSaveApi(props?.selectedJob, "ExclusionTable", JSON.stringify(splicedArry), isAutoUpdate);
                }
                // await CsrSaveHistoryApiCall(props?.selectedJob, sessionStorage.getItem("csrAuthUserName"), JSON.stringify(splicedArry), brokerId, isAutoUpdate);
            } else if (sheetCheck == "ProposalExclusions") {
                let mappingData = proposalexclusionDataForUpdate.map(e => e.Data);
                let arry = mappingData.flat();  // used to flatten the nested array into array of objects
                let splicedArry = arry.filter(obj => {
                    let spliceObj = Object.keys(obj).filter(key => key != "Id");
                    return spliceObj.some(keys => obj[keys] != "");   // sending to api only the objects with non-empty values
                })
                if (shouldCallApi) {
                    csrSheetCommonSaveApi(props?.selectedJob, "ProposalExclusionTable", JSON.stringify(splicedArry), isAutoUpdate);
                }
                // await CsrSaveHistoryApiCall(props?.selectedJob, sessionStorage.getItem("csrAuthUserName"), JSON.stringify(splicedArry), brokerId, isAutoUpdate);
            } 
            // else if (sheetCheck == "ProposalExclusions") {
            //     const currentSheet = luckysheet.getSheet();

            //     if (!currentSheet) {
            //         console.error("ProposalExclusions sheet not found");
            //         return;
            //     }

            //     const sheetData = currentSheet.data || [];

            //     console.log("CURRENT PROPOSAL SHEET DATA:", sheetData);

            //     const getCellValue = (cell) => {
            //         if (cell === null || cell === undefined) {
            //             return "";
            //         }

            //         if (typeof cell === "object") {
            //             return cell?.v ?? cell?.m ?? "";
            //         }

            //         return cell;
            //     };

            //     const cleanValue = (value) => {
            //         if (
            //             value === "Click here" ||
            //             value === "~~Click here"
            //         ) {
            //             return "";
            //         }

            //         return value ?? "";
            //     };

            //     const proposalDataForSave = proposalstate?.map(
            //         (originalData, index) => {

            //             // Proposal data starts from row 2
            //             const rowIndex = index + 2;

            //             const row = sheetData?.[rowIndex] || [];

            //             return {
            //                 Id: originalData?.Id,

            //                 FormName: getCellValue(row?.[0]),

            //                 FormDescription: getCellValue(row?.[1]),

            //                 Proposal: getCellValue(row?.[2]),

            //                 PageNumber: getCellValue(row?.[3]),

            //                 // Selected: getCellValue(row?.[4]),

            //                 "Document Viewer": getCellValue(row?.[4]),

            //                 ActionOnDiscrepancy: cleanValue(
            //                     getCellValue(row?.[5])
            //                 ),

            //                 RequestEndorsement: cleanValue(
            //                     getCellValue(row?.[6])
            //                 ),

            //                 Notes: cleanValue(
            //                     getCellValue(row?.[7])
            //                 ),

            //                 NotesFreeFill: cleanValue(
            //                     getCellValue(row?.[8])
            //                 )
            //             };
            //         }
            //     );

            //     console.log(
            //         "FINAL PROPOSAL SAVE DATA:",
            //         proposalDataForSave
            //     );

            //     if (shouldCallApi) {
            //         await csrSheetCommonSaveApi(
            //             props?.selectedJob,
            //             "ProposalExclusion",
            //             JSON.stringify(proposalDataForSave),
            //             isAutoUpdate
            //         );
            //     }
            // }
            else if ((sheetCheck == "Red" || sheetCheck == "Green")) {
                if (shouldCallApi) {
                    await csrSheetPolicyGradiationDataSaveApi(0, props?.selectedJob, "GradiationSheet", JSON.stringify(gradiationDataForUpdate), isAutoUpdate);
                }
                await CsrSaveHistoryApiCall("GradiationSheet", props?.selectedJob, sessionStorage.getItem("csrAuthUserName"), JSON.stringify(gradiationDataForUpdate), brokerId, isAutoUpdate);
            } else if (sheetCheck == "QA Checklist") {
                if (shouldCallApi) {
                    await qacSheetSaveCall(props?.selectedJob, JSON.stringify(qacDataSet), isAutoUpdate);
                }
            }

            if (brokerId == "1167") {
                await table1Datamap(jobId, noColumnValue, shouldCallApi);
            }
        } catch (error) {
            const message = isAutoUpdate ? "CSR-AOD-AuoUpdate-UI-function-error" : "CSR-AOD-Update-UI-function-error";
            updateGridAuditLog(jobId, message, typeof error === 'object' ? JSON.stringify(error) : error, (userName || sessionUserName));
        }
    };

    const Autoupdateclick = async (autoupdate) => {
        if (autoupdate == true && (luckysheet != undefined && luckysheet != null)) {
            try {
                await onSaveClick(true, true);
            } catch (error) {
                console.error("Error occurred:", error);
            }
        }
    }

    const csrSaveJobidExportFun = async (sheetType, checklistDataForUpdate, shouldCallApi, isAutoUpdate) => {
        let mergedData = checklistDataForUpdate.reduce((acc, table) => {
            return acc.concat(table.Data);
        }, []);

        let filteredArrayData = mergedData.filter(obj =>
            obj.ActionOnDiscrepancy !== "" ||
            obj.RequestEndorsement !== "" ||
            obj.Notes !== ""
        )

        if (filteredArrayData?.length > 0) {
            let UserName = sessionStorage.getItem("csrAuthUserName");
            let JobID = props?.selectedJob;
            let currentDate = new Date().toISOString();

            filteredArrayData?.forEach(item => {
                item.UserName = UserName;  // Add UserName as a key-value pair
                item.JobID = JobID;        // Add JobID as a key-value pair
                item.CreatedOn = currentDate;
                delete item?.Id;
            });

            filteredArrayData?.forEach(obj => {
                // Rename 'COVERAGE_SPECIFICATIONS_MASTER' or 'Coverage_Specifications_Master' to 'COVERAGE SPECIFICATIONS'
                if (obj.hasOwnProperty('COVERAGE_SPECIFICATIONS_MASTER')) {
                    obj['COVERAGE SPECIFICATIONS'] = obj['COVERAGE_SPECIFICATIONS_MASTER'];
                    delete obj['COVERAGE_SPECIFICATIONS_MASTER'];
                } else if (obj.hasOwnProperty('Coverage_Specifications_Master')) {
                    obj['COVERAGE SPECIFICATIONS'] = obj['Coverage_Specifications_Master'];
                    delete obj['Coverage_Specifications_Master'];
                }
            });

            let getLocalStgbrokerDatas = sessionStorage.getItem('brokerDatas');
            const brokerData = JSON.parse(getLocalStgbrokerDatas);
            const mappedData = brokerData.map(({ BrokerId, VchBrokerName }) => ({
                key: BrokerId.toString(),
                text: VchBrokerName,
            }));

            filteredArrayData?.forEach(item => {
                const sliceJobid = item?.JobID.slice(0, 4);
                const brokerIdMap = mappedData.find(e => e.key === sliceJobid);

                if (brokerIdMap) {
                    item.BrokerId = brokerIdMap?.key;
                    item.BrokerName = brokerIdMap?.text;
                }
            })
            sessionStorage.setItem('endorsementRowData', JSON.stringify(filteredArrayData))
            if (shouldCallApi) {
                await CsrSaveHistoryApiCall(sheetType, props?.selectedJob, sessionStorage.getItem("csrAuthUserName"), JSON.stringify(filteredArrayData), brokerId, isAutoUpdate);
            }
        }
    }

    const UpdateJobPreviewStatusCall = async () => {
        const response = await UpdateJobPreviewStatus(jobId, token);
        await getCsrReviewData(jobId);
        container.current.showSnackbar('Status updated successfully', "info", true);
    }

    const UpdateJobSendPolicyInsuredCall = async () => {
        const response = await UpdateJobSendPolicyInsured(jobId, token);
        await getCsrReviewData(jobId);
        container.current.showSnackbar('Status updated successfully', "info", true);
    }

    const DownloadConsolidatedXray = async (sheetName) => {
        document.body.classList.add('loading-indicator');
        let category = sheetName == "CSR Pro" ? "Summary"
                : sheetName == "Summary Checklist" ? "Policy"
                : sheetName == "Forms Compare" ? "FormsCompare"
                : sheetName == "Exclusions" ? "Exclusions"
                : sheetName;
        try {
            const Token = await processAndUpdateToken(token);
            const headers = {
                'Authorization': `Bearer ${Token}`,
                "Content-Type": "application/json",
            };
            const Url = `${baseUrl}/api/XrayPDFSnippet/GetPdfbyCategory/GetPdf?jobId=${jobId}&category=${category}`;
            const response = await axios.get(Url, {
                headers,
                responseType: 'blob',
            });

            if (response.status !== 200) {
                return "error";
            }

            // const ChecklistfilenameFromHeader = response.headers['x-checklist-filename'];
            const ChecklistFileName = `${jobId}_${category}.pdf`;

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', ChecklistFileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error("ChecklistGenrator error", error);
            return "error";
        }
        finally {
            document.body.classList.remove('loading-indicator');
        }
    }

    const isPreviewCompleted = reviewData?.length > 0 && reviewData[0]?.IsPreviewCompleted;
    const isGridspiCompleted = sendPolicyInsuredData?.length > 0 && sendPolicyInsuredData[0]?.IsGridspiCompleted;

    useEffect(() => {
        // checkUserAndShowDialog();
    }, [activeUserName, sessionUserName]);

    // Update summaryReviewChecklistData when props change
    // useEffect(() => {
    //     if (props?.summaryReviewChecklistData) {
    //         console.log('SummaryReviewChecklist data received:', props.summaryReviewChecklistData);
    //         setSummaryReviewChecklistData(props.summaryReviewChecklistData);
    //     }
    // }, [props?.summaryReviewChecklistData]);

    const checkUserAndShowDialog = () => {
        if (activeUserName !== sessionUserName && activeUserName) {
            setOpenDialog(true);
            setMsgText(
                <span className="msg-text">
                    The checklist for this job is currently opened by{' '}
                    {activeUserName === "" ? " - " : activeUserName}.
                    You will not be able to edit or save any changes to the checklist.
                </span>
            );
        }
    };

    const handleDialogClose = (shouldNavigate) => {
        setOpenDialog(false);
        if (shouldNavigate) {
            navigate(-1); // Go to the previous page
        }
    };

    return (
        <div>
            <div >
                 { msgVisible &&
                <div className="alert-container">
                        <div className={ msgClass }>{ msgText }</div>
                    </div>
                }
                {/* {(activeUserName === sessionUserName || !activeUserName) ? ( // Show buttons only if users match and not SummaryReviewChecklist */}
                <div
                    // onClick={() => handleExportExcel()}
                    style={{ display: 'flex' }}>
                    {/* <PrimaryButton
                            disabled={endorsementColflag === "CSR Pro"}
                            onClick={() => {
                                onSaveClick(false); // Call onSaveClick with false to skip API call
                                ExportClick(true);   // Then trigger ExportClick
                            }} style={{
                                backgroundColor: endorsementColflag !== "CSR Pro" ? 'lightblue' : "#cccccc", height: '28px', borderRadius: '20px',
                                borderColor: 'black', fontSize: '12px', margin: '5px 5px 5px 5px', color: 'black'
                            }}>Export Checklist</PrimaryButton> */}
                    {/* { brokerId != "1003" || (endorsementColflag != "Forms Compare" && endorsementColflag != "Exclusion") ? ( <PrimaryButton onClick={() => onSaveClick()} style={{ */}

                    {/* {endorsementColflag !== "CSR Pro" && ( */}
                    <>
                        {AODDBrokerIds.includes(brokerId) || (endorsementColflag != FormsCompareSheetName && endorsementColflag != ExclusionSheetName) ? (
                            <PrimaryButton
                                disabled={endorsementColflag === "CSR Pro"}
                                onClick={() => onSaveClick(true, false)}
                                style={{ backgroundColor: endorsementColflag !== "CSR Pro" ? 'lightblue' : "#cccccc", height: '28px', borderRadius: '20px', borderColor: 'black', fontSize: '12px', margin: '5px 5px 5px 5px', color: 'black' }}
                            >Save</PrimaryButton>) : null
                        }
                        <PrimaryButton
                            // disabled={endorsementColflag === "CSR Pro"}
                            onClick={() => {
                                onSaveClick(false); // Call onSaveClick with false to skip API call
                                ExportClick(true);   // Then trigger ExportClick
                            }} style={{
                                backgroundColor: 'lightblue', height: '28px', borderRadius: '20px',
                                borderColor: 'black', fontSize: '12px', margin: '5px 5px 5px 5px', color: 'black'
                            }}>Export Checklist</PrimaryButton>
                        {/* { brokerId != "1003" || (endorsementColflag != FormsCompareSheetName && endorsementColflag != ExclusionSheetName) ? ( <PrimaryButton onClick={() => toggleYesDialog()} style={{ */}
                        {(((AODDBrokerIds.includes(brokerId) && endorsementColflag !== "QA Checklist" && endorsementColflag !== "ProposalExclusions") ||
                            (!AODDBrokerIds.includes(brokerId) && endorsementColflag !== FormsCompareSheetName && endorsementColflag !== ExclusionSheetName &&  
                                endorsementColflag !== "QA Checklist")) && !reqEndorsementColHideBrokerId.includes(brokerId)) ? (
                            <PrimaryButton disabled={endorsementColflag === "CSR Pro"} onClick={() => toggleYesDialog()} style={{
                                backgroundColor: endorsementColflag !== "CSR Pro" ? 'lightblue' : "#cccccc", height: '28px', borderRadius: '20px',
                                borderColor: 'black', fontSize: '12px', margin: '5px 5px 5px 5px', color: 'black'
                            }}>Generate Endorsement Template</PrimaryButton>) : null
                        }
                        {(endorsementColflag !== "QA Checklist") ? <PrimaryButton disabled={endorsementColflag === "CSR Pro"}
                            onClick={() => UpdateJobPreviewStatusCall()} style={{
                                backgroundColor: isPreviewCompleted ? '#22bb33' : endorsementColflag !== "CSR Pro" ? 'lightblue' : "#cccccc", height: '28px', borderRadius: '20px',
                                borderColor: 'black', fontSize: '12px', margin: '5px 5px 5px 5px', color: 'black'
                            }}>Review Completed</PrimaryButton> : null}
                        {['1003', '1165']?.includes(brokerId) && (endorsementColflag !== "QA Checklist") ? <PrimaryButton disabled={endorsementColflag === "CSR Pro"}
                            onClick={() => UpdateJobSendPolicyInsuredCall()} style={{
                                backgroundColor: isGridspiCompleted ? '#22bb33' : endorsementColflag !== "CSR Pro" ? 'lightblue' : "#cccccc", height: '28px', borderRadius: '20px',
                                borderColor: 'black', fontSize: '12px', margin: '5px 5px 5px 5px', color: 'black'
                            }}>Send Policy To Insured</PrimaryButton> : null}
                        {endorsementColflag !== ExclusionSheetName &&
                                endorsementColflag !== "ProposalExclusions" && (
                            <PrimaryButton
                            onClick={() => DownloadConsolidatedXray(luckysheet?.getSheet()?.name)} style={{
                                backgroundColor: 'lightblue', height: '28px', borderRadius: '20px',
                                borderColor: 'black', fontSize: '12px', margin: '5px 5px 5px 5px', color: 'black'
                            }}> Consolidated xray</PrimaryButton>)}
                    </>
                    {/* )} */}

                    {/* <Icon iconName="Filter" onClick={handleIconClick} style={{ fontSize: '20px', margin: '5px', cursor: 'pointer' }}/> */}

                </div>
                {/* ) : null} */}

                {openDialog && (<DialogComponent isOpen={openDialog} onClose={handleDialogClose} message={msgText} />)}
                {yesDialog && <EndorsementDialogComponent isOpen={yesDialog} luckySheet={luckysheet} state={csrPolicyData} formState={formsComparedata} redSheetData={gradtionData} sheetState={sheetState} tableColumnDetails={tableColumnDetails} formTableColumnDetails={formTableColumnDetails} exTableColumnDetails={exTableColumnDetails} dataForXRayMapping={dataForXRayMapping} formdataForXRayMapping={formdataForXRayMapping} exclusiondataForXRayMapping={exclusiondataForXRayMapping} redSheetDataForXRayMapping={sessionStorage.getItem('redSheetData')} greenSheetDataForXRayMapping={sessionStorage.getItem('greenSheetData')} onClose={(e) => handleYesDailog(e)} />}
                {dropDialog && < DiscrepancyOptionsDialogComponent isOpen={dropDialog} luckySheet={luckysheet} state={csrPolicyData} jobId={jobId} onClose={(e) => funForDiscrepancyCol(e)} message={"Action On Descrepancy (from AMs)"} />}
                {dropProposalExDialog && < DiscrepancyOptionsDialogComponent isOpen={dropProposalExDialog} luckySheet={luckysheet} jobId={jobId} onClose={(e) => funForDiscrepancyCol(e)} message={"Action On Descrepancy (from AMs)"} />}
                {gradiationDialog && < DiscrepancyOptionsDialogComponent isOpen={gradiationDialog} luckySheet={luckysheet} state={csrPolicyData} jobId={jobId} onClose={(e) => funForDiscrepancyCol(e)} message={"Action On Descrepancy (from AMs)"} />}
                {openFilterDialog && <FilterCsrDialogComponent isOpen={{ openFilterDialog, tableColumnDetails, props, luckysheet, filterSelectionData }} onClose={(e) => handleFilterDialogClose(e)} />}
            </div>
            <div style={{ position: 'relative' }}>
                {!reqEndorsementColHideBrokerId.includes(brokerId) && (endorsementColflag !== "QA Checklist") && (endorsementColflag !== "CSR Pro" && endorsementColflag !== "Forms Compare" && endorsementColflag !== "ProposalExclusions" && endorsementColflag !== "Exclusions") ? (<Icon iconName="Filter" onClick={handleIconClick} style={{
                    position: 'absolute',
                    top: '2px',
                    right: '-470px',
                    fontSize: '16.2px',
                    margin: '5px',
                    zIndex: 10,
                    cursor: 'pointer'
                }} />) : null}
                {!reqEndorsementColHideBrokerId.includes(brokerId) && (endorsementColflag !== "QA Checklist") && (endorsementColflag !== "CSR Pro" && endorsementColflag !== "Forms Compare" && endorsementColflag !== "ProposalExclusions" && endorsementColflag !== "Exclusions") ? (<h6 style={{
                    position: 'absolute',
                    top: '5px',
                    fontWeight: 500,
                    right: '-500px',
                    fontSize: '12.5px',
                    margin: '5px',
                    zIndex: 10,
                    cursor: 'pointer'
                }} onClick={handleIconClick} >Filter</h6>
                ) : null}
                <div className="csrSheet" id="luckysheet2" ref={luckyCss} ></div>

            </div>

            <SimpleSnackbar ref={container} />
        </div>
    );
}
